import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';

var isClientSide = function () {
  return typeof window !== "undefined";
};
var isString = function (str) {
  return Object.prototype.toString.call(str) === "[object String]";
};
var isExternalLink = function (url) {
  return url.includes("//");
};
var oneLineHelpScout = function (str) {
  return !isString(str) ? "" : str.replace("Help Scout", "Help&nbsp;Scout");
};
// tiny port of classnames module
// accepts an object like: `{ "class-one": var === condition, "class-two": var === conditional2 }`
// and returns: `class-one class-two` / `class-two` / etc.
var generateConditionalClassName = function (classNames) {
  return Object.keys(classNames).reduce(function (acc, className) {
    return "".concat(acc).concat(classNames[className] ? " ".concat(className) : "");
  }, "");
};
var convertStringToKebabCase = function (str) {
  if (!isString(str) || str.length === 0) return "";
  var matches = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);
  if (!matches) return "";
  return matches.map(function (x) {
    return x.toLowerCase();
  }).join("-");
};

var BADGE_COLORS;
(function (BADGE_COLORS) {
  BADGE_COLORS["CHARCOAL"] = "CHARCOAL";
  BADGE_COLORS["CHARCOAL_TINT"] = "CHARCOAL_TINT";
  BADGE_COLORS["CLAY"] = "CLAY";
  BADGE_COLORS["CLAY_TINT"] = "CLAY_TINT";
  BADGE_COLORS["COBALT"] = "COBALT";
  BADGE_COLORS["GREEN"] = "GREEN";
  BADGE_COLORS["MAGENTA"] = "MAGENTA";
  BADGE_COLORS["ORANGE"] = "ORANGE";
  BADGE_COLORS["PURPLE"] = "PURPLE";
  BADGE_COLORS["RED"] = "RED";
  BADGE_COLORS["SLATE"] = "SLATE";
  BADGE_COLORS["SLATE_TINT"] = "SLATE_TINT";
  BADGE_COLORS["YELLOW"] = "YELLOW";
})(BADGE_COLORS || (BADGE_COLORS = {}));
var BADGE_SIZES;
(function (BADGE_SIZES) {
  BADGE_SIZES["XS"] = "XS";
  BADGE_SIZES["S"] = "S";
  BADGE_SIZES["M"] = "M";
})(BADGE_SIZES || (BADGE_SIZES = {}));
var BADGE_BACKGROUND_COLOR_MAP = {
  CHARCOAL: "background-color--charcoal-700",
  CHARCOAL_TINT: "background-color--charcoal-200",
  CLAY: "background-color--clay-700",
  CLAY_TINT: "background-color--clay-200",
  COBALT: "background-color--cobalt-700",
  GREEN: "background-color--green-600",
  MAGENTA: "background-color--magenta-500",
  ORANGE: "background-color--orange-600",
  PURPLE: "background-color--purple-600",
  RED: "background-color--red-600",
  SLATE: "background-color--slate-600",
  SLATE_TINT: "background-color--slate-200",
  YELLOW: "background-color--yellow-600"
};
var BADGE_INVERTED_BORDER_COLOR_MAP = {
  CHARCOAL: "var(--color--charcoal-400)",
  CHARCOAL_TINT: "var(--color--charcoal-300)",
  CLAY: "var(--color--clay-400)",
  CLAY_TINT: "var(--color--clay-300)",
  COBALT: "var(--color--cobalt-300)",
  GREEN: "var(--color--green-300)",
  MAGENTA: "var(--color--magenta-300)",
  ORANGE: "var(--color--orange-300)",
  PURPLE: "var(--color--purple-300)",
  RED: "var(--color--red-300)",
  SLATE: "var(--color--slate-300)",
  SLATE_TINT: "var(--color--slate-300)",
  YELLOW: "var(--color--yellow-300)"
};
var BADGE_INVERTED_COLOR_MAP = {
  CHARCOAL: "color--text-default",
  CHARCOAL_TINT: "color--text-light",
  CLAY: "color--text-default",
  CLAY_TINT: "color--text-light",
  COBALT: "color--cobalt-700",
  GREEN: "color--green-700",
  MAGENTA: "color--magenta-700",
  ORANGE: "color--orange-700",
  PURPLE: "color--purple-700",
  RED: "color--red-700",
  SLATE: "color--slate-600",
  SLATE_TINT: "color--text-light",
  YELLOW: "color--yellow-700"
};
var Badge = function (_a) {
  var _b;
  var children = _a.children,
    className = _a.className,
    _c = _a.color,
    color = _c === void 0 ? BADGE_COLORS.CLAY_TINT : _c,
    isInverted = _a.isInverted,
    _d = _a.size,
    size = _d === void 0 ? BADGE_SIZES.M : _d,
    useMonoFont = _a.useMonoFont;
  var isTint = color.includes("TINT");
  return jsx("span", {
    className: generateConditionalClassName((_b = {
      Badge: true
    }, _b["".concat(BADGE_INVERTED_COLOR_MAP[color])] = !!isInverted, _b["".concat(className)] = !!className, _b["".concat(isInverted ? "" : BADGE_BACKGROUND_COLOR_MAP[color])] = true, _b["color--basics-white"] = !isInverted && !isTint, _b["color--text-default"] = !isInverted && isTint, _b["font-family--mono"] = size === BADGE_SIZES.M && !!useMonoFont, _b["font-family--sans-brand"] = size === BADGE_SIZES.XS, _b["font-family--sans"] = [BADGE_SIZES.S, BADGE_SIZES.M].includes(size) && !useMonoFont, _b["is-inverted"] = !!isInverted, _b["size--".concat(size)] = true, _b)),
    style: {
      boxShadow: isInverted ? "0 0 0 1px ".concat(BADGE_INVERTED_BORDER_COLOR_MAP[color]) : undefined
    },
    children: children
  });
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var lib$1 = {exports: {}};

var _default$1 = {};

var lib = {exports: {}};

var _default = {};

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

function getDefaultWhiteList$1 () {
  // 白名单值说明：
  // true: 允许该属性
  // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
  // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
  // 除上面列出的值外均表示不允许
  var whiteList = {};

  whiteList['align-content'] = false; // default: auto
  whiteList['align-items'] = false; // default: auto
  whiteList['align-self'] = false; // default: auto
  whiteList['alignment-adjust'] = false; // default: auto
  whiteList['alignment-baseline'] = false; // default: baseline
  whiteList['all'] = false; // default: depending on individual properties
  whiteList['anchor-point'] = false; // default: none
  whiteList['animation'] = false; // default: depending on individual properties
  whiteList['animation-delay'] = false; // default: 0
  whiteList['animation-direction'] = false; // default: normal
  whiteList['animation-duration'] = false; // default: 0
  whiteList['animation-fill-mode'] = false; // default: none
  whiteList['animation-iteration-count'] = false; // default: 1
  whiteList['animation-name'] = false; // default: none
  whiteList['animation-play-state'] = false; // default: running
  whiteList['animation-timing-function'] = false; // default: ease
  whiteList['azimuth'] = false; // default: center
  whiteList['backface-visibility'] = false; // default: visible
  whiteList['background'] = true; // default: depending on individual properties
  whiteList['background-attachment'] = true; // default: scroll
  whiteList['background-clip'] = true; // default: border-box
  whiteList['background-color'] = true; // default: transparent
  whiteList['background-image'] = true; // default: none
  whiteList['background-origin'] = true; // default: padding-box
  whiteList['background-position'] = true; // default: 0% 0%
  whiteList['background-repeat'] = true; // default: repeat
  whiteList['background-size'] = true; // default: auto
  whiteList['baseline-shift'] = false; // default: baseline
  whiteList['binding'] = false; // default: none
  whiteList['bleed'] = false; // default: 6pt
  whiteList['bookmark-label'] = false; // default: content()
  whiteList['bookmark-level'] = false; // default: none
  whiteList['bookmark-state'] = false; // default: open
  whiteList['border'] = true; // default: depending on individual properties
  whiteList['border-bottom'] = true; // default: depending on individual properties
  whiteList['border-bottom-color'] = true; // default: current color
  whiteList['border-bottom-left-radius'] = true; // default: 0
  whiteList['border-bottom-right-radius'] = true; // default: 0
  whiteList['border-bottom-style'] = true; // default: none
  whiteList['border-bottom-width'] = true; // default: medium
  whiteList['border-collapse'] = true; // default: separate
  whiteList['border-color'] = true; // default: depending on individual properties
  whiteList['border-image'] = true; // default: none
  whiteList['border-image-outset'] = true; // default: 0
  whiteList['border-image-repeat'] = true; // default: stretch
  whiteList['border-image-slice'] = true; // default: 100%
  whiteList['border-image-source'] = true; // default: none
  whiteList['border-image-width'] = true; // default: 1
  whiteList['border-left'] = true; // default: depending on individual properties
  whiteList['border-left-color'] = true; // default: current color
  whiteList['border-left-style'] = true; // default: none
  whiteList['border-left-width'] = true; // default: medium
  whiteList['border-radius'] = true; // default: 0
  whiteList['border-right'] = true; // default: depending on individual properties
  whiteList['border-right-color'] = true; // default: current color
  whiteList['border-right-style'] = true; // default: none
  whiteList['border-right-width'] = true; // default: medium
  whiteList['border-spacing'] = true; // default: 0
  whiteList['border-style'] = true; // default: depending on individual properties
  whiteList['border-top'] = true; // default: depending on individual properties
  whiteList['border-top-color'] = true; // default: current color
  whiteList['border-top-left-radius'] = true; // default: 0
  whiteList['border-top-right-radius'] = true; // default: 0
  whiteList['border-top-style'] = true; // default: none
  whiteList['border-top-width'] = true; // default: medium
  whiteList['border-width'] = true; // default: depending on individual properties
  whiteList['bottom'] = false; // default: auto
  whiteList['box-decoration-break'] = true; // default: slice
  whiteList['box-shadow'] = true; // default: none
  whiteList['box-sizing'] = true; // default: content-box
  whiteList['box-snap'] = true; // default: none
  whiteList['box-suppress'] = true; // default: show
  whiteList['break-after'] = true; // default: auto
  whiteList['break-before'] = true; // default: auto
  whiteList['break-inside'] = true; // default: auto
  whiteList['caption-side'] = false; // default: top
  whiteList['chains'] = false; // default: none
  whiteList['clear'] = true; // default: none
  whiteList['clip'] = false; // default: auto
  whiteList['clip-path'] = false; // default: none
  whiteList['clip-rule'] = false; // default: nonzero
  whiteList['color'] = true; // default: implementation dependent
  whiteList['color-interpolation-filters'] = true; // default: auto
  whiteList['column-count'] = false; // default: auto
  whiteList['column-fill'] = false; // default: balance
  whiteList['column-gap'] = false; // default: normal
  whiteList['column-rule'] = false; // default: depending on individual properties
  whiteList['column-rule-color'] = false; // default: current color
  whiteList['column-rule-style'] = false; // default: medium
  whiteList['column-rule-width'] = false; // default: medium
  whiteList['column-span'] = false; // default: none
  whiteList['column-width'] = false; // default: auto
  whiteList['columns'] = false; // default: depending on individual properties
  whiteList['contain'] = false; // default: none
  whiteList['content'] = false; // default: normal
  whiteList['counter-increment'] = false; // default: none
  whiteList['counter-reset'] = false; // default: none
  whiteList['counter-set'] = false; // default: none
  whiteList['crop'] = false; // default: auto
  whiteList['cue'] = false; // default: depending on individual properties
  whiteList['cue-after'] = false; // default: none
  whiteList['cue-before'] = false; // default: none
  whiteList['cursor'] = false; // default: auto
  whiteList['direction'] = false; // default: ltr
  whiteList['display'] = true; // default: depending on individual properties
  whiteList['display-inside'] = true; // default: auto
  whiteList['display-list'] = true; // default: none
  whiteList['display-outside'] = true; // default: inline-level
  whiteList['dominant-baseline'] = false; // default: auto
  whiteList['elevation'] = false; // default: level
  whiteList['empty-cells'] = false; // default: show
  whiteList['filter'] = false; // default: none
  whiteList['flex'] = false; // default: depending on individual properties
  whiteList['flex-basis'] = false; // default: auto
  whiteList['flex-direction'] = false; // default: row
  whiteList['flex-flow'] = false; // default: depending on individual properties
  whiteList['flex-grow'] = false; // default: 0
  whiteList['flex-shrink'] = false; // default: 1
  whiteList['flex-wrap'] = false; // default: nowrap
  whiteList['float'] = false; // default: none
  whiteList['float-offset'] = false; // default: 0 0
  whiteList['flood-color'] = false; // default: black
  whiteList['flood-opacity'] = false; // default: 1
  whiteList['flow-from'] = false; // default: none
  whiteList['flow-into'] = false; // default: none
  whiteList['font'] = true; // default: depending on individual properties
  whiteList['font-family'] = true; // default: implementation dependent
  whiteList['font-feature-settings'] = true; // default: normal
  whiteList['font-kerning'] = true; // default: auto
  whiteList['font-language-override'] = true; // default: normal
  whiteList['font-size'] = true; // default: medium
  whiteList['font-size-adjust'] = true; // default: none
  whiteList['font-stretch'] = true; // default: normal
  whiteList['font-style'] = true; // default: normal
  whiteList['font-synthesis'] = true; // default: weight style
  whiteList['font-variant'] = true; // default: normal
  whiteList['font-variant-alternates'] = true; // default: normal
  whiteList['font-variant-caps'] = true; // default: normal
  whiteList['font-variant-east-asian'] = true; // default: normal
  whiteList['font-variant-ligatures'] = true; // default: normal
  whiteList['font-variant-numeric'] = true; // default: normal
  whiteList['font-variant-position'] = true; // default: normal
  whiteList['font-weight'] = true; // default: normal
  whiteList['grid'] = false; // default: depending on individual properties
  whiteList['grid-area'] = false; // default: depending on individual properties
  whiteList['grid-auto-columns'] = false; // default: auto
  whiteList['grid-auto-flow'] = false; // default: none
  whiteList['grid-auto-rows'] = false; // default: auto
  whiteList['grid-column'] = false; // default: depending on individual properties
  whiteList['grid-column-end'] = false; // default: auto
  whiteList['grid-column-start'] = false; // default: auto
  whiteList['grid-row'] = false; // default: depending on individual properties
  whiteList['grid-row-end'] = false; // default: auto
  whiteList['grid-row-start'] = false; // default: auto
  whiteList['grid-template'] = false; // default: depending on individual properties
  whiteList['grid-template-areas'] = false; // default: none
  whiteList['grid-template-columns'] = false; // default: none
  whiteList['grid-template-rows'] = false; // default: none
  whiteList['hanging-punctuation'] = false; // default: none
  whiteList['height'] = true; // default: auto
  whiteList['hyphens'] = false; // default: manual
  whiteList['icon'] = false; // default: auto
  whiteList['image-orientation'] = false; // default: auto
  whiteList['image-resolution'] = false; // default: normal
  whiteList['ime-mode'] = false; // default: auto
  whiteList['initial-letters'] = false; // default: normal
  whiteList['inline-box-align'] = false; // default: last
  whiteList['justify-content'] = false; // default: auto
  whiteList['justify-items'] = false; // default: auto
  whiteList['justify-self'] = false; // default: auto
  whiteList['left'] = false; // default: auto
  whiteList['letter-spacing'] = true; // default: normal
  whiteList['lighting-color'] = true; // default: white
  whiteList['line-box-contain'] = false; // default: block inline replaced
  whiteList['line-break'] = false; // default: auto
  whiteList['line-grid'] = false; // default: match-parent
  whiteList['line-height'] = false; // default: normal
  whiteList['line-snap'] = false; // default: none
  whiteList['line-stacking'] = false; // default: depending on individual properties
  whiteList['line-stacking-ruby'] = false; // default: exclude-ruby
  whiteList['line-stacking-shift'] = false; // default: consider-shifts
  whiteList['line-stacking-strategy'] = false; // default: inline-line-height
  whiteList['list-style'] = true; // default: depending on individual properties
  whiteList['list-style-image'] = true; // default: none
  whiteList['list-style-position'] = true; // default: outside
  whiteList['list-style-type'] = true; // default: disc
  whiteList['margin'] = true; // default: depending on individual properties
  whiteList['margin-bottom'] = true; // default: 0
  whiteList['margin-left'] = true; // default: 0
  whiteList['margin-right'] = true; // default: 0
  whiteList['margin-top'] = true; // default: 0
  whiteList['marker-offset'] = false; // default: auto
  whiteList['marker-side'] = false; // default: list-item
  whiteList['marks'] = false; // default: none
  whiteList['mask'] = false; // default: border-box
  whiteList['mask-box'] = false; // default: see individual properties
  whiteList['mask-box-outset'] = false; // default: 0
  whiteList['mask-box-repeat'] = false; // default: stretch
  whiteList['mask-box-slice'] = false; // default: 0 fill
  whiteList['mask-box-source'] = false; // default: none
  whiteList['mask-box-width'] = false; // default: auto
  whiteList['mask-clip'] = false; // default: border-box
  whiteList['mask-image'] = false; // default: none
  whiteList['mask-origin'] = false; // default: border-box
  whiteList['mask-position'] = false; // default: center
  whiteList['mask-repeat'] = false; // default: no-repeat
  whiteList['mask-size'] = false; // default: border-box
  whiteList['mask-source-type'] = false; // default: auto
  whiteList['mask-type'] = false; // default: luminance
  whiteList['max-height'] = true; // default: none
  whiteList['max-lines'] = false; // default: none
  whiteList['max-width'] = true; // default: none
  whiteList['min-height'] = true; // default: 0
  whiteList['min-width'] = true; // default: 0
  whiteList['move-to'] = false; // default: normal
  whiteList['nav-down'] = false; // default: auto
  whiteList['nav-index'] = false; // default: auto
  whiteList['nav-left'] = false; // default: auto
  whiteList['nav-right'] = false; // default: auto
  whiteList['nav-up'] = false; // default: auto
  whiteList['object-fit'] = false; // default: fill
  whiteList['object-position'] = false; // default: 50% 50%
  whiteList['opacity'] = false; // default: 1
  whiteList['order'] = false; // default: 0
  whiteList['orphans'] = false; // default: 2
  whiteList['outline'] = false; // default: depending on individual properties
  whiteList['outline-color'] = false; // default: invert
  whiteList['outline-offset'] = false; // default: 0
  whiteList['outline-style'] = false; // default: none
  whiteList['outline-width'] = false; // default: medium
  whiteList['overflow'] = false; // default: depending on individual properties
  whiteList['overflow-wrap'] = false; // default: normal
  whiteList['overflow-x'] = false; // default: visible
  whiteList['overflow-y'] = false; // default: visible
  whiteList['padding'] = true; // default: depending on individual properties
  whiteList['padding-bottom'] = true; // default: 0
  whiteList['padding-left'] = true; // default: 0
  whiteList['padding-right'] = true; // default: 0
  whiteList['padding-top'] = true; // default: 0
  whiteList['page'] = false; // default: auto
  whiteList['page-break-after'] = false; // default: auto
  whiteList['page-break-before'] = false; // default: auto
  whiteList['page-break-inside'] = false; // default: auto
  whiteList['page-policy'] = false; // default: start
  whiteList['pause'] = false; // default: implementation dependent
  whiteList['pause-after'] = false; // default: implementation dependent
  whiteList['pause-before'] = false; // default: implementation dependent
  whiteList['perspective'] = false; // default: none
  whiteList['perspective-origin'] = false; // default: 50% 50%
  whiteList['pitch'] = false; // default: medium
  whiteList['pitch-range'] = false; // default: 50
  whiteList['play-during'] = false; // default: auto
  whiteList['position'] = false; // default: static
  whiteList['presentation-level'] = false; // default: 0
  whiteList['quotes'] = false; // default: text
  whiteList['region-fragment'] = false; // default: auto
  whiteList['resize'] = false; // default: none
  whiteList['rest'] = false; // default: depending on individual properties
  whiteList['rest-after'] = false; // default: none
  whiteList['rest-before'] = false; // default: none
  whiteList['richness'] = false; // default: 50
  whiteList['right'] = false; // default: auto
  whiteList['rotation'] = false; // default: 0
  whiteList['rotation-point'] = false; // default: 50% 50%
  whiteList['ruby-align'] = false; // default: auto
  whiteList['ruby-merge'] = false; // default: separate
  whiteList['ruby-position'] = false; // default: before
  whiteList['shape-image-threshold'] = false; // default: 0.0
  whiteList['shape-outside'] = false; // default: none
  whiteList['shape-margin'] = false; // default: 0
  whiteList['size'] = false; // default: auto
  whiteList['speak'] = false; // default: auto
  whiteList['speak-as'] = false; // default: normal
  whiteList['speak-header'] = false; // default: once
  whiteList['speak-numeral'] = false; // default: continuous
  whiteList['speak-punctuation'] = false; // default: none
  whiteList['speech-rate'] = false; // default: medium
  whiteList['stress'] = false; // default: 50
  whiteList['string-set'] = false; // default: none
  whiteList['tab-size'] = false; // default: 8
  whiteList['table-layout'] = false; // default: auto
  whiteList['text-align'] = true; // default: start
  whiteList['text-align-last'] = true; // default: auto
  whiteList['text-combine-upright'] = true; // default: none
  whiteList['text-decoration'] = true; // default: none
  whiteList['text-decoration-color'] = true; // default: currentColor
  whiteList['text-decoration-line'] = true; // default: none
  whiteList['text-decoration-skip'] = true; // default: objects
  whiteList['text-decoration-style'] = true; // default: solid
  whiteList['text-emphasis'] = true; // default: depending on individual properties
  whiteList['text-emphasis-color'] = true; // default: currentColor
  whiteList['text-emphasis-position'] = true; // default: over right
  whiteList['text-emphasis-style'] = true; // default: none
  whiteList['text-height'] = true; // default: auto
  whiteList['text-indent'] = true; // default: 0
  whiteList['text-justify'] = true; // default: auto
  whiteList['text-orientation'] = true; // default: mixed
  whiteList['text-overflow'] = true; // default: clip
  whiteList['text-shadow'] = true; // default: none
  whiteList['text-space-collapse'] = true; // default: collapse
  whiteList['text-transform'] = true; // default: none
  whiteList['text-underline-position'] = true; // default: auto
  whiteList['text-wrap'] = true; // default: normal
  whiteList['top'] = false; // default: auto
  whiteList['transform'] = false; // default: none
  whiteList['transform-origin'] = false; // default: 50% 50% 0
  whiteList['transform-style'] = false; // default: flat
  whiteList['transition'] = false; // default: depending on individual properties
  whiteList['transition-delay'] = false; // default: 0s
  whiteList['transition-duration'] = false; // default: 0s
  whiteList['transition-property'] = false; // default: all
  whiteList['transition-timing-function'] = false; // default: ease
  whiteList['unicode-bidi'] = false; // default: normal
  whiteList['vertical-align'] = false; // default: baseline
  whiteList['visibility'] = false; // default: visible
  whiteList['voice-balance'] = false; // default: center
  whiteList['voice-duration'] = false; // default: auto
  whiteList['voice-family'] = false; // default: implementation dependent
  whiteList['voice-pitch'] = false; // default: medium
  whiteList['voice-range'] = false; // default: medium
  whiteList['voice-rate'] = false; // default: normal
  whiteList['voice-stress'] = false; // default: normal
  whiteList['voice-volume'] = false; // default: medium
  whiteList['volume'] = false; // default: medium
  whiteList['white-space'] = false; // default: normal
  whiteList['widows'] = false; // default: 2
  whiteList['width'] = true; // default: auto
  whiteList['will-change'] = false; // default: auto
  whiteList['word-break'] = true; // default: normal
  whiteList['word-spacing'] = true; // default: normal
  whiteList['word-wrap'] = true; // default: normal
  whiteList['wrap-flow'] = false; // default: auto
  whiteList['wrap-through'] = false; // default: wrap
  whiteList['writing-mode'] = false; // default: horizontal-tb
  whiteList['z-index'] = false; // default: auto

  return whiteList;
}


/**
 * 匹配到白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onAttr (name, value, options) {
  // do nothing
}

/**
 * 匹配到不在白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onIgnoreAttr (name, value, options) {
  // do nothing
}

var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;

/**
 * 过滤属性值
 *
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function safeAttrValue$1(name, value) {
  if (REGEXP_URL_JAVASCRIPT.test(value)) return '';
  return value;
}


_default.whiteList = getDefaultWhiteList$1();
_default.getDefaultWhiteList = getDefaultWhiteList$1;
_default.onAttr = onAttr;
_default.onIgnoreAttr = onIgnoreAttr;
_default.safeAttrValue = safeAttrValue$1;

var util$1 = {
  indexOf: function (arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function (arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function (str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, '');
  },
  trimRight: function (str) {
    if (String.prototype.trimRight) {
      return str.trimRight();
    }
    return str.replace(/(\s*$)/g, '');
  }
};

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var _$3 = util$1;


/**
 * 解析style
 *
 * @param {String} css
 * @param {Function} onAttr 处理属性的函数
 *   参数格式： function (sourcePosition, position, name, value, source)
 * @return {String}
 */
function parseStyle$1 (css, onAttr) {
  css = _$3.trimRight(css);
  if (css[css.length - 1] !== ';') css += ';';
  var cssLength = css.length;
  var isParenthesisOpen = false;
  var lastPos = 0;
  var i = 0;
  var retCSS = '';

  function addNewAttr () {
    // 如果没有正常的闭合圆括号，则直接忽略当前属性
    if (!isParenthesisOpen) {
      var source = _$3.trim(css.slice(lastPos, i));
      var j = source.indexOf(':');
      if (j !== -1) {
        var name = _$3.trim(source.slice(0, j));
        var value = _$3.trim(source.slice(j + 1));
        // 必须有属性名称
        if (name) {
          var ret = onAttr(lastPos, retCSS.length, name, value, source);
          if (ret) retCSS += ret + '; ';
        }
      }
    }
    lastPos = i + 1;
  }

  for (; i < cssLength; i++) {
    var c = css[i];
    if (c === '/' && css[i + 1] === '*') {
      // 备注开始
      var j = css.indexOf('*/', i + 2);
      // 如果没有正常的备注结束，则后面的部分全部跳过
      if (j === -1) break;
      // 直接将当前位置调到备注结尾，并且初始化状态
      i = j + 1;
      lastPos = i + 1;
      isParenthesisOpen = false;
    } else if (c === '(') {
      isParenthesisOpen = true;
    } else if (c === ')') {
      isParenthesisOpen = false;
    } else if (c === ';') {
      if (isParenthesisOpen) ; else {
        addNewAttr();
      }
    } else if (c === '\n') {
      addNewAttr();
    }
  }

  return _$3.trim(retCSS);
}

var parser$2 = parseStyle$1;

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var DEFAULT$1 = _default;
var parseStyle = parser$2;


/**
 * 返回值是否为空
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull$1 (obj) {
  return (obj === undefined || obj === null);
}

/**
 * 浅拷贝对象
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject$1 (obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

/**
 * 创建CSS过滤器
 *
 * @param {Object} options
 *   - {Object} whiteList
 *   - {Function} onAttr
 *   - {Function} onIgnoreAttr
 *   - {Function} safeAttrValue
 */
function FilterCSS$2 (options) {
  options = shallowCopyObject$1(options || {});
  options.whiteList = options.whiteList || DEFAULT$1.whiteList;
  options.onAttr = options.onAttr || DEFAULT$1.onAttr;
  options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT$1.onIgnoreAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT$1.safeAttrValue;
  this.options = options;
}

FilterCSS$2.prototype.process = function (css) {
  // 兼容各种奇葩输入
  css = css || '';
  css = css.toString();
  if (!css) return '';

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onAttr = options.onAttr;
  var onIgnoreAttr = options.onIgnoreAttr;
  var safeAttrValue = options.safeAttrValue;

  var retCSS = parseStyle(css, function (sourcePosition, position, name, value, source) {

    var check = whiteList[name];
    var isWhite = false;
    if (check === true) isWhite = check;
    else if (typeof check === 'function') isWhite = check(value);
    else if (check instanceof RegExp) isWhite = check.test(value);
    if (isWhite !== true) isWhite = false;

    // 如果过滤后 value 为空则直接忽略
    value = safeAttrValue(name, value);
    if (!value) return;

    var opts = {
      position: position,
      sourcePosition: sourcePosition,
      source: source,
      isWhite: isWhite
    };

    if (isWhite) {

      var ret = onAttr(name, value, opts);
      if (isNull$1(ret)) {
        return name + ':' + value;
      } else {
        return ret;
      }

    } else {

      var ret = onIgnoreAttr(name, value, opts);
      if (!isNull$1(ret)) {
        return ret;
      }

    }
  });

  return retCSS;
};


var css = FilterCSS$2;

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

(function (module, exports) {
	var DEFAULT = _default;
	var FilterCSS = css;


	/**
	 * XSS过滤
	 *
	 * @param {String} css 要过滤的CSS代码
	 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
	 * @return {String}
	 */
	function filterCSS (html, options) {
	  var xss = new FilterCSS(options);
	  return xss.process(html);
	}


	// 输出
	exports = module.exports = filterCSS;
	exports.FilterCSS = FilterCSS;
	for (var i in DEFAULT) exports[i] = DEFAULT[i];

	// 在浏览器端使用
	if (typeof window !== 'undefined') {
	  window.filterCSS = module.exports;
	} 
} (lib, lib.exports));

var libExports$1 = lib.exports;

var util = {
  indexOf: function (arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function (arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function (str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function (str) {
    var reg = /\s|\n|\t/;
    var match = reg.exec(str);
    return match ? match.index : -1;
  },
};

/**
 * default settings
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS$1 = libExports$1.FilterCSS;
var getDefaultCSSWhiteList = libExports$1.getDefaultWhiteList;
var _$2 = util;

function getDefaultWhiteList() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "preload",
      "src",
    ],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    figcaption: [],
    figure: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height", "loading"],
    ins: ["datetime"],
    kbd: [],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    summary: [],
    sup: [],
    strong: [],
    strike: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "playsinline",
      "poster",
      "preload",
      "src",
      "height",
      "width",
    ],
  };
}

var defaultCSSFilter = new FilterCSS$1();

/**
 * default onTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onTag(tag, html, options) {
  // do nothing
}

/**
 * default onIgnoreTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onIgnoreTag(tag, html, options) {
  // do nothing
}

/**
 * default onTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default onIgnoreTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onIgnoreTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default escapeHtml function
 *
 * @param {String} html
 */
function escapeHtml(html) {
  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
}

/**
 * default safeAttrValue function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @param {Object} cssFilter
 * @return {String}
 */
function safeAttrValue(tag, name, value, cssFilter) {
  // unescape attribute value firstly
  value = friendlyAttrValue(value);

  if (name === "href" || name === "src") {
    // filter `href` and `src` attribute
    // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
    value = _$2.trim(value);
    if (value === "#") return "#";
    if (
      !(
        value.substr(0, 7) === "http://" ||
        value.substr(0, 8) === "https://" ||
        value.substr(0, 7) === "mailto:" ||
        value.substr(0, 4) === "tel:" ||
        value.substr(0, 11) === "data:image/" ||
        value.substr(0, 6) === "ftp://" ||
        value.substr(0, 2) === "./" ||
        value.substr(0, 3) === "../" ||
        value[0] === "#" ||
        value[0] === "/"
      )
    ) {
      return "";
    }
  } else if (name === "background") {
    // filter `background` attribute (maybe no use)
    // `javascript:`
    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
      return "";
    }
  } else if (name === "style") {
    // `expression()`
    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
      return "";
    }
    // `url()`
    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
        return "";
      }
    }
    if (cssFilter !== false) {
      cssFilter = cssFilter || defaultCSSFilter;
      value = cssFilter.process(value);
    }
  }

  // escape `<>"` before returns
  value = escapeAttrValue(value);
  return value;
}

// RegExp list
var REGEXP_LT = /</g;
var REGEXP_GT = />/g;
var REGEXP_QUOTE = /"/g;
var REGEXP_QUOTE_2 = /&quot;/g;
var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
// var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
var REGEXP_DEFAULT_ON_TAG_ATTR_4 =
  /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_7 =
  /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;

/**
 * escape double quote
 *
 * @param {String} str
 * @return {String} str
 */
function escapeQuote(str) {
  return str.replace(REGEXP_QUOTE, "&quot;");
}

/**
 * unescape double quote
 *
 * @param {String} str
 * @return {String} str
 */
function unescapeQuote(str) {
  return str.replace(REGEXP_QUOTE_2, '"');
}

/**
 * escape html entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeHtmlEntities(str) {
  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
    return code[0] === "x" || code[0] === "X"
      ? String.fromCharCode(parseInt(code.substr(1), 16))
      : String.fromCharCode(parseInt(code, 10));
  });
}

/**
 * escape html5 new danger entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeDangerHtml5Entities(str) {
  return str
    .replace(REGEXP_ATTR_VALUE_COLON, ":")
    .replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
}

/**
 * clear nonprintable characters
 *
 * @param {String} str
 * @return {String}
 */
function clearNonPrintableCharacter(str) {
  var str2 = "";
  for (var i = 0, len = str.length; i < len; i++) {
    str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
  }
  return _$2.trim(str2);
}

/**
 * get friendly attribute value
 *
 * @param {String} str
 * @return {String}
 */
function friendlyAttrValue(str) {
  str = unescapeQuote(str);
  str = escapeHtmlEntities(str);
  str = escapeDangerHtml5Entities(str);
  str = clearNonPrintableCharacter(str);
  return str;
}

/**
 * unescape attribute value
 *
 * @param {String} str
 * @return {String}
 */
function escapeAttrValue(str) {
  str = escapeQuote(str);
  str = escapeHtml(str);
  return str;
}

/**
 * `onIgnoreTag` function for removing all the tags that are not in whitelist
 */
function onIgnoreTagStripAll() {
  return "";
}

/**
 * remove tag body
 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
 *
 * @param {array} tags
 * @param {function} next
 */
function StripTagBody(tags, next) {
  if (typeof next !== "function") {
    next = function () {};
  }

  var isRemoveAllTag = !Array.isArray(tags);
  function isRemoveTag(tag) {
    if (isRemoveAllTag) return true;
    return _$2.indexOf(tags, tag) !== -1;
  }

  var removeList = [];
  var posStart = false;

  return {
    onIgnoreTag: function (tag, html, options) {
      if (isRemoveTag(tag)) {
        if (options.isClosing) {
          var ret = "[/removed]";
          var end = options.position + ret.length;
          removeList.push([
            posStart !== false ? posStart : options.position,
            end,
          ]);
          posStart = false;
          return ret;
        } else {
          if (!posStart) {
            posStart = options.position;
          }
          return "[removed]";
        }
      } else {
        return next(tag, html, options);
      }
    },
    remove: function (html) {
      var rethtml = "";
      var lastPos = 0;
      _$2.forEach(removeList, function (pos) {
        rethtml += html.slice(lastPos, pos[0]);
        lastPos = pos[1];
      });
      rethtml += html.slice(lastPos);
      return rethtml;
    },
  };
}

/**
 * remove html comments
 *
 * @param {String} html
 * @return {String}
 */
function stripCommentTag(html) {
  var retHtml = "";
  var lastPos = 0;
  while (lastPos < html.length) {
    var i = html.indexOf("<!--", lastPos);
    if (i === -1) {
      retHtml += html.slice(lastPos);
      break;
    }
    retHtml += html.slice(lastPos, i);
    var j = html.indexOf("-->", i);
    if (j === -1) {
      break;
    }
    lastPos = j + 3;
  }
  return retHtml;
}

/**
 * remove invisible characters
 *
 * @param {String} html
 * @return {String}
 */
function stripBlankChar(html) {
  var chars = html.split("");
  chars = chars.filter(function (char) {
    var c = char.charCodeAt(0);
    if (c === 127) return false;
    if (c <= 31) {
      if (c === 10 || c === 13) return true;
      return false;
    }
    return true;
  });
  return chars.join("");
}

_default$1.whiteList = getDefaultWhiteList();
_default$1.getDefaultWhiteList = getDefaultWhiteList;
_default$1.onTag = onTag;
_default$1.onIgnoreTag = onIgnoreTag;
_default$1.onTagAttr = onTagAttr;
_default$1.onIgnoreTagAttr = onIgnoreTagAttr;
_default$1.safeAttrValue = safeAttrValue;
_default$1.escapeHtml = escapeHtml;
_default$1.escapeQuote = escapeQuote;
_default$1.unescapeQuote = unescapeQuote;
_default$1.escapeHtmlEntities = escapeHtmlEntities;
_default$1.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
_default$1.clearNonPrintableCharacter = clearNonPrintableCharacter;
_default$1.friendlyAttrValue = friendlyAttrValue;
_default$1.escapeAttrValue = escapeAttrValue;
_default$1.onIgnoreTagStripAll = onIgnoreTagStripAll;
_default$1.StripTagBody = StripTagBody;
_default$1.stripCommentTag = stripCommentTag;
_default$1.stripBlankChar = stripBlankChar;
_default$1.attributeWrapSign = '"';
_default$1.cssFilter = defaultCSSFilter;
_default$1.getDefaultCSSWhiteList = getDefaultCSSWhiteList;

var parser$1 = {};

/**
 * Simple HTML Parser
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var _$1 = util;

/**
 * get tag name
 *
 * @param {String} html e.g. '<a hef="#">'
 * @return {String}
 */
function getTagName(html) {
  var i = _$1.spaceIndex(html);
  var tagName;
  if (i === -1) {
    tagName = html.slice(1, -1);
  } else {
    tagName = html.slice(1, i + 1);
  }
  tagName = _$1.trim(tagName).toLowerCase();
  if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
  if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
  return tagName;
}

/**
 * is close tag?
 *
 * @param {String} html 如：'<a hef="#">'
 * @return {Boolean}
 */
function isClosing(html) {
  return html.slice(0, 2) === "</";
}

/**
 * parse input html and returns processed html
 *
 * @param {String} html
 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
 * @param {Function} escapeHtml
 * @return {String}
 */
function parseTag$1(html, onTag, escapeHtml) {

  var rethtml = "";
  var lastPos = 0;
  var tagStart = false;
  var quoteStart = false;
  var currentPos = 0;
  var len = html.length;
  var currentTagName = "";
  var currentHtml = "";

  chariterator: for (currentPos = 0; currentPos < len; currentPos++) {
    var c = html.charAt(currentPos);
    if (tagStart === false) {
      if (c === "<") {
        tagStart = currentPos;
        continue;
      }
    } else {
      if (quoteStart === false) {
        if (c === "<") {
          rethtml += escapeHtml(html.slice(lastPos, currentPos));
          tagStart = currentPos;
          lastPos = currentPos;
          continue;
        }
        if (c === ">" || currentPos === len - 1) {
          rethtml += escapeHtml(html.slice(lastPos, tagStart));
          currentHtml = html.slice(tagStart, currentPos + 1);
          currentTagName = getTagName(currentHtml);
          rethtml += onTag(
            tagStart,
            rethtml.length,
            currentTagName,
            currentHtml,
            isClosing(currentHtml)
          );
          lastPos = currentPos + 1;
          tagStart = false;
          continue;
        }
        if (c === '"' || c === "'") {
          var i = 1;
          var ic = html.charAt(currentPos - i);

          while (ic.trim() === "" || ic === "=") {
            if (ic === "=") {
              quoteStart = c;
              continue chariterator;
            }
            ic = html.charAt(currentPos - ++i);
          }
        }
      } else {
        if (c === quoteStart) {
          quoteStart = false;
          continue;
        }
      }
    }
  }
  if (lastPos < len) {
    rethtml += escapeHtml(html.substr(lastPos));
  }

  return rethtml;
}

var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9\\_:.-]/gim;

/**
 * parse input attributes and returns processed attributes
 *
 * @param {String} html e.g. `href="#" target="_blank"`
 * @param {Function} onAttr e.g. `function (name, value)`
 * @return {String}
 */
function parseAttr$1(html, onAttr) {

  var lastPos = 0;
  var lastMarkPos = 0;
  var retAttrs = [];
  var tmpName = false;
  var len = html.length;

  function addAttr(name, value) {
    name = _$1.trim(name);
    name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
    if (name.length < 1) return;
    var ret = onAttr(name, value || "");
    if (ret) retAttrs.push(ret);
  }

  // 逐个分析字符
  for (var i = 0; i < len; i++) {
    var c = html.charAt(i);
    var v, j;
    if (tmpName === false && c === "=") {
      tmpName = html.slice(lastPos, i);
      lastPos = i + 1;
      lastMarkPos = html.charAt(lastPos) === '"' || html.charAt(lastPos) === "'" ? lastPos : findNextQuotationMark(html, i + 1);
      continue;
    }
    if (tmpName !== false) {
      if (
        i === lastMarkPos
      ) {
        j = html.indexOf(c, i + 1);
        if (j === -1) {
          break;
        } else {
          v = _$1.trim(html.slice(lastMarkPos + 1, j));
          addAttr(tmpName, v);
          tmpName = false;
          i = j;
          lastPos = i + 1;
          continue;
        }
      }
    }
    if (/\s|\n|\t/.test(c)) {
      html = html.replace(/\s|\n|\t/g, " ");
      if (tmpName === false) {
        j = findNextEqual(html, i);
        if (j === -1) {
          v = _$1.trim(html.slice(lastPos, i));
          addAttr(v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          i = j - 1;
          continue;
        }
      } else {
        j = findBeforeEqual(html, i - 1);
        if (j === -1) {
          v = _$1.trim(html.slice(lastPos, i));
          v = stripQuoteWrap(v);
          addAttr(tmpName, v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          continue;
        }
      }
    }
  }

  if (lastPos < html.length) {
    if (tmpName === false) {
      addAttr(html.slice(lastPos));
    } else {
      addAttr(tmpName, stripQuoteWrap(_$1.trim(html.slice(lastPos))));
    }
  }

  return _$1.trim(retAttrs.join(" "));
}

function findNextEqual(str, i) {
  for (; i < str.length; i++) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function findNextQuotationMark(str, i) {
  for (; i < str.length; i++) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "'" || c === '"') return i;
    return -1;
  }
}

function findBeforeEqual(str, i) {
  for (; i > 0; i--) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function isQuoteWrapString(text) {
  if (
    (text[0] === '"' && text[text.length - 1] === '"') ||
    (text[0] === "'" && text[text.length - 1] === "'")
  ) {
    return true;
  } else {
    return false;
  }
}

function stripQuoteWrap(text) {
  if (isQuoteWrapString(text)) {
    return text.substr(1, text.length - 2);
  } else {
    return text;
  }
}

parser$1.parseTag = parseTag$1;
parser$1.parseAttr = parseAttr$1;

/**
 * filter xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS = libExports$1.FilterCSS;
var DEFAULT = _default$1;
var parser = parser$1;
var parseTag = parser.parseTag;
var parseAttr = parser.parseAttr;
var _ = util;

/**
 * returns `true` if the input value is `undefined` or `null`
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull(obj) {
  return obj === undefined || obj === null;
}

/**
 * get attributes for a tag
 *
 * @param {String} html
 * @return {Object}
 *   - {String} html
 *   - {Boolean} closing
 */
function getAttrs(html) {
  var i = _.spaceIndex(html);
  if (i === -1) {
    return {
      html: "",
      closing: html[html.length - 2] === "/",
    };
  }
  html = _.trim(html.slice(i + 1, -1));
  var isClosing = html[html.length - 1] === "/";
  if (isClosing) html = _.trim(html.slice(0, -1));
  return {
    html: html,
    closing: isClosing,
  };
}

/**
 * shallow copy
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject(obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

function keysToLowerCase(obj) {
  var ret = {};
  for (var i in obj) {
    if (Array.isArray(obj[i])) {
      ret[i.toLowerCase()] = obj[i].map(function (item) {
        return item.toLowerCase();
      });
    } else {
      ret[i.toLowerCase()] = obj[i];
    }
  }
  return ret;
}

/**
 * FilterXSS class
 *
 * @param {Object} options
 *        whiteList (or allowList), onTag, onTagAttr, onIgnoreTag,
 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
 */
function FilterXSS(options) {
  options = shallowCopyObject(options || {});

  if (options.stripIgnoreTag) {
    if (options.onIgnoreTag) {
      console.error(
        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
      );
    }
    options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
  }
  if (options.whiteList || options.allowList) {
    options.whiteList = keysToLowerCase(options.whiteList || options.allowList);
  } else {
    options.whiteList = DEFAULT.whiteList;
  }

  this.attributeWrapSign = options.singleQuotedAttributeValue === true ? "'" : DEFAULT.attributeWrapSign;

  options.onTag = options.onTag || DEFAULT.onTag;
  options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
  options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
  options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
  this.options = options;

  if (options.css === false) {
    this.cssFilter = false;
  } else {
    options.css = options.css || {};
    this.cssFilter = new FilterCSS(options.css);
  }
}

/**
 * start process and returns result
 *
 * @param {String} html
 * @return {String}
 */
FilterXSS.prototype.process = function (html) {
  // compatible with the input
  html = html || "";
  html = html.toString();
  if (!html) return "";

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onTag = options.onTag;
  var onIgnoreTag = options.onIgnoreTag;
  var onTagAttr = options.onTagAttr;
  var onIgnoreTagAttr = options.onIgnoreTagAttr;
  var safeAttrValue = options.safeAttrValue;
  var escapeHtml = options.escapeHtml;
  var attributeWrapSign = me.attributeWrapSign;
  var cssFilter = me.cssFilter;

  // remove invisible characters
  if (options.stripBlankChar) {
    html = DEFAULT.stripBlankChar(html);
  }

  // remove html comments
  if (!options.allowCommentTag) {
    html = DEFAULT.stripCommentTag(html);
  }

  // if enable stripIgnoreTagBody
  var stripIgnoreTagBody = false;
  if (options.stripIgnoreTagBody) {
    stripIgnoreTagBody = DEFAULT.StripTagBody(
      options.stripIgnoreTagBody,
      onIgnoreTag
    );
    onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
  }

  var retHtml = parseTag(
    html,
    function (sourcePosition, position, tag, html, isClosing) {
      var info = {
        sourcePosition: sourcePosition,
        position: position,
        isClosing: isClosing,
        isWhite: Object.prototype.hasOwnProperty.call(whiteList, tag),
      };

      // call `onTag()`
      var ret = onTag(tag, html, info);
      if (!isNull(ret)) return ret;

      if (info.isWhite) {
        if (info.isClosing) {
          return "</" + tag + ">";
        }

        var attrs = getAttrs(html);
        var whiteAttrList = whiteList[tag];
        var attrsHtml = parseAttr(attrs.html, function (name, value) {
          // call `onTagAttr()`
          var isWhiteAttr = _.indexOf(whiteAttrList, name) !== -1;
          var ret = onTagAttr(tag, name, value, isWhiteAttr);
          if (!isNull(ret)) return ret;

          if (isWhiteAttr) {
            // call `safeAttrValue()`
            value = safeAttrValue(tag, name, value, cssFilter);
            if (value) {
              return name + '=' + attributeWrapSign + value + attributeWrapSign;
            } else {
              return name;
            }
          } else {
            // call `onIgnoreTagAttr()`
            ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
            if (!isNull(ret)) return ret;
            return;
          }
        });

        // build new tag html
        html = "<" + tag;
        if (attrsHtml) html += " " + attrsHtml;
        if (attrs.closing) html += " /";
        html += ">";
        return html;
      } else {
        // call `onIgnoreTag()`
        ret = onIgnoreTag(tag, html, info);
        if (!isNull(ret)) return ret;
        return escapeHtml(html);
      }
    },
    escapeHtml
  );

  // if enable stripIgnoreTagBody
  if (stripIgnoreTagBody) {
    retHtml = stripIgnoreTagBody.remove(retHtml);
  }

  return retHtml;
};

var xss$1 = FilterXSS;

/**
 * xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

(function (module, exports) {
	var DEFAULT = _default$1;
	var parser = parser$1;
	var FilterXSS = xss$1;

	/**
	 * filter xss function
	 *
	 * @param {String} html
	 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
	 * @return {String}
	 */
	function filterXSS(html, options) {
	  var xss = new FilterXSS(options);
	  return xss.process(html);
	}

	exports = module.exports = filterXSS;
	exports.filterXSS = filterXSS;
	exports.FilterXSS = FilterXSS;

	(function () {
	  for (var i in DEFAULT) {
	    exports[i] = DEFAULT[i];
	  }
	  for (var j in parser) {
	    exports[j] = parser[j];
	  }
	})();

	// using `xss` on the browser, output `filterXSS` to the globals
	if (typeof window !== "undefined") {
	  window.filterXSS = module.exports;
	}

	// using `xss` on the WebWorker, output `filterXSS` to the globals
	function isWorkerEnv() {
	  return (
	    typeof self !== "undefined" &&
	    typeof DedicatedWorkerGlobalScope !== "undefined" &&
	    self instanceof DedicatedWorkerGlobalScope
	  );
	}
	if (isWorkerEnv()) {
	  self.filterXSS = module.exports;
	} 
} (lib$1, lib$1.exports));

var libExports = lib$1.exports;
var xss = /*@__PURE__*/getDefaultExportFromCjs(libExports);

var Prefooter = function (_a) {
  var backgroundCss = _a.backgroundCss,
    backgroundImageLeft = _a.backgroundImageLeft,
    backgroundImageRight = _a.backgroundImageRight,
    bodyText = _a.bodyText,
    button1Label = _a.button1Label,
    button1Url = _a.button1Url,
    button2Label = _a.button2Label,
    button2Url = _a.button2Url,
    children = _a.children,
    // hubspotFormData,
    // includeMobileAppButtons,
    // formRedirectUrl,
    title = _a.title,
    useDarkMode = _a.useDarkMode;
  // Determine which background images to use
  var leftImageSrc = backgroundImageLeft || "https://hs-marketing-contentful.imgix.net/https%3A%2F%2Fimages.ctfassets.net%2Fp15sglj92v6o%2F1ICOp6hNCHPVfufTh4kIco%2Faab7f8633748eec2e30795cda22f5fa1%2FPrefooter--bg-left.png?ixlib=js-3.8.0&w=1540&q=75&format=webp&s=eb6809244c6c6592ab7b3bdcdbb4cdc6";
  var rightImageSrc = backgroundImageRight || "https://hs-marketing-contentful.imgix.net/https%3A%2F%2Fimages.ctfassets.net%2Fp15sglj92v6o%2F1vDj8cqGUKzJ9jJicAQe7E%2F14121f26988fa6a1592703cdcdf0f77e%2FPrefooter--bg-right.png?ixlib=js-3.8.0&w=1540&q=75&format=webp&s=ffda906808ea49c687f4adabca2017e8";
  return jsxs("div", {
    className: "Prefooter".concat(useDarkMode ? " use-dark-mode" : ""),
    style: backgroundCss ? {
      background: backgroundCss
    } : {},
    children: [jsx("img", {
      alt: "",
      className: "bg-left",
      src: leftImageSrc,
      role: "presentation"
    }), jsx("img", {
      alt: "",
      className: "bg-right",
      src: rightImageSrc,
      role: "presentation"
    }), jsx("div", {
      className: "container",
      children: jsx("div", {
        className: "grid",
        children: jsxs("div", {
          className: "content column column--2-12-M",
          children: [title && jsx("h2", {
            className: "type--headline-medium-5XL",
            dangerouslySetInnerHTML: {
              __html: xss(oneLineHelpScout(title))
            },
            id: convertStringToKebabCase(title)
          }), bodyText && jsx("p", {
            className: "type--text-L max-width--column--6",
            dangerouslySetInnerHTML: {
              __html: xss(bodyText)
            }
          }), jsxs("div", {
            className: "Prefooter--Buttons",
            children: [button1Label && button1Url && jsx("a", {
              className: "button button--L",
              href: button1Url || "/",
              children: button1Label || "Download the ebook"
            }), button2Label && button2Url && jsx("a", {
              className: "button button--L button--secondary",
              href: button2Url,
              children: button2Label
            })]
          }), children && children]
        })
      })
    })]
  });
};

// Thresholds work this way:
// First keyword = start
// Second keyword = end
// So, for example:
// BOTTOM_BOTTOM means when the top of the Ref hits the BOTTOM of the screen, start scrubbing.
// When the bottom of the Ref hits the BOTTOM of the screen, end scrubbing.
var SCRUBBER_THRESHOLDS;
(function (SCRUBBER_THRESHOLDS) {
  SCRUBBER_THRESHOLDS["BOTTOM_BOTTOM"] = "BOTTOM_BOTTOM";
  SCRUBBER_THRESHOLDS["BOTTOM_TOP"] = "BOTTOM_TOP";
  SCRUBBER_THRESHOLDS["TOP_TOP"] = "TOP_TOP";
})(SCRUBBER_THRESHOLDS || (SCRUBBER_THRESHOLDS = {}));
var Scrubber = function (_a) {
  var children = _a.children,
    _b = _a.threshold,
    threshold = _b === void 0 ? SCRUBBER_THRESHOLDS.BOTTOM_TOP : _b;
  var ref = useRef(null);
  var _c = useState(0),
    pctCompleted = _c[0],
    setPctCompleted = _c[1];
  var _d = useState(false),
    isReady = _d[0],
    setIsReady = _d[1];
  useEffect(function () {
    if (!isClientSide()) return;
    var handleScroll = function () {
      var _a;
      window.requestAnimationFrame(function () {
        return setIsReady(true);
      });
      var rect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
      if (!rect) return;
      var posFromBottom = window.innerHeight - rect.y;
      var posFromTop = rect.y;
      var height = rect.height;
      // Is below the viewport
      if (posFromBottom < 0) {
        window.requestAnimationFrame(function () {
          return setPctCompleted(0);
        });
        return;
      }
      // Is above the viewport
      if (posFromTop < height * -1 - 100) {
        window.requestAnimationFrame(function () {
          return setPctCompleted(100);
        });
        return;
      }
      if (threshold === SCRUBBER_THRESHOLDS.BOTTOM_BOTTOM) {
        if (posFromBottom >= height) {
          window.requestAnimationFrame(function () {
            return setPctCompleted(1);
          });
          return;
        }
        window.requestAnimationFrame(function () {
          return setPctCompleted(Math.ceil(posFromBottom / height * 1000) / 1000);
        });
        return;
      }
      if (threshold === SCRUBBER_THRESHOLDS.BOTTOM_TOP) {
        if (posFromBottom >= window.innerHeight + height) {
          window.requestAnimationFrame(function () {
            return setPctCompleted(1);
          });
          return;
        }
        window.requestAnimationFrame(function () {
          return setPctCompleted(Math.ceil(posFromBottom / (window.innerHeight + height) * 1000) / 1000);
        });
        return;
      }
      if (threshold === SCRUBBER_THRESHOLDS.TOP_TOP) {
        if (posFromTop >= 0) {
          window.requestAnimationFrame(function () {
            return setPctCompleted(0);
          });
          return;
        }
        if (posFromTop <= height * -1) {
          window.requestAnimationFrame(function () {
            return setPctCompleted(1);
          });
          return;
        }
        if (posFromTop <= 0) {
          window.requestAnimationFrame(function () {
            return setPctCompleted(Math.ceil(Math.abs(posFromTop) / height * 1000) / 1000);
          });
          return;
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return children(ref, pctCompleted, isReady);
};

var RevealArea = function (_a) {
  var children = _a.children;
  return jsx(Scrubber, {
    threshold: SCRUBBER_THRESHOLDS.BOTTOM_BOTTOM,
    children: function (ref, pctCompleted) {
      return jsxs("div", {
        className: "RevealArea",
        ref: ref,
        style: {
          overflow: "hidden",
          position: "relative"
        },
        children: [jsx("div", {
          className: "RevealArea--shadow",
          style: {
            boxShadow: "var(--elevation--M)",
            height: 0,
            left: "-10vw",
            position: "absolute",
            top: 0,
            width: "120vw",
            zIndex: 1
          }
        }), jsx("div", {
          className: "RevealArea--wrapper",
          style: {
            transform: "translateY(".concat((isClientSide() ? 1 - pctCompleted : 0) * -10, "vw)")
          },
          children: children
        })]
      });
    }
  });
};

var DefaultPrefooter = function (_a) {
  var demoUrl = _a.demoUrl,
    signupPlusUrl = _a.signupPlusUrl;
  return jsx(RevealArea, {
    children: jsx(Fragment, {
      children: jsxs("div", {
        className: "DefaultPrefooter",
        style: {
          "--DefaultPrefooter--noise-overlay": "url(\"https://hs-marketing-contentful.imgix.net/https%3A%2F%2Fimages.ctfassets.net%2Fp15sglj92v6o%2F2wVXgpNXWP0vqaEXRo82Ro%2F4e8ead91f6ffec70abb7659d3bc02885%2FNoise_Overlay_240x240.png?ixlib=js-3.8.0&w=240&q=75&format=webp&s=63500dd7854457245242e7a1ace027d2\")"
        },
        children: [jsx(Prefooter, {
          backgroundImageLeft: "https://hs-marketing-contentful.imgix.net/https%3A%2F%2Fimages.ctfassets.net%2Fp15sglj92v6o%2F7Bzis0FkbzjXmx1Z9To7Qa%2Fb8ae3254e28689e6d83fff002431f4b8%2FDefaultPrefooter--bg-left-24.png?ixlib=js-3.8.0&w=1310&q=75&format=webp&s=f8161cc6e66b179cf8e18cad83522045",
          backgroundImageRight: "https://hs-marketing-contentful.imgix.net/https%3A%2F%2Fimages.ctfassets.net%2Fp15sglj92v6o%2F4sCZdjSFilCBFKwZYDyFKb%2F3d43c651c268a88f152eeff4fd2e7cbd%2FDefaultPrefooter--bg-right-24.png?ixlib=js-3.8.0&w=1310&q=75&format=webp&s=09c27debc5216686e39ed229c5cb67ea",
          bodyText: "Learn the platform in less than\u00A0an\u00A0hour.<br>Become a <em>power user</em> in less\u00A0than\u00A0a\u00A0day.",
          title: "Start for Free",
          children: jsxs("div", {
            className: "buttons-container",
            children: [jsx("a", {
              className: "button button--L",
              href: signupPlusUrl || "/",
              children: "Start for Free"
            }), jsx("a", {
              className: "demo-button button button--L button--secondary",
              href: demoUrl || "/",
              children: "Book a Demo"
            })]
          })
        }), jsx("div", {
          className: "DefaultPrefooter--graphic container",
          children: jsxs("div", {
            className: "card",
            children: [jsxs("div", {
              className: "avatars",
              children: [jsx("img", {
                alt: "",
                role: "presentation",
                src: "https://hs-marketing-contentful.imgix.net/https%3A%2F%2Fimages.ctfassets.net%2Fp15sglj92v6o%2F14F4JW81TVmBqrkjlL5dY3%2F4e21d7fc5cc610edf9165bd428cbd221%2FFCB7gqVp.png?ixlib=gatsbySourceUrl-2.1.3&auto=format%2C%20compress&q=75&w=176&h=176&s=5d586cfd5909c3411cee2521fa7ae67f",
                width: 88,
                height: 88
              }), jsxs("div", {
                className: "status-animation",
                children: [jsx("div", {
                  className: "status-ring"
                }), jsx("div", {
                  className: "status-ring"
                }), jsx("img", {
                  alt: "",
                  role: "presentation",
                  src: "https://hs-marketing-contentful.imgix.net/https%3A%2F%2Fimages.ctfassets.net%2Fp15sglj92v6o%2F2bWW3wrtGFFx9TrMMkpscj%2F865aebc32e37505a24b87c8dfb73ee0f%2FDefaultPrefooter--graphic-avatar-right.png?ixlib=gatsbySourceUrl-2.1.3&auto=format%2C%20compress&q=75&w=176&h=176&s=25e2476677a7a39a23e9d48ee0e6f998",
                  width: 88,
                  height: 88
                })]
              })]
            }), jsxs("div", {
              className: "card-top",
              children: [jsx("img", {
                alt: "",
                className: "card-title",
                loading: "lazy",
                role: "presentation",
                src: "https://hs-marketing-contentful.imgix.net/https%3A%2F%2Fimages.ctfassets.net%2Fp15sglj92v6o%2F6BGqwB3ZROlXwi1V7gIFNs%2Fa2019be36e01f5f534b0a75826e5da47%2FDefaultPrefooter--graphic--title.svg?ixlib=js-3.8.0&w=125&q=75&format=svg&s=88acbb61a72f9384ee9a0ffc8b18a265"
              }), jsx("img", {
                alt: "",
                className: "card-tags",
                loading: "lazy",
                role: "presentation",
                src: "https://hs-marketing-contentful.imgix.net/https%3A%2F%2Fimages.ctfassets.net%2Fp15sglj92v6o%2F5D0Ss43czRTZNPXsdbyicd%2Fbb2d259e44e90b0e929856e473b6903e%2FDefaultPrefooter--graphic--tags.svg?ixlib=js-3.8.0&w=95&q=75&format=svg&s=7d04fa547e9fa0f25ef5ca72413fadc8"
              })]
            })]
          })
        })]
      })
    })
  });
};

var ICON_TYPES;
(function (ICON_TYPES) {
  ICON_TYPES["16-plus"] = "16-plus";
  ICON_TYPES["18-plus"] = "18-plus";
  ICON_TYPES["2m-distance"] = "2m-distance";
  ICON_TYPES["3d-rotate"] = "3d-rotate";
  ICON_TYPES["4g"] = "4g";
  ICON_TYPES["4k"] = "4k";
  ICON_TYPES["5g"] = "5g";
  ICON_TYPES["90-degrees"] = "90-degrees";
  ICON_TYPES["a-z-sort"] = "a-z-sort";
  ICON_TYPES["accessibility"] = "accessibility";
  ICON_TYPES["acorn"] = "acorn";
  ICON_TYPES["activity"] = "activity";
  ICON_TYPES["add-video"] = "add-video";
  ICON_TYPES["aerial"] = "aerial";
  ICON_TYPES["airplay-to-tv"] = "airplay-to-tv";
  ICON_TYPES["airpods"] = "airpods";
  ICON_TYPES["alarm"] = "alarm";
  ICON_TYPES["alarm-warning"] = "alarm-warning";
  ICON_TYPES["alert"] = "alert";
  ICON_TYPES["alert-error"] = "alert-error";
  ICON_TYPES["alien"] = "alien";
  ICON_TYPES["alien-2"] = "alien-2";
  ICON_TYPES["align-arrow-down"] = "align-arrow-down";
  ICON_TYPES["align-arrow-left"] = "align-arrow-left";
  ICON_TYPES["align-arrow-right"] = "align-arrow-right";
  ICON_TYPES["align-arrow-up"] = "align-arrow-up";
  ICON_TYPES["align-bottom"] = "align-bottom";
  ICON_TYPES["align-centre-horizontal"] = "align-centre-horizontal";
  ICON_TYPES["align-centre-vertical"] = "align-centre-vertical";
  ICON_TYPES["align-horizontal-centre"] = "align-horizontal-centre";
  ICON_TYPES["align-left"] = "align-left";
  ICON_TYPES["align-right"] = "align-right";
  ICON_TYPES["align-top"] = "align-top";
  ICON_TYPES["align-vertical-centre"] = "align-vertical-centre";
  ICON_TYPES["alt-key"] = "alt-key";
  ICON_TYPES["anchor"] = "anchor";
  ICON_TYPES["angle"] = "angle";
  ICON_TYPES["animation-enter"] = "animation-enter";
  ICON_TYPES["animation-exit"] = "animation-exit";
  ICON_TYPES["annotation"] = "annotation";
  ICON_TYPES["annotation-dots"] = "annotation-dots";
  ICON_TYPES["annotation-warning"] = "annotation-warning";
  ICON_TYPES["announcement"] = "announcement";
  ICON_TYPES["app-store"] = "app-store";
  ICON_TYPES["apple"] = "apple";
  ICON_TYPES["apple-2"] = "apple-2";
  ICON_TYPES["apple-pay"] = "apple-pay";
  ICON_TYPES["apple-watch"] = "apple-watch";
  ICON_TYPES["apple-watch-ultra"] = "apple-watch-ultra";
  ICON_TYPES["apps"] = "apps";
  ICON_TYPES["apps-integrations"] = "apps-integrations";
  ICON_TYPES["aquarius"] = "aquarius";
  ICON_TYPES["archive"] = "archive";
  ICON_TYPES["archive-arrow-down"] = "archive-arrow-down";
  ICON_TYPES["archive-arrow-up"] = "archive-arrow-up";
  ICON_TYPES["archive-check"] = "archive-check";
  ICON_TYPES["archive-minus"] = "archive-minus";
  ICON_TYPES["archive-plus"] = "archive-plus";
  ICON_TYPES["archive-stack"] = "archive-stack";
  ICON_TYPES["aries"] = "aries";
  ICON_TYPES["arrow-down"] = "arrow-down";
  ICON_TYPES["arrow-down-circle"] = "arrow-down-circle";
  ICON_TYPES["arrow-down-left"] = "arrow-down-left";
  ICON_TYPES["arrow-down-left-circle"] = "arrow-down-left-circle";
  ICON_TYPES["arrow-down-right"] = "arrow-down-right";
  ICON_TYPES["arrow-down-right-circle"] = "arrow-down-right-circle";
  ICON_TYPES["arrow-left"] = "arrow-left";
  ICON_TYPES["arrow-left-circle"] = "arrow-left-circle";
  ICON_TYPES["arrow-right"] = "arrow-right";
  ICON_TYPES["arrow-right-circle"] = "arrow-right-circle";
  ICON_TYPES["arrow-up"] = "arrow-up";
  ICON_TYPES["arrow-up-circle"] = "arrow-up-circle";
  ICON_TYPES["arrow-up-left"] = "arrow-up-left";
  ICON_TYPES["arrow-up-left-circle"] = "arrow-up-left-circle";
  ICON_TYPES["arrow-up-right"] = "arrow-up-right";
  ICON_TYPES["arrow-up-right-circle"] = "arrow-up-right-circle";
  ICON_TYPES["arrows"] = "arrows";
  ICON_TYPES["asterisk"] = "asterisk";
  ICON_TYPES["astronomy"] = "astronomy";
  ICON_TYPES["at-sign"] = "at-sign";
  ICON_TYPES["avatar-hexagonal"] = "avatar-hexagonal";
  ICON_TYPES["avatar-square"] = "avatar-square";
  ICON_TYPES["award"] = "award";
  ICON_TYPES["axe"] = "axe";
  ICON_TYPES["back"] = "back";
  ICON_TYPES["backpack"] = "backpack";
  ICON_TYPES["bacteria"] = "bacteria";
  ICON_TYPES["badge"] = "badge";
  ICON_TYPES["badge-2"] = "badge-2";
  ICON_TYPES["baguette"] = "baguette";
  ICON_TYPES["baht"] = "baht";
  ICON_TYPES["balance-sheet"] = "balance-sheet";
  ICON_TYPES["ball"] = "ball";
  ICON_TYPES["ball-rolling"] = "ball-rolling";
  ICON_TYPES["ball-rolling-fast"] = "ball-rolling-fast";
  ICON_TYPES["balloon"] = "balloon";
  ICON_TYPES["balloons"] = "balloons";
  ICON_TYPES["ballot"] = "ballot";
  ICON_TYPES["ballot-box"] = "ballot-box";
  ICON_TYPES["banana"] = "banana";
  ICON_TYPES["band-aid"] = "band-aid";
  ICON_TYPES["bandages"] = "bandages";
  ICON_TYPES["bank"] = "bank";
  ICON_TYPES["bank-note"] = "bank-note";
  ICON_TYPES["barcode"] = "barcode";
  ICON_TYPES["barcode-2"] = "barcode-2";
  ICON_TYPES["baseball"] = "baseball";
  ICON_TYPES["bath"] = "bath";
  ICON_TYPES["battery"] = "battery";
  ICON_TYPES["battery-charging"] = "battery-charging";
  ICON_TYPES["battery-error"] = "battery-error";
  ICON_TYPES["battery-full"] = "battery-full";
  ICON_TYPES["battery-low"] = "battery-low";
  ICON_TYPES["battery-medium"] = "battery-medium";
  ICON_TYPES["bbq"] = "bbq";
  ICON_TYPES["beach"] = "beach";
  ICON_TYPES["beach-2"] = "beach-2";
  ICON_TYPES["bed"] = "bed";
  ICON_TYPES["beer"] = "beer";
  ICON_TYPES["bell"] = "bell";
  ICON_TYPES["bell-check"] = "bell-check";
  ICON_TYPES["bell-cross"] = "bell-cross";
  ICON_TYPES["bell-off"] = "bell-off";
  ICON_TYPES["bell-ringing"] = "bell-ringing";
  ICON_TYPES["bell-snooze"] = "bell-snooze";
  ICON_TYPES["bezier-curve"] = "bezier-curve";
  ICON_TYPES["bicycle"] = "bicycle";
  ICON_TYPES["binoculars"] = "binoculars";
  ICON_TYPES["bird"] = "bird";
  ICON_TYPES["bird-house"] = "bird-house";
  ICON_TYPES["bitcoin"] = "bitcoin";
  ICON_TYPES["blinds-closed"] = "blinds-closed";
  ICON_TYPES["blinds-open"] = "blinds-open";
  ICON_TYPES["block-inside"] = "block-inside";
  ICON_TYPES["block-outside"] = "block-outside";
  ICON_TYPES["blockquote"] = "blockquote";
  ICON_TYPES["bluetooth"] = "bluetooth";
  ICON_TYPES["boat"] = "boat";
  ICON_TYPES["bold"] = "bold";
  ICON_TYPES["bolt"] = "bolt";
  ICON_TYPES["bone"] = "bone";
  ICON_TYPES["book"] = "book";
  ICON_TYPES["book-2"] = "book-2";
  ICON_TYPES["book-open"] = "book-open";
  ICON_TYPES["bookmark"] = "bookmark";
  ICON_TYPES["bookmark-2"] = "bookmark-2";
  ICON_TYPES["books"] = "books";
  ICON_TYPES["borders"] = "borders";
  ICON_TYPES["bottle"] = "bottle";
  ICON_TYPES["bowl"] = "bowl";
  ICON_TYPES["bowling"] = "bowling";
  ICON_TYPES["box"] = "box";
  ICON_TYPES["boxes"] = "boxes";
  ICON_TYPES["brain"] = "brain";
  ICON_TYPES["bread"] = "bread";
  ICON_TYPES["brick-wall"] = "brick-wall";
  ICON_TYPES["briefcase"] = "briefcase";
  ICON_TYPES["briefcase-2"] = "briefcase-2";
  ICON_TYPES["brightness-high"] = "brightness-high";
  ICON_TYPES["brightness-low"] = "brightness-low";
  ICON_TYPES["brightness-medium"] = "brightness-medium";
  ICON_TYPES["bring-forward"] = "bring-forward";
  ICON_TYPES["broadcast"] = "broadcast";
  ICON_TYPES["broken-bone"] = "broken-bone";
  ICON_TYPES["browser"] = "browser";
  ICON_TYPES["browser-history"] = "browser-history";
  ICON_TYPES["browser-tabs"] = "browser-tabs";
  ICON_TYPES["bug"] = "bug";
  ICON_TYPES["building"] = "building";
  ICON_TYPES["building-01"] = "building-01";
  ICON_TYPES["building-2"] = "building-2";
  ICON_TYPES["building-store"] = "building-store";
  ICON_TYPES["buildings"] = "buildings";
  ICON_TYPES["bunting"] = "bunting";
  ICON_TYPES["bunting-2"] = "bunting-2";
  ICON_TYPES["burger"] = "burger";
  ICON_TYPES["bus"] = "bus";
  ICON_TYPES["cabinet"] = "cabinet";
  ICON_TYPES["cabinet-2"] = "cabinet-2";
  ICON_TYPES["cake"] = "cake";
  ICON_TYPES["cake-slice"] = "cake-slice";
  ICON_TYPES["calculator"] = "calculator";
  ICON_TYPES["calendar"] = "calendar";
  ICON_TYPES["calendar-check"] = "calendar-check";
  ICON_TYPES["calendar-cross"] = "calendar-cross";
  ICON_TYPES["calendar-minus"] = "calendar-minus";
  ICON_TYPES["calendar-plus"] = "calendar-plus";
  ICON_TYPES["calendar-timer"] = "calendar-timer";
  ICON_TYPES["camera"] = "camera";
  ICON_TYPES["camera-off"] = "camera-off";
  ICON_TYPES["camera-tripod"] = "camera-tripod";
  ICON_TYPES["cancer"] = "cancer";
  ICON_TYPES["capricorn"] = "capricorn";
  ICON_TYPES["captions"] = "captions";
  ICON_TYPES["car"] = "car";
  ICON_TYPES["car-2"] = "car-2";
  ICON_TYPES["car-battery"] = "car-battery";
  ICON_TYPES["car-dashboard"] = "car-dashboard";
  ICON_TYPES["car-door"] = "car-door";
  ICON_TYPES["car-engine"] = "car-engine";
  ICON_TYPES["car-gear-stick"] = "car-gear-stick";
  ICON_TYPES["carat-down"] = "carat-down";
  ICON_TYPES["carat-left"] = "carat-left";
  ICON_TYPES["carat-right"] = "carat-right";
  ICON_TYPES["carat-up"] = "carat-up";
  ICON_TYPES["cards"] = "cards";
  ICON_TYPES["cart"] = "cart";
  ICON_TYPES["cassette"] = "cassette";
  ICON_TYPES["cat"] = "cat";
  ICON_TYPES["cctv"] = "cctv";
  ICON_TYPES["celsius"] = "celsius";
  ICON_TYPES["cent"] = "cent";
  ICON_TYPES["center"] = "center";
  ICON_TYPES["chart"] = "chart";
  ICON_TYPES["chart-decrease"] = "chart-decrease";
  ICON_TYPES["chart-increase"] = "chart-increase";
  ICON_TYPES["check"] = "check";
  ICON_TYPES["check-2"] = "check-2";
  ICON_TYPES["check-circle"] = "check-circle";
  ICON_TYPES["checklist"] = "checklist";
  ICON_TYPES["checklist-2"] = "checklist-2";
  ICON_TYPES["checkmark"] = "checkmark";
  ICON_TYPES["cheese"] = "cheese";
  ICON_TYPES["chemical-bottle"] = "chemical-bottle";
  ICON_TYPES["chemical-tube"] = "chemical-tube";
  ICON_TYPES["chemical-tube-2"] = "chemical-tube-2";
  ICON_TYPES["cherry"] = "cherry";
  ICON_TYPES["chevron-down"] = "chevron-down";
  ICON_TYPES["chevron-left"] = "chevron-left";
  ICON_TYPES["chevron-right"] = "chevron-right";
  ICON_TYPES["chevron-up"] = "chevron-up";
  ICON_TYPES["chicken"] = "chicken";
  ICON_TYPES["chilli"] = "chilli";
  ICON_TYPES["christmas-tree"] = "christmas-tree";
  ICON_TYPES["circle"] = "circle";
  ICON_TYPES["circle-intersect"] = "circle-intersect";
  ICON_TYPES["circle-plus"] = "circle-plus";
  ICON_TYPES["clean"] = "clean";
  ICON_TYPES["clean-power"] = "clean-power";
  ICON_TYPES["click-pulse"] = "click-pulse";
  ICON_TYPES["clickable-area"] = "clickable-area";
  ICON_TYPES["clipboard"] = "clipboard";
  ICON_TYPES["clock"] = "clock";
  ICON_TYPES["close"] = "close";
  ICON_TYPES["close-circle"] = "close-circle";
  ICON_TYPES["closed-captions"] = "closed-captions";
  ICON_TYPES["closed-captions-off"] = "closed-captions-off";
  ICON_TYPES["cloud"] = "cloud";
  ICON_TYPES["clubs"] = "clubs";
  ICON_TYPES["coat-hanger"] = "coat-hanger";
  ICON_TYPES["cocktail"] = "cocktail";
  ICON_TYPES["code"] = "code";
  ICON_TYPES["code-2"] = "code-2";
  ICON_TYPES["code-3"] = "code-3";
  ICON_TYPES["coffee-machine"] = "coffee-machine";
  ICON_TYPES["coffin"] = "coffin";
  ICON_TYPES["coins"] = "coins";
  ICON_TYPES["color-swatch"] = "color-swatch";
  ICON_TYPES["columns"] = "columns";
  ICON_TYPES["columns-2"] = "columns-2";
  ICON_TYPES["columns-horizontal"] = "columns-horizontal";
  ICON_TYPES["columns-vertical"] = "columns-vertical";
  ICON_TYPES["command"] = "command";
  ICON_TYPES["compass"] = "compass";
  ICON_TYPES["components"] = "components";
  ICON_TYPES["cone"] = "cone";
  ICON_TYPES["cone-2"] = "cone-2";
  ICON_TYPES["construction"] = "construction";
  ICON_TYPES["contacts"] = "contacts";
  ICON_TYPES["contract"] = "contract";
  ICON_TYPES["copy"] = "copy";
  ICON_TYPES["corner-flag"] = "corner-flag";
  ICON_TYPES["cpu"] = "cpu";
  ICON_TYPES["credit-card"] = "credit-card";
  ICON_TYPES["credit-card-plus"] = "credit-card-plus";
  ICON_TYPES["crop"] = "crop";
  ICON_TYPES["crosshair"] = "crosshair";
  ICON_TYPES["crosshair-2"] = "crosshair-2";
  ICON_TYPES["crowd"] = "crowd";
  ICON_TYPES["crown"] = "crown";
  ICON_TYPES["crown-2"] = "crown-2";
  ICON_TYPES["crucifix"] = "crucifix";
  ICON_TYPES["css"] = "css";
  ICON_TYPES["cup-straw"] = "cup-straw";
  ICON_TYPES["cursor"] = "cursor";
  ICON_TYPES["cursor-click"] = "cursor-click";
  ICON_TYPES["cursor-text"] = "cursor-text";
  ICON_TYPES["dashboard"] = "dashboard";
  ICON_TYPES["database"] = "database";
  ICON_TYPES["database-error"] = "database-error";
  ICON_TYPES["database-minus"] = "database-minus";
  ICON_TYPES["database-plus"] = "database-plus";
  ICON_TYPES["deathstar"] = "deathstar";
  ICON_TYPES["deer"] = "deer";
  ICON_TYPES["delete"] = "delete";
  ICON_TYPES["devices"] = "devices";
  ICON_TYPES["dial-pad"] = "dial-pad";
  ICON_TYPES["diamonds"] = "diamonds";
  ICON_TYPES["dice-1"] = "dice-1";
  ICON_TYPES["dice-2"] = "dice-2";
  ICON_TYPES["dice-3"] = "dice-3";
  ICON_TYPES["dice-4"] = "dice-4";
  ICON_TYPES["dice-5"] = "dice-5";
  ICON_TYPES["dice-6"] = "dice-6";
  ICON_TYPES["dimensions"] = "dimensions";
  ICON_TYPES["directions"] = "directions";
  ICON_TYPES["disability"] = "disability";
  ICON_TYPES["disability-2"] = "disability-2";
  ICON_TYPES["discord"] = "discord";
  ICON_TYPES["dna"] = "dna";
  ICON_TYPES["dna-2"] = "dna-2";
  ICON_TYPES["doc"] = "doc";
  ICON_TYPES["dog"] = "dog";
  ICON_TYPES["dogecoin"] = "dogecoin";
  ICON_TYPES["dogecoin-2"] = "dogecoin-2";
  ICON_TYPES["dollar"] = "dollar";
  ICON_TYPES["dollar-2"] = "dollar-2";
  ICON_TYPES["door"] = "door";
  ICON_TYPES["door-enter"] = "door-enter";
  ICON_TYPES["door-exit"] = "door-exit";
  ICON_TYPES["door-lock"] = "door-lock";
  ICON_TYPES["door-open"] = "door-open";
  ICON_TYPES["dots"] = "dots";
  ICON_TYPES["dots-horizontal"] = "dots-horizontal";
  ICON_TYPES["dots-horizontal-circle"] = "dots-horizontal-circle";
  ICON_TYPES["dots-vertical"] = "dots-vertical";
  ICON_TYPES["dots-vertical-circle"] = "dots-vertical-circle";
  ICON_TYPES["dotted-circle-left"] = "dotted-circle-left";
  ICON_TYPES["dotted-circle-right"] = "dotted-circle-right";
  ICON_TYPES["double-bed"] = "double-bed";
  ICON_TYPES["double-chat-bubble"] = "double-chat-bubble";
  ICON_TYPES["double-chevron-down"] = "double-chevron-down";
  ICON_TYPES["double-chevron-left"] = "double-chevron-left";
  ICON_TYPES["double-chevron-right"] = "double-chevron-right";
  ICON_TYPES["double-chevron-up"] = "double-chevron-up";
  ICON_TYPES["download"] = "download";
  ICON_TYPES["download-cloud"] = "download-cloud";
  ICON_TYPES["downstairs"] = "downstairs";
  ICON_TYPES["dress"] = "dress";
  ICON_TYPES["dribbble"] = "dribbble";
  ICON_TYPES["drill"] = "drill";
  ICON_TYPES["drink"] = "drink";
  ICON_TYPES["drone"] = "drone";
  ICON_TYPES["dropbox"] = "dropbox";
  ICON_TYPES["dropdown"] = "dropdown";
  ICON_TYPES["droplet"] = "droplet";
  ICON_TYPES["droplet-off"] = "droplet-off";
  ICON_TYPES["droplets"] = "droplets";
  ICON_TYPES["drums"] = "drums";
  ICON_TYPES["drums-2"] = "drums-2";
  ICON_TYPES["dumbell"] = "dumbell";
  ICON_TYPES["ear"] = "ear";
  ICON_TYPES["ear-off"] = "ear-off";
  ICON_TYPES["east"] = "east";
  ICON_TYPES["edit"] = "edit";
  ICON_TYPES["edit-shape"] = "edit-shape";
  ICON_TYPES["education"] = "education";
  ICON_TYPES["egg-timer"] = "egg-timer";
  ICON_TYPES["electric-bike"] = "electric-bike";
  ICON_TYPES["electric-scooter"] = "electric-scooter";
  ICON_TYPES["email-error"] = "email-error";
  ICON_TYPES["email-minus"] = "email-minus";
  ICON_TYPES["email-plus"] = "email-plus";
  ICON_TYPES["emoji-angry"] = "emoji-angry";
  ICON_TYPES["emoji-happy"] = "emoji-happy";
  ICON_TYPES["emoji-neutral"] = "emoji-neutral";
  ICON_TYPES["emoji-sad"] = "emoji-sad";
  ICON_TYPES["emoji-x-eyes"] = "emoji-x-eyes";
  ICON_TYPES["eraser"] = "eraser";
  ICON_TYPES["esc-key"] = "esc-key";
  ICON_TYPES["ethereum"] = "ethereum";
  ICON_TYPES["euro"] = "euro";
  ICON_TYPES["export"] = "export";
  ICON_TYPES["eye"] = "eye";
  ICON_TYPES["eye-dropper"] = "eye-dropper";
  ICON_TYPES["eye-lock"] = "eye-lock";
  ICON_TYPES["eye-off"] = "eye-off";
  ICON_TYPES["face"] = "face";
  ICON_TYPES["face-angel"] = "face-angel";
  ICON_TYPES["face-big-smile"] = "face-big-smile";
  ICON_TYPES["face-big-smile-1"] = "face-big-smile-1";
  ICON_TYPES["face-check"] = "face-check";
  ICON_TYPES["face-cry"] = "face-cry";
  ICON_TYPES["face-id"] = "face-id";
  ICON_TYPES["face-id-error"] = "face-id-error";
  ICON_TYPES["face-laughing"] = "face-laughing";
  ICON_TYPES["face-love"] = "face-love";
  ICON_TYPES["face-sad"] = "face-sad";
  ICON_TYPES["face-sad-2"] = "face-sad-2";
  ICON_TYPES["face-shock"] = "face-shock";
  ICON_TYPES["face-smile-circle"] = "face-smile-circle";
  ICON_TYPES["face-straight"] = "face-straight";
  ICON_TYPES["face-sweat"] = "face-sweat";
  ICON_TYPES["face-upside-down"] = "face-upside-down";
  ICON_TYPES["face-whistle"] = "face-whistle";
  ICON_TYPES["face-yawn"] = "face-yawn";
  ICON_TYPES["facebook"] = "facebook";
  ICON_TYPES["fahrenheit"] = "fahrenheit";
  ICON_TYPES["fan"] = "fan";
  ICON_TYPES["fan-2"] = "fan-2";
  ICON_TYPES["fast-forward"] = "fast-forward";
  ICON_TYPES["fast-train"] = "fast-train";
  ICON_TYPES["faucet"] = "faucet";
  ICON_TYPES["feather"] = "feather";
  ICON_TYPES["female"] = "female";
  ICON_TYPES["female-1"] = "female-1";
  ICON_TYPES["figma"] = "figma";
  ICON_TYPES["file"] = "file";
  ICON_TYPES["file-2"] = "file-2";
  ICON_TYPES["file-checkmark"] = "file-checkmark";
  ICON_TYPES["file-download-2"] = "file-download-2";
  ICON_TYPES["file-error"] = "file-error";
  ICON_TYPES["file-important"] = "file-important";
  ICON_TYPES["file-minus"] = "file-minus";
  ICON_TYPES["file-minus-2"] = "file-minus-2";
  ICON_TYPES["file-plus"] = "file-plus";
  ICON_TYPES["file-plus-2"] = "file-plus-2";
  ICON_TYPES["file-scan"] = "file-scan";
  ICON_TYPES["file-search"] = "file-search";
  ICON_TYPES["file-share"] = "file-share";
  ICON_TYPES["file-text"] = "file-text";
  ICON_TYPES["file-text-2"] = "file-text-2";
  ICON_TYPES["file-user"] = "file-user";
  ICON_TYPES["files"] = "files";
  ICON_TYPES["film"] = "film";
  ICON_TYPES["filter"] = "filter";
  ICON_TYPES["filter-2"] = "filter-2";
  ICON_TYPES["filters"] = "filters";
  ICON_TYPES["filters-2"] = "filters-2";
  ICON_TYPES["finder"] = "finder";
  ICON_TYPES["finger-cross"] = "finger-cross";
  ICON_TYPES["finger-point"] = "finger-point";
  ICON_TYPES["finger-swipe"] = "finger-swipe";
  ICON_TYPES["finger-tap"] = "finger-tap";
  ICON_TYPES["fingerprint"] = "fingerprint";
  ICON_TYPES["fingerprint-2"] = "fingerprint-2";
  ICON_TYPES["fire"] = "fire";
  ICON_TYPES["fish"] = "fish";
  ICON_TYPES["fishes"] = "fishes";
  ICON_TYPES["flag"] = "flag";
  ICON_TYPES["flag-priority"] = "flag-priority";
  ICON_TYPES["flag-priority-2"] = "flag-priority-2";
  ICON_TYPES["flag-priority-3"] = "flag-priority-3";
  ICON_TYPES["flashlight"] = "flashlight";
  ICON_TYPES["flip-horizontal"] = "flip-horizontal";
  ICON_TYPES["flip-horizontally"] = "flip-horizontally";
  ICON_TYPES["flip-vertical"] = "flip-vertical";
  ICON_TYPES["flip-vertically"] = "flip-vertically";
  ICON_TYPES["float-center"] = "float-center";
  ICON_TYPES["float-left"] = "float-left";
  ICON_TYPES["float-right"] = "float-right";
  ICON_TYPES["floorplan"] = "floorplan";
  ICON_TYPES["floppy-disc"] = "floppy-disc";
  ICON_TYPES["flower"] = "flower";
  ICON_TYPES["flowers"] = "flowers";
  ICON_TYPES["folder"] = "folder";
  ICON_TYPES["folder-check"] = "folder-check";
  ICON_TYPES["folder-cross"] = "folder-cross";
  ICON_TYPES["folder-down"] = "folder-down";
  ICON_TYPES["folder-important"] = "folder-important";
  ICON_TYPES["folder-minus"] = "folder-minus";
  ICON_TYPES["folder-open"] = "folder-open";
  ICON_TYPES["folder-open-2"] = "folder-open-2";
  ICON_TYPES["folder-person"] = "folder-person";
  ICON_TYPES["folder-plus"] = "folder-plus";
  ICON_TYPES["folder-search"] = "folder-search";
  ICON_TYPES["folder-share"] = "folder-share";
  ICON_TYPES["folder-star"] = "folder-star";
  ICON_TYPES["folder-up"] = "folder-up";
  ICON_TYPES["folder-zip"] = "folder-zip";
  ICON_TYPES["font-family"] = "font-family";
  ICON_TYPES["font-size"] = "font-size";
  ICON_TYPES["food-can"] = "food-can";
  ICON_TYPES["forbid"] = "forbid";
  ICON_TYPES["forbid-2"] = "forbid-2";
  ICON_TYPES["fork"] = "fork";
  ICON_TYPES["fork-2"] = "fork-2";
  ICON_TYPES["forward"] = "forward";
  ICON_TYPES["fountain-pen"] = "fountain-pen";
  ICON_TYPES["frame"] = "frame";
  ICON_TYPES["framer"] = "framer";
  ICON_TYPES["frying-pan"] = "frying-pan";
  ICON_TYPES["fullscreen"] = "fullscreen";
  ICON_TYPES["gallery-view"] = "gallery-view";
  ICON_TYPES["gaming"] = "gaming";
  ICON_TYPES["garage"] = "garage";
  ICON_TYPES["garden-hose"] = "garden-hose";
  ICON_TYPES["gauge"] = "gauge";
  ICON_TYPES["gavel"] = "gavel";
  ICON_TYPES["gbp"] = "gbp";
  ICON_TYPES["gemini"] = "gemini";
  ICON_TYPES["ghost"] = "ghost";
  ICON_TYPES["gif"] = "gif";
  ICON_TYPES["gift"] = "gift";
  ICON_TYPES["git-branch"] = "git-branch";
  ICON_TYPES["git-commit"] = "git-commit";
  ICON_TYPES["git-diff"] = "git-diff";
  ICON_TYPES["git-fork"] = "git-fork";
  ICON_TYPES["git-merge"] = "git-merge";
  ICON_TYPES["git-pull-request"] = "git-pull-request";
  ICON_TYPES["github"] = "github";
  ICON_TYPES["giving"] = "giving";
  ICON_TYPES["giving-money"] = "giving-money";
  ICON_TYPES["glass-spill"] = "glass-spill";
  ICON_TYPES["globe"] = "globe";
  ICON_TYPES["gmail"] = "gmail";
  ICON_TYPES["golden-gate-bridge"] = "golden-gate-bridge";
  ICON_TYPES["golf"] = "golf";
  ICON_TYPES["golf-ball"] = "golf-ball";
  ICON_TYPES["google"] = "google";
  ICON_TYPES["google-drive"] = "google-drive";
  ICON_TYPES["grapes"] = "grapes";
  ICON_TYPES["gravestone"] = "gravestone";
  ICON_TYPES["grid"] = "grid";
  ICON_TYPES["grid-2"] = "grid-2";
  ICON_TYPES["grid-3"] = "grid-3";
  ICON_TYPES["grid-masonry"] = "grid-masonry";
  ICON_TYPES["grid-masonry-2"] = "grid-masonry-2";
  ICON_TYPES["guitar"] = "guitar";
  ICON_TYPES["gun"] = "gun";
  ICON_TYPES["hair-clippers"] = "hair-clippers";
  ICON_TYPES["hair-pin"] = "hair-pin";
  ICON_TYPES["hairdryer"] = "hairdryer";
  ICON_TYPES["half-circle-bottom"] = "half-circle-bottom";
  ICON_TYPES["half-circle-top"] = "half-circle-top";
  ICON_TYPES["hammer"] = "hammer";
  ICON_TYPES["hand"] = "hand";
  ICON_TYPES["hand-important"] = "hand-important";
  ICON_TYPES["hand-lock"] = "hand-lock";
  ICON_TYPES["hand-minus"] = "hand-minus";
  ICON_TYPES["hand-plus"] = "hand-plus";
  ICON_TYPES["hard-drive"] = "hard-drive";
  ICON_TYPES["hard-drive-2"] = "hard-drive-2";
  ICON_TYPES["hard-drive-storage"] = "hard-drive-storage";
  ICON_TYPES["hashtag"] = "hashtag";
  ICON_TYPES["hat"] = "hat";
  ICON_TYPES["heading"] = "heading";
  ICON_TYPES["headphones"] = "headphones";
  ICON_TYPES["headphones-2"] = "headphones-2";
  ICON_TYPES["headphones-3"] = "headphones-3";
  ICON_TYPES["headset"] = "headset";
  ICON_TYPES["health"] = "health";
  ICON_TYPES["heart"] = "heart";
  ICON_TYPES["heart-minus"] = "heart-minus";
  ICON_TYPES["heart-plus"] = "heart-plus";
  ICON_TYPES["heart-rate"] = "heart-rate";
  ICON_TYPES["hearts"] = "hearts";
  ICON_TYPES["height"] = "height";
  ICON_TYPES["helicopter"] = "helicopter";
  ICON_TYPES["help"] = "help";
  ICON_TYPES["help-circle"] = "help-circle";
  ICON_TYPES["highlighter"] = "highlighter";
  ICON_TYPES["home"] = "home";
  ICON_TYPES["home-wifi"] = "home-wifi";
  ICON_TYPES["hook"] = "hook";
  ICON_TYPES["hourglass"] = "hourglass";
  ICON_TYPES["hubspot"] = "hubspot";
  ICON_TYPES["humidity-high"] = "humidity-high";
  ICON_TYPES["humidity-low"] = "humidity-low";
  ICON_TYPES["humidity-sensor"] = "humidity-sensor";
  ICON_TYPES["ice"] = "ice";
  ICON_TYPES["ice-cream"] = "ice-cream";
  ICON_TYPES["id-card"] = "id-card";
  ICON_TYPES["inbox"] = "inbox";
  ICON_TYPES["incognito"] = "incognito";
  ICON_TYPES["indent-left"] = "indent-left";
  ICON_TYPES["indent-right"] = "indent-right";
  ICON_TYPES["information"] = "information";
  ICON_TYPES["ingredients"] = "ingredients";
  ICON_TYPES["input-field"] = "input-field";
  ICON_TYPES["insights-analytics"] = "insights-analytics";
  ICON_TYPES["instagram"] = "instagram";
  ICON_TYPES["iphone"] = "iphone";
  ICON_TYPES["iphone-2"] = "iphone-2";
  ICON_TYPES["iphone-3"] = "iphone-3";
  ICON_TYPES["iphone-dual-camera"] = "iphone-dual-camera";
  ICON_TYPES["iphone-pro-camera"] = "iphone-pro-camera";
  ICON_TYPES["iron"] = "iron";
  ICON_TYPES["italic"] = "italic";
  ICON_TYPES["jetski"] = "jetski";
  ICON_TYPES["jpg"] = "jpg";
  ICON_TYPES["kerning"] = "kerning";
  ICON_TYPES["kettle"] = "kettle";
  ICON_TYPES["kettle-2"] = "kettle-2";
  ICON_TYPES["key"] = "key";
  ICON_TYPES["keyboard"] = "keyboard";
  ICON_TYPES["keyboard-2"] = "keyboard-2";
  ICON_TYPES["keyhole"] = "keyhole";
  ICON_TYPES["keys"] = "keys";
  ICON_TYPES["kiosk"] = "kiosk";
  ICON_TYPES["knife"] = "knife";
  ICON_TYPES["knife-2"] = "knife-2";
  ICON_TYPES["knowledge-base"] = "knowledge-base";
  ICON_TYPES["ladder"] = "ladder";
  ICON_TYPES["ladder-2"] = "ladder-2";
  ICON_TYPES["lamp"] = "lamp";
  ICON_TYPES["landscape"] = "landscape";
  ICON_TYPES["language"] = "language";
  ICON_TYPES["language-1"] = "language-1";
  ICON_TYPES["languages"] = "languages";
  ICON_TYPES["laptop"] = "laptop";
  ICON_TYPES["laptop-2"] = "laptop-2";
  ICON_TYPES["laptop-and-phone"] = "laptop-and-phone";
  ICON_TYPES["laptop-check"] = "laptop-check";
  ICON_TYPES["laptop-error"] = "laptop-error";
  ICON_TYPES["layer-1"] = "layer-1";
  ICON_TYPES["layer-2"] = "layer-2";
  ICON_TYPES["layer-3"] = "layer-3";
  ICON_TYPES["layers"] = "layers";
  ICON_TYPES["layout-bottom"] = "layout-bottom";
  ICON_TYPES["layout-left"] = "layout-left";
  ICON_TYPES["layout-right"] = "layout-right";
  ICON_TYPES["layout-top"] = "layout-top";
  ICON_TYPES["leaderboard"] = "leaderboard";
  ICON_TYPES["leaf"] = "leaf";
  ICON_TYPES["leaf-2"] = "leaf-2";
  ICON_TYPES["leaf-3"] = "leaf-3";
  ICON_TYPES["lego"] = "lego";
  ICON_TYPES["leo"] = "leo";
  ICON_TYPES["letter-a-circle"] = "letter-a-circle";
  ICON_TYPES["letter-b-circle"] = "letter-b-circle";
  ICON_TYPES["letter-c-circle"] = "letter-c-circle";
  ICON_TYPES["letter-spacing"] = "letter-spacing";
  ICON_TYPES["libra"] = "libra";
  ICON_TYPES["life-jacket"] = "life-jacket";
  ICON_TYPES["light-bulb"] = "light-bulb";
  ICON_TYPES["light-ceiling"] = "light-ceiling";
  ICON_TYPES["light-off"] = "light-off";
  ICON_TYPES["light-switch"] = "light-switch";
  ICON_TYPES["lightning"] = "lightning";
  ICON_TYPES["line-height"] = "line-height";
  ICON_TYPES["line-height-2"] = "line-height-2";
  ICON_TYPES["link"] = "link";
  ICON_TYPES["link-break"] = "link-break";
  ICON_TYPES["linked"] = "linked";
  ICON_TYPES["linkedin"] = "linkedin";
  ICON_TYPES["livestream"] = "livestream";
  ICON_TYPES["loading"] = "loading";
  ICON_TYPES["location"] = "location";
  ICON_TYPES["lock"] = "lock";
  ICON_TYPES["lock-unlocked"] = "lock-unlocked";
  ICON_TYPES["log-in"] = "log-in";
  ICON_TYPES["log-out"] = "log-out";
  ICON_TYPES["love"] = "love";
  ICON_TYPES["luggage-carousel"] = "luggage-carousel";
  ICON_TYPES["lungs"] = "lungs";
  ICON_TYPES["magic-hat"] = "magic-hat";
  ICON_TYPES["magic-mouse"] = "magic-mouse";
  ICON_TYPES["magnet"] = "magnet";
  ICON_TYPES["magnet-bolt"] = "magnet-bolt";
  ICON_TYPES["mail"] = "mail";
  ICON_TYPES["mail-open"] = "mail-open";
  ICON_TYPES["mail-open-cross"] = "mail-open-cross";
  ICON_TYPES["mail-open-cross-1"] = "mail-open-cross-1";
  ICON_TYPES["mailbox"] = "mailbox";
  ICON_TYPES["male"] = "male";
  ICON_TYPES["male-1"] = "male-1";
  ICON_TYPES["map"] = "map";
  ICON_TYPES["map-2"] = "map-2";
  ICON_TYPES["mask"] = "mask";
  ICON_TYPES["mask-2"] = "mask-2";
  ICON_TYPES["maximize"] = "maximize";
  ICON_TYPES["maximize-2"] = "maximize-2";
  ICON_TYPES["medical"] = "medical";
  ICON_TYPES["menu"] = "menu";
  ICON_TYPES["menu-2"] = "menu-2";
  ICON_TYPES["message"] = "message";
  ICON_TYPES["messages"] = "messages";
  ICON_TYPES["microphone"] = "microphone";
  ICON_TYPES["microphone-2"] = "microphone-2";
  ICON_TYPES["microphone-mute"] = "microphone-mute";
  ICON_TYPES["microwave"] = "microwave";
  ICON_TYPES["milk"] = "milk";
  ICON_TYPES["mini-fridge"] = "mini-fridge";
  ICON_TYPES["minimize"] = "minimize";
  ICON_TYPES["minimize-2"] = "minimize-2";
  ICON_TYPES["minus"] = "minus";
  ICON_TYPES["minus-circle"] = "minus-circle";
  ICON_TYPES["mirror"] = "mirror";
  ICON_TYPES["mirror-1"] = "mirror-1";
  ICON_TYPES["mirror-horizontal"] = "mirror-horizontal";
  ICON_TYPES["mobile"] = "mobile";
  ICON_TYPES["money"] = "money";
  ICON_TYPES["money-bag"] = "money-bag";
  ICON_TYPES["monitor"] = "monitor";
  ICON_TYPES["monitor-1"] = "monitor-1";
  ICON_TYPES["moon"] = "moon";
  ICON_TYPES["moon-2"] = "moon-2";
  ICON_TYPES["motion-sensor"] = "motion-sensor";
  ICON_TYPES["mountain"] = "mountain";
  ICON_TYPES["mouse"] = "mouse";
  ICON_TYPES["move"] = "move";
  ICON_TYPES["mug"] = "mug";
  ICON_TYPES["mug-2"] = "mug-2";
  ICON_TYPES["mug-3"] = "mug-3";
  ICON_TYPES["multiple-folders"] = "multiple-folders";
  ICON_TYPES["music"] = "music";
  ICON_TYPES["music-note"] = "music-note";
  ICON_TYPES["navigation"] = "navigation";
  ICON_TYPES["needle"] = "needle";
  ICON_TYPES["network"] = "network";
  ICON_TYPES["new"] = "new";
  ICON_TYPES["new-hire"] = "new-hire";
  ICON_TYPES["newspaper"] = "newspaper";
  ICON_TYPES["no-avatar"] = "no-avatar";
  ICON_TYPES["no-avatar-square"] = "no-avatar-square";
  ICON_TYPES["no-location"] = "no-location";
  ICON_TYPES["no-parking"] = "no-parking";
  ICON_TYPES["no-pin"] = "no-pin";
  ICON_TYPES["no-weed"] = "no-weed";
  ICON_TYPES["nordvpn"] = "nordvpn";
  ICON_TYPES["north"] = "north";
  ICON_TYPES["nose"] = "nose";
  ICON_TYPES["nose-bleed"] = "nose-bleed";
  ICON_TYPES["notebook"] = "notebook";
  ICON_TYPES["nuclear"] = "nuclear";
  ICON_TYPES["nut"] = "nut";
  ICON_TYPES["octagon"] = "octagon";
  ICON_TYPES["one-finger"] = "one-finger";
  ICON_TYPES["onion"] = "onion";
  ICON_TYPES["open-pane"] = "open-pane";
  ICON_TYPES["option"] = "option";
  ICON_TYPES["ordered-list"] = "ordered-list";
  ICON_TYPES["package"] = "package";
  ICON_TYPES["padding"] = "padding";
  ICON_TYPES["page-flip"] = "page-flip";
  ICON_TYPES["paintbrush"] = "paintbrush";
  ICON_TYPES["paintbrush-2"] = "paintbrush-2";
  ICON_TYPES["paintbrush-3"] = "paintbrush-3";
  ICON_TYPES["paintbucket"] = "paintbucket";
  ICON_TYPES["paintbucket-2"] = "paintbucket-2";
  ICON_TYPES["paintbucket-3"] = "paintbucket-3";
  ICON_TYPES["paperclip"] = "paperclip";
  ICON_TYPES["parenthesis"] = "parenthesis";
  ICON_TYPES["parking"] = "parking";
  ICON_TYPES["party"] = "party";
  ICON_TYPES["passport"] = "passport";
  ICON_TYPES["password"] = "password";
  ICON_TYPES["pause"] = "pause";
  ICON_TYPES["pawn"] = "pawn";
  ICON_TYPES["pdf"] = "pdf";
  ICON_TYPES["peace"] = "peace";
  ICON_TYPES["pen"] = "pen";
  ICON_TYPES["pen-tool"] = "pen-tool";
  ICON_TYPES["pen-tool-2"] = "pen-tool-2";
  ICON_TYPES["pencil"] = "pencil";
  ICON_TYPES["pencil-2"] = "pencil-2";
  ICON_TYPES["pencil-book"] = "pencil-book";
  ICON_TYPES["people"] = "people";
  ICON_TYPES["pepper"] = "pepper";
  ICON_TYPES["percentage"] = "percentage";
  ICON_TYPES["periodic-table"] = "periodic-table";
  ICON_TYPES["person"] = "person";
  ICON_TYPES["person-check"] = "person-check";
  ICON_TYPES["person-cross"] = "person-cross";
  ICON_TYPES["person-with-luggage"] = "person-with-luggage";
  ICON_TYPES["petrol"] = "petrol";
  ICON_TYPES["pharmacy"] = "pharmacy";
  ICON_TYPES["phone"] = "phone";
  ICON_TYPES["phone-call"] = "phone-call";
  ICON_TYPES["phone-call-cross"] = "phone-call-cross";
  ICON_TYPES["phone-call-forward"] = "phone-call-forward";
  ICON_TYPES["phone-call-hang-up"] = "phone-call-hang-up";
  ICON_TYPES["phone-call-incoming"] = "phone-call-incoming";
  ICON_TYPES["phone-call-outgoing"] = "phone-call-outgoing";
  ICON_TYPES["phone-check"] = "phone-check";
  ICON_TYPES["phone-signal"] = "phone-signal";
  ICON_TYPES["photo"] = "photo";
  ICON_TYPES["photo-error"] = "photo-error";
  ICON_TYPES["photo-film"] = "photo-film";
  ICON_TYPES["photo-frame"] = "photo-frame";
  ICON_TYPES["photo-hide"] = "photo-hide";
  ICON_TYPES["photo-lens"] = "photo-lens";
  ICON_TYPES["photo-minus"] = "photo-minus";
  ICON_TYPES["photo-plus"] = "photo-plus";
  ICON_TYPES["photoshop"] = "photoshop";
  ICON_TYPES["picture-in-picture"] = "picture-in-picture";
  ICON_TYPES["pie-chart"] = "pie-chart";
  ICON_TYPES["piggybank"] = "piggybank";
  ICON_TYPES["pill"] = "pill";
  ICON_TYPES["pill-2"] = "pill-2";
  ICON_TYPES["pills"] = "pills";
  ICON_TYPES["pin"] = "pin";
  ICON_TYPES["pin-on-map"] = "pin-on-map";
  ICON_TYPES["pin-tack"] = "pin-tack";
  ICON_TYPES["pin-tack-2"] = "pin-tack-2";
  ICON_TYPES["pin-tack-3"] = "pin-tack-3";
  ICON_TYPES["pipe"] = "pipe";
  ICON_TYPES["pisces"] = "pisces";
  ICON_TYPES["pizza"] = "pizza";
  ICON_TYPES["pizza-2"] = "pizza-2";
  ICON_TYPES["plane"] = "plane";
  ICON_TYPES["plane-2"] = "plane-2";
  ICON_TYPES["plane-landing"] = "plane-landing";
  ICON_TYPES["plane-take-off"] = "plane-take-off";
  ICON_TYPES["planet"] = "planet";
  ICON_TYPES["play"] = "play";
  ICON_TYPES["plug"] = "plug";
  ICON_TYPES["plug-in"] = "plug-in";
  ICON_TYPES["plug-off"] = "plug-off";
  ICON_TYPES["plug-on"] = "plug-on";
  ICON_TYPES["plus"] = "plus";
  ICON_TYPES["plus-circle"] = "plus-circle";
  ICON_TYPES["plus-minus"] = "plus-minus";
  ICON_TYPES["png"] = "png";
  ICON_TYPES["pokeball"] = "pokeball";
  ICON_TYPES["polaroids"] = "polaroids";
  ICON_TYPES["poll"] = "poll";
  ICON_TYPES["polywork"] = "polywork";
  ICON_TYPES["poo"] = "poo";
  ICON_TYPES["popcorn"] = "popcorn";
  ICON_TYPES["portrait"] = "portrait";
  ICON_TYPES["pot"] = "pot";
  ICON_TYPES["pot-2"] = "pot-2";
  ICON_TYPES["power"] = "power";
  ICON_TYPES["power-plant"] = "power-plant";
  ICON_TYPES["pram"] = "pram";
  ICON_TYPES["presentation"] = "presentation";
  ICON_TYPES["press"] = "press";
  ICON_TYPES["print"] = "print";
  ICON_TYPES["projector"] = "projector";
  ICON_TYPES["puzzle"] = "puzzle";
  ICON_TYPES["pyramid"] = "pyramid";
  ICON_TYPES["qr-code"] = "qr-code";
  ICON_TYPES["qr-code-2"] = "qr-code-2";
  ICON_TYPES["question-mark"] = "question-mark";
  ICON_TYPES["question-mark-circle"] = "question-mark-circle";
  ICON_TYPES["quote"] = "quote";
  ICON_TYPES["radio"] = "radio";
  ICON_TYPES["rain"] = "rain";
  ICON_TYPES["razor"] = "razor";
  ICON_TYPES["receipt"] = "receipt";
  ICON_TYPES["receive-money"] = "receive-money";
  ICON_TYPES["reddit"] = "reddit";
  ICON_TYPES["redo"] = "redo";
  ICON_TYPES["refresh"] = "refresh";
  ICON_TYPES["refresh-2"] = "refresh-2";
  ICON_TYPES["refresh-3"] = "refresh-3";
  ICON_TYPES["repeat"] = "repeat";
  ICON_TYPES["reply"] = "reply";
  ICON_TYPES["reports-chart"] = "reports-chart";
  ICON_TYPES["rewind"] = "rewind";
  ICON_TYPES["robot"] = "robot";
  ICON_TYPES["rocket"] = "rocket";
  ICON_TYPES["rollercoaster"] = "rollercoaster";
  ICON_TYPES["rotate"] = "rotate";
  ICON_TYPES["rotate-2"] = "rotate-2";
  ICON_TYPES["rounded-corners-bl"] = "rounded-corners-bl";
  ICON_TYPES["rounded-corners-br"] = "rounded-corners-br";
  ICON_TYPES["rounded-corners-tl"] = "rounded-corners-tl";
  ICON_TYPES["rounded-corners-tr"] = "rounded-corners-tr";
  ICON_TYPES["route"] = "route";
  ICON_TYPES["router"] = "router";
  ICON_TYPES["rows"] = "rows";
  ICON_TYPES["rows-2"] = "rows-2";
  ICON_TYPES["rss"] = "rss";
  ICON_TYPES["rucksack"] = "rucksack";
  ICON_TYPES["ruler"] = "ruler";
  ICON_TYPES["rupee"] = "rupee";
  ICON_TYPES["safe"] = "safe";
  ICON_TYPES["safety-pin"] = "safety-pin";
  ICON_TYPES["sagittarius"] = "sagittarius";
  ICON_TYPES["salesforce"] = "salesforce";
  ICON_TYPES["salt"] = "salt";
  ICON_TYPES["satellite"] = "satellite";
  ICON_TYPES["scale"] = "scale";
  ICON_TYPES["scale-tool"] = "scale-tool";
  ICON_TYPES["scales"] = "scales";
  ICON_TYPES["scan-minus"] = "scan-minus";
  ICON_TYPES["scan-plus"] = "scan-plus";
  ICON_TYPES["scissors"] = "scissors";
  ICON_TYPES["scooter"] = "scooter";
  ICON_TYPES["screw"] = "screw";
  ICON_TYPES["screwdriver"] = "screwdriver";
  ICON_TYPES["scroll"] = "scroll";
  ICON_TYPES["scrubber"] = "scrubber";
  ICON_TYPES["search"] = "search";
  ICON_TYPES["search-area"] = "search-area";
  ICON_TYPES["search-field"] = "search-field";
  ICON_TYPES["search-globe"] = "search-globe";
  ICON_TYPES["seedlings"] = "seedlings";
  ICON_TYPES["seeds"] = "seeds";
  ICON_TYPES["self-service"] = "self-service";
  ICON_TYPES["send"] = "send";
  ICON_TYPES["send-money"] = "send-money";
  ICON_TYPES["send-to-back"] = "send-to-back";
  ICON_TYPES["send-to-back-2"] = "send-to-back-2";
  ICON_TYPES["send-to-front"] = "send-to-front";
  ICON_TYPES["server"] = "server";
  ICON_TYPES["service-bell"] = "service-bell";
  ICON_TYPES["settings"] = "settings";
  ICON_TYPES["settings-2"] = "settings-2";
  ICON_TYPES["settings-sliders"] = "settings-sliders";
  ICON_TYPES["sewer"] = "sewer";
  ICON_TYPES["shape"] = "shape";
  ICON_TYPES["shape-rotate"] = "shape-rotate";
  ICON_TYPES["share"] = "share";
  ICON_TYPES["share-2"] = "share-2";
  ICON_TYPES["share-3"] = "share-3";
  ICON_TYPES["shield"] = "shield";
  ICON_TYPES["shield-cross"] = "shield-cross";
  ICON_TYPES["shield-lock"] = "shield-lock";
  ICON_TYPES["shield-tick"] = "shield-tick";
  ICON_TYPES["shield-unlock"] = "shield-unlock";
  ICON_TYPES["shield-warning"] = "shield-warning";
  ICON_TYPES["shipment"] = "shipment";
  ICON_TYPES["shipment-check"] = "shipment-check";
  ICON_TYPES["shipment-cross"] = "shipment-cross";
  ICON_TYPES["shop-sign"] = "shop-sign";
  ICON_TYPES["shopping-bag"] = "shopping-bag";
  ICON_TYPES["shopping-basket"] = "shopping-basket";
  ICON_TYPES["shopping-basket-check"] = "shopping-basket-check";
  ICON_TYPES["shopping-basket-cross"] = "shopping-basket-cross";
  ICON_TYPES["shopping-cart"] = "shopping-cart";
  ICON_TYPES["shower"] = "shower";
  ICON_TYPES["shower-2"] = "shower-2";
  ICON_TYPES["shuffle"] = "shuffle";
  ICON_TYPES["side-profile"] = "side-profile";
  ICON_TYPES["sidebar"] = "sidebar";
  ICON_TYPES["sign"] = "sign";
  ICON_TYPES["signage"] = "signage";
  ICON_TYPES["single-bed"] = "single-bed";
  ICON_TYPES["skateboard"] = "skateboard";
  ICON_TYPES["sketch"] = "sketch";
  ICON_TYPES["skew"] = "skew";
  ICON_TYPES["ski-mask"] = "ski-mask";
  ICON_TYPES["skip-back"] = "skip-back";
  ICON_TYPES["skip-forward"] = "skip-forward";
  ICON_TYPES["skull"] = "skull";
  ICON_TYPES["slash"] = "slash";
  ICON_TYPES["slice"] = "slice";
  ICON_TYPES["slide-menu"] = "slide-menu";
  ICON_TYPES["sliders-horizontal"] = "sliders-horizontal";
  ICON_TYPES["sliders-vertical"] = "sliders-vertical";
  ICON_TYPES["slideshow"] = "slideshow";
  ICON_TYPES["smartphone"] = "smartphone";
  ICON_TYPES["snail"] = "snail";
  ICON_TYPES["snapchat"] = "snapchat";
  ICON_TYPES["snorkel"] = "snorkel";
  ICON_TYPES["snow-mobile"] = "snow-mobile";
  ICON_TYPES["soap-pump"] = "soap-pump";
  ICON_TYPES["soccer-pitch"] = "soccer-pitch";
  ICON_TYPES["solar-panels"] = "solar-panels";
  ICON_TYPES["sombrero"] = "sombrero";
  ICON_TYPES["sort-ascending"] = "sort-ascending";
  ICON_TYPES["sort-descending"] = "sort-descending";
  ICON_TYPES["sos"] = "sos";
  ICON_TYPES["soundcloud"] = "soundcloud";
  ICON_TYPES["south"] = "south";
  ICON_TYPES["spacing-horizontal"] = "spacing-horizontal";
  ICON_TYPES["spades"] = "spades";
  ICON_TYPES["sparkles"] = "sparkles";
  ICON_TYPES["sparkles-2"] = "sparkles-2";
  ICON_TYPES["speaker"] = "speaker";
  ICON_TYPES["speaker-2"] = "speaker-2";
  ICON_TYPES["speaker-mute"] = "speaker-mute";
  ICON_TYPES["speaker-mute-2"] = "speaker-mute-2";
  ICON_TYPES["speaker-off"] = "speaker-off";
  ICON_TYPES["speaker-volume-high"] = "speaker-volume-high";
  ICON_TYPES["speaker-volume-low"] = "speaker-volume-low";
  ICON_TYPES["spectacles"] = "spectacles";
  ICON_TYPES["spectacles-2"] = "spectacles-2";
  ICON_TYPES["speech-bubble"] = "speech-bubble";
  ICON_TYPES["speech-bubble-minus"] = "speech-bubble-minus";
  ICON_TYPES["speech-bubble-plus"] = "speech-bubble-plus";
  ICON_TYPES["speech-important"] = "speech-important";
  ICON_TYPES["speed-fast"] = "speed-fast";
  ICON_TYPES["speed-gauge"] = "speed-gauge";
  ICON_TYPES["speed-slow"] = "speed-slow";
  ICON_TYPES["sphere"] = "sphere";
  ICON_TYPES["spider"] = "spider";
  ICON_TYPES["spinner"] = "spinner";
  ICON_TYPES["spoon"] = "spoon";
  ICON_TYPES["spoon-2"] = "spoon-2";
  ICON_TYPES["spotify"] = "spotify";
  ICON_TYPES["spray-paint"] = "spray-paint";
  ICON_TYPES["spreadsheet"] = "spreadsheet";
  ICON_TYPES["square"] = "square";
  ICON_TYPES["square-check"] = "square-check";
  ICON_TYPES["square-cross"] = "square-cross";
  ICON_TYPES["square-frame"] = "square-frame";
  ICON_TYPES["square-interface"] = "square-interface";
  ICON_TYPES["square-intersect"] = "square-intersect";
  ICON_TYPES["square-minus"] = "square-minus";
  ICON_TYPES["square-plus"] = "square-plus";
  ICON_TYPES["stack-overflow"] = "stack-overflow";
  ICON_TYPES["stairs"] = "stairs";
  ICON_TYPES["stamp"] = "stamp";
  ICON_TYPES["star"] = "star";
  ICON_TYPES["steering-wheel"] = "steering-wheel";
  ICON_TYPES["stethoscope"] = "stethoscope";
  ICON_TYPES["sticker"] = "sticker";
  ICON_TYPES["sticky-note"] = "sticky-note";
  ICON_TYPES["stiletto"] = "stiletto";
  ICON_TYPES["stop"] = "stop";
  ICON_TYPES["stream-to-tv"] = "stream-to-tv";
  ICON_TYPES["stream-to-tv-2"] = "stream-to-tv-2";
  ICON_TYPES["strikethrough"] = "strikethrough";
  ICON_TYPES["subscription"] = "subscription";
  ICON_TYPES["substitute"] = "substitute";
  ICON_TYPES["sun"] = "sun";
  ICON_TYPES["sunrise"] = "sunrise";
  ICON_TYPES["sunrise-2"] = "sunrise-2";
  ICON_TYPES["swap"] = "swap";
  ICON_TYPES["swiss-army-knife"] = "swiss-army-knife";
  ICON_TYPES["switch"] = "switch";
  ICON_TYPES["switch-2"] = "switch-2";
  ICON_TYPES["t-shirt"] = "t-shirt";
  ICON_TYPES["table-columns"] = "table-columns";
  ICON_TYPES["table-rows"] = "table-rows";
  ICON_TYPES["tablet"] = "tablet";
  ICON_TYPES["tablet-drawing"] = "tablet-drawing";
  ICON_TYPES["tag"] = "tag";
  ICON_TYPES["tag-2"] = "tag-2";
  ICON_TYPES["tag-add"] = "tag-add";
  ICON_TYPES["tap-left"] = "tap-left";
  ICON_TYPES["tap-right"] = "tap-right";
  ICON_TYPES["target"] = "target";
  ICON_TYPES["taurus"] = "taurus";
  ICON_TYPES["telegram"] = "telegram";
  ICON_TYPES["telescope"] = "telescope";
  ICON_TYPES["temperature"] = "temperature";
  ICON_TYPES["temperature-high"] = "temperature-high";
  ICON_TYPES["temperature-low"] = "temperature-low";
  ICON_TYPES["tepee"] = "tepee";
  ICON_TYPES["text"] = "text";
  ICON_TYPES["text-align-center"] = "text-align-center";
  ICON_TYPES["text-align-justified"] = "text-align-justified";
  ICON_TYPES["text-align-left"] = "text-align-left";
  ICON_TYPES["text-align-right"] = "text-align-right";
  ICON_TYPES["text-capitalise"] = "text-capitalise";
  ICON_TYPES["text-lowercase"] = "text-lowercase";
  ICON_TYPES["text-uppercase"] = "text-uppercase";
  ICON_TYPES["thumbs-down"] = "thumbs-down";
  ICON_TYPES["thumbs-up"] = "thumbs-up";
  ICON_TYPES["ticket"] = "ticket";
  ICON_TYPES["tickets"] = "tickets";
  ICON_TYPES["tiktok"] = "tiktok";
  ICON_TYPES["timer"] = "timer";
  ICON_TYPES["timer-2"] = "timer-2";
  ICON_TYPES["timer-3"] = "timer-3";
  ICON_TYPES["timer-4"] = "timer-4";
  ICON_TYPES["timer-checkmark"] = "timer-checkmark";
  ICON_TYPES["timer-snooze"] = "timer-snooze";
  ICON_TYPES["toggle-left"] = "toggle-left";
  ICON_TYPES["toggle-right"] = "toggle-right";
  ICON_TYPES["toilet-roll"] = "toilet-roll";
  ICON_TYPES["tomahawk"] = "tomahawk";
  ICON_TYPES["toolbox"] = "toolbox";
  ICON_TYPES["tooth"] = "tooth";
  ICON_TYPES["tooth-pain"] = "tooth-pain";
  ICON_TYPES["top-hat"] = "top-hat";
  ICON_TYPES["toys"] = "toys";
  ICON_TYPES["traffic-lights"] = "traffic-lights";
  ICON_TYPES["trailer"] = "trailer";
  ICON_TYPES["train"] = "train";
  ICON_TYPES["train-arriving"] = "train-arriving";
  ICON_TYPES["train-departing"] = "train-departing";
  ICON_TYPES["trampoline"] = "trampoline";
  ICON_TYPES["trash"] = "trash";
  ICON_TYPES["trash-2"] = "trash-2";
  ICON_TYPES["trash-can"] = "trash-can";
  ICON_TYPES["tree"] = "tree";
  ICON_TYPES["tree-2"] = "tree-2";
  ICON_TYPES["trees"] = "trees";
  ICON_TYPES["trending-down"] = "trending-down";
  ICON_TYPES["trending-up"] = "trending-up";
  ICON_TYPES["triangle"] = "triangle";
  ICON_TYPES["triangle-circle"] = "triangle-circle";
  ICON_TYPES["triangle-ruler"] = "triangle-ruler";
  ICON_TYPES["trolly"] = "trolly";
  ICON_TYPES["trophy"] = "trophy";
  ICON_TYPES["trousers"] = "trousers";
  ICON_TYPES["truck"] = "truck";
  ICON_TYPES["truck-2"] = "truck-2";
  ICON_TYPES["turn-volume-high"] = "turn-volume-high";
  ICON_TYPES["turn-volume-low"] = "turn-volume-low";
  ICON_TYPES["turntable"] = "turntable";
  ICON_TYPES["twitch"] = "twitch";
  ICON_TYPES["twitter"] = "twitter";
  ICON_TYPES["two-checkmarks"] = "two-checkmarks";
  ICON_TYPES["two-fingers"] = "two-fingers";
  ICON_TYPES["two-hearts"] = "two-hearts";
  ICON_TYPES["uae-dirham"] = "uae-dirham";
  ICON_TYPES["ufo"] = "ufo";
  ICON_TYPES["ufo-2"] = "ufo-2";
  ICON_TYPES["ui-bottom"] = "ui-bottom";
  ICON_TYPES["umbrella"] = "umbrella";
  ICON_TYPES["umbrella-2"] = "umbrella-2";
  ICON_TYPES["underline"] = "underline";
  ICON_TYPES["undo"] = "undo";
  ICON_TYPES["union"] = "union";
  ICON_TYPES["union-mask"] = "union-mask";
  ICON_TYPES["unordered-list"] = "unordered-list";
  ICON_TYPES["unpin"] = "unpin";
  ICON_TYPES["unread-message"] = "unread-message";
  ICON_TYPES["upload"] = "upload";
  ICON_TYPES["upload-cloud"] = "upload-cloud";
  ICON_TYPES["upstairs"] = "upstairs";
  ICON_TYPES["usb"] = "usb";
  ICON_TYPES["user"] = "user";
  ICON_TYPES["user-check"] = "user-check";
  ICON_TYPES["user-circle"] = "user-circle";
  ICON_TYPES["user-cross"] = "user-cross";
  ICON_TYPES["user-minus"] = "user-minus";
  ICON_TYPES["user-plus"] = "user-plus";
  ICON_TYPES["users"] = "users";
  ICON_TYPES["users-check"] = "users-check";
  ICON_TYPES["users-cross"] = "users-cross";
  ICON_TYPES["users-minus"] = "users-minus";
  ICON_TYPES["users-plus"] = "users-plus";
  ICON_TYPES["vaccine"] = "vaccine";
  ICON_TYPES["vanity"] = "vanity";
  ICON_TYPES["vase"] = "vase";
  ICON_TYPES["verified"] = "verified";
  ICON_TYPES["vga-cable"] = "vga-cable";
  ICON_TYPES["vice-grip"] = "vice-grip";
  ICON_TYPES["video"] = "video";
  ICON_TYPES["video-camera"] = "video-camera";
  ICON_TYPES["video-camera-2"] = "video-camera-2";
  ICON_TYPES["video-camera-off"] = "video-camera-off";
  ICON_TYPES["video-camera-off-2"] = "video-camera-off-2";
  ICON_TYPES["virgo"] = "virgo";
  ICON_TYPES["virus"] = "virus";
  ICON_TYPES["voice-id"] = "voice-id";
  ICON_TYPES["voice-id-2"] = "voice-id-2";
  ICON_TYPES["voicemail"] = "voicemail";
  ICON_TYPES["volcano"] = "volcano";
  ICON_TYPES["vpn"] = "vpn";
  ICON_TYPES["vr"] = "vr";
  ICON_TYPES["wall-socket-uk"] = "wall-socket-uk";
  ICON_TYPES["wall-socket-usa"] = "wall-socket-usa";
  ICON_TYPES["wallet"] = "wallet";
  ICON_TYPES["wallpaper"] = "wallpaper";
  ICON_TYPES["wand"] = "wand";
  ICON_TYPES["warning-triangle"] = "warning-triangle";
  ICON_TYPES["washer"] = "washer";
  ICON_TYPES["waves"] = "waves";
  ICON_TYPES["weed"] = "weed";
  ICON_TYPES["west"] = "west";
  ICON_TYPES["wheat"] = "wheat";
  ICON_TYPES["wheel"] = "wheel";
  ICON_TYPES["width"] = "width";
  ICON_TYPES["wifi"] = "wifi";
  ICON_TYPES["wifi-high"] = "wifi-high";
  ICON_TYPES["wifi-low"] = "wifi-low";
  ICON_TYPES["wifi-medium"] = "wifi-medium";
  ICON_TYPES["wifi-no-connection"] = "wifi-no-connection";
  ICON_TYPES["wind"] = "wind";
  ICON_TYPES["wind-power"] = "wind-power";
  ICON_TYPES["windows"] = "windows";
  ICON_TYPES["wine"] = "wine";
  ICON_TYPES["wink"] = "wink";
  ICON_TYPES["wish-list"] = "wish-list";
  ICON_TYPES["world"] = "world";
  ICON_TYPES["wrench"] = "wrench";
  ICON_TYPES["wrench-2"] = "wrench-2";
  ICON_TYPES["write-note"] = "write-note";
  ICON_TYPES["x-axis"] = "x-axis";
  ICON_TYPES["xls"] = "xls";
  ICON_TYPES["y-axis"] = "y-axis";
  ICON_TYPES["yen"] = "yen";
  ICON_TYPES["yin-yang"] = "yin-yang";
  ICON_TYPES["zip-file"] = "zip-file";
  ICON_TYPES["zip-file-2"] = "zip-file-2";
  ICON_TYPES["zoom-in"] = "zoom-in";
  ICON_TYPES["zoom-out"] = "zoom-out";
})(ICON_TYPES || (ICON_TYPES = {}));

var Icon = function (_a) {
  var _b = _a.color,
    color = _b === void 0 ? "var(--color--text-default)" : _b,
    _c = _a.className,
    className = _c === void 0 ? "" : _c,
    id = _a.id,
    _d = _a.size,
    size = _d === void 0 ? "16px" : _d,
    type = _a.type;
  return Object.keys(ICON_TYPES).includes(type) ? jsx("div", {
    className: "Icon Icon--".concat(type, " ").concat(className),
    id: id,
    style: {
      background: color,
      width: size,
      height: size,
      mask: "center center / 100% auto url(\"/images/icons/".concat(type, ".svg\") no-repeat")
    }
  }) : null;
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ICON_BUTTON_SIZES;
(function (ICON_BUTTON_SIZES) {
  ICON_BUTTON_SIZES["S"] = "S";
  ICON_BUTTON_SIZES["M"] = "M";
})(ICON_BUTTON_SIZES || (ICON_BUTTON_SIZES = {}));
var ICON_BUTTON_VARIANTS;
(function (ICON_BUTTON_VARIANTS) {
  ICON_BUTTON_VARIANTS["DEFAULT"] = "DEFAULT";
  ICON_BUTTON_VARIANTS["SECONDARY"] = "SECONDARY";
  ICON_BUTTON_VARIANTS["OUTLINE"] = "OUTLINE";
})(ICON_BUTTON_VARIANTS || (ICON_BUTTON_VARIANTS = {}));
var IconButton = function (_a) {
  var _b;
  var LinkComponent = _a.LinkComponent,
    className = _a.className,
    disabled = _a.disabled,
    href = _a.href,
    iconType = _a.iconType,
    onClick = _a.onClick,
    _c = _a.size,
    size = _c === void 0 ? ICON_BUTTON_SIZES.M : _c,
    variant = _a.variant;
  var Component = href ? LinkComponent || function (props) {
    return jsx("a", __assign({}, props));
  } : function (props) {
    return jsx("button", __assign({}, props));
  };
  return jsx(Component, {
    className: generateConditionalClassName((_b = {
      IconButton: true,
      button: true,
      "button--secondary": variant === ICON_BUTTON_VARIANTS.SECONDARY,
      "button--outline": variant === ICON_BUTTON_VARIANTS.OUTLINE,
      disabled: !!disabled
    }, _b["".concat(className)] = !!className, _b)),
    href: href || "",
    onClick: onClick,
    style: {
      "--IconButton--size": Object.keys(ICON_BUTTON_SIZES).includes(size) ? "var(--spacing--".concat(size, ")") : size
    },
    children: jsx(Icon, {
      color: variant && variant !== ICON_BUTTON_VARIANTS.DEFAULT ? "var(--color--clay-1000)" : "var(--color--basics-white)",
      size: "calc(var(--IconButton--size) * 0.6)",
      type: iconType
    })
  });
};

var PLAY_BUTTON_VARIANTS;
(function (PLAY_BUTTON_VARIANTS) {
  PLAY_BUTTON_VARIANTS["DEFAULT"] = "DEFAULT";
  PLAY_BUTTON_VARIANTS["OUTLINE"] = "OUTLINE";
})(PLAY_BUTTON_VARIANTS || (PLAY_BUTTON_VARIANTS = {}));
var PLAY_BUTTON_SIZES;
(function (PLAY_BUTTON_SIZES) {
  PLAY_BUTTON_SIZES["XS"] = "XS";
  PLAY_BUTTON_SIZES["S"] = "S";
  PLAY_BUTTON_SIZES["M"] = "M";
  PLAY_BUTTON_SIZES["L"] = "L";
})(PLAY_BUTTON_SIZES || (PLAY_BUTTON_SIZES = {}));
var PlayButton = function (_a) {
  var children = _a.children,
    onClick = _a.onClick,
    _b = _a.size,
    size = _b === void 0 ? PLAY_BUTTON_SIZES.L : _b,
    _c = _a.variant,
    variant = _c === void 0 ? PLAY_BUTTON_VARIANTS.DEFAULT : _c;
  return jsxs("div", {
    "aria-label": onClick ? "Click to play video" : "",
    className: "PlayButton variant--".concat(variant, " size--").concat(size).concat(children ? " has-text" : ""),
    onClick: onClick,
    children: [children ? jsx("svg", {
      width: "27",
      height: "27",
      viewBox: "0 0 27 27",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsx("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.5 0C20.9558 0 27 6.04416 27 13.5C27 20.9558 20.9558 27 13.5 27C6.04416 27 0 20.9558 0 13.5C0 6.04416 6.04416 0 13.5 0ZM10.8704 7.36354C10.5481 7.16757 10.1379 7.2878 9.95361 7.6262C9.895 7.73758 9.86539 7.85843 9.86539 7.98317V19.0178C9.86539 19.4099 10.1673 19.7308 10.5357 19.7308C10.6528 19.7307 10.7659 19.6998 10.8704 19.6375L19.9133 14.1176C20.2357 13.9216 20.345 13.4847 20.1608 13.1461C20.1021 13.0347 20.0138 12.9458 19.9133 12.8834L10.8704 7.36354Z",
        fill: variant === PLAY_BUTTON_VARIANTS.OUTLINE ? "var(--color--action-default)" : "var(--color--basics-white)"
      })
    }) : jsx("svg", {
      width: "36",
      height: "40",
      viewBox: "0 0 36 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsx("path", {
        d: "M0.909103 2.39761V37.6046C0.909103 38.8554 1.92244 39.8788 3.16096 39.8788C3.55504 39.8788 3.93504 39.7793 4.28689 39.5803L34.687 21.9697C35.7707 21.3443 36.1366 19.9514 35.5174 18.8711C35.3203 18.5158 35.0248 18.2315 34.687 18.0325L4.28689 0.421923C3.20319 -0.203474 1.82392 0.180293 1.20466 1.26052C1.00762 1.61586 0.909103 1.99963 0.909103 2.39761Z",
        fill: variant === PLAY_BUTTON_VARIANTS.OUTLINE ? "var(--color--action-default)" : "var(--color--basics-white)"
      })
    }), children && jsx("div", {
      className: "".concat(variant === PLAY_BUTTON_VARIANTS.OUTLINE ? "color--action-default" : "color--basics-white", " ").concat(size === PLAY_BUTTON_SIZES.L ? "type--headline-medium-S" : "type--headline-medium-XS"),
      children: children
    })]
  });
};

var SEARCH_INPUT_SIZES;
(function (SEARCH_INPUT_SIZES) {
  SEARCH_INPUT_SIZES["DEFAULT"] = "M";
  SEARCH_INPUT_SIZES["M"] = "M";
  SEARCH_INPUT_SIZES["XL"] = "XL";
})(SEARCH_INPUT_SIZES || (SEARCH_INPUT_SIZES = {}));
var SearchInput = function (_a) {
  var onClearQuery = _a.onClearQuery,
    onSearch = _a.onSearch,
    _b = _a.placeholder,
    placeholder = _b === void 0 ? 'Search' : _b,
    query = _a.query,
    searchInputRef = _a.searchInputRef,
    _c = _a.size,
    size = _c === void 0 ? SEARCH_INPUT_SIZES.DEFAULT : _c;
  return jsxs("div", {
    className: "SearchInput size-".concat(size),
    children: [jsx(Icon, {
      size: size === SEARCH_INPUT_SIZES.XL ? "27px" : "24px",
      type: ICON_TYPES["search"]
    }), jsx("input", {
      className: size === SEARCH_INPUT_SIZES.XL ? "type--text-L" : "type--text-S",
      onChange: function (e) {
        onSearch(e.target.value);
      },
      placeholder: placeholder,
      ref: searchInputRef,
      type: "text",
      value: query
    }), query && query.length > 0 && jsx("button", {
      className: "clear-button",
      onClick: function (e) {
        e.preventDefault();
        if (onClearQuery) onClearQuery();
      },
      children: jsx(Icon, {
        size: size === SEARCH_INPUT_SIZES.XL ? "30px" : "24px",
        type: ICON_TYPES["close-circle"]
      })
    })]
  });
};

var Search = function (_a) {
  var children = _a.children,
    hasError = _a.hasError,
    hasResults = _a.hasResults,
    isLoading = _a.isLoading,
    isSearching = _a.isSearching,
    onClickClose = _a.onClickClose,
    onSearch = _a.onSearch,
    query = _a.query;
  useEffect(function () {
    var handleKeyup = function (e) {
      if (onClickClose && e.key === "Escape") onClickClose();
    };
    window.addEventListener("keyup", handleKeyup);
    return function () {
      window.removeEventListener("keyup", handleKeyup);
    };
  }, []);
  useEffect(function () {
    if (!isClientSide() || isLoading) return;
    var SearchInputEl = document.querySelector(".SearchInput input");
    if (SearchInputEl) {
      SearchInputEl.focus();
    }
  }, [isLoading]);
  return jsxs("div", {
    className: "Search",
    children: [jsx("button", {
      className: "Search--CloseButton",
      onClick: onClickClose,
      children: jsx(Icon, {
        size: "20px",
        type: ICON_TYPES["close"]
      })
    }), jsx("div", {
      className: "container",
      children: jsxs("div", {
        className: "Search--Content",
        children: [!isLoading && !hasError && jsxs(Fragment, {
          children: [jsx(SearchInput, {
            onClearQuery: function () {
              return onSearch("");
            },
            onSearch: onSearch,
            query: query,
            size: SEARCH_INPUT_SIZES.XL
          }), jsxs("div", {
            className: "Search--Results",
            children: [hasResults && children, !isSearching && !hasResults && query && query.length > 0 && jsx("p", {
              className: "Search--NoResults",
              children: "Sorry, no results found."
            })]
          })]
        }), !hasResults && hasError && jsx("h4", {
          style: {
            textAlign: "center"
          },
          children: "Oops, something went wrong."
        })]
      })
    }), isLoading && !hasResults && !hasError && jsx("div", {
      className: "Search--Loading",
      children: "Loading..."
    })]
  });
};

var HS_MARKETING_SITE_URL = "https://www.helpscout.com";
var LOCAL_STORAGE_NAME_LOGGED_IN = 'HS--log-in-clicked';
var BREAKPOINTS_KEYS;
(function (BREAKPOINTS_KEYS) {
  BREAKPOINTS_KEYS["XS"] = "XS";
  BREAKPOINTS_KEYS["S"] = "S";
  BREAKPOINTS_KEYS["M"] = "M";
  BREAKPOINTS_KEYS["L"] = "L";
  BREAKPOINTS_KEYS["XL"] = "XL";
  BREAKPOINTS_KEYS["2XL"] = "2XL";
})(BREAKPOINTS_KEYS || (BREAKPOINTS_KEYS = {}));
var BREAKPOINTS = {
  XS: 375,
  S: 480,
  M: 768,
  L: 1024,
  XL: 1600,
  "2XL": 2560
};

var GLOW_STROKE_WIDTH = 1478;
var GLOW_STROKE_HEIGHT = 201;
var GLOW_XY = 150;
var SiteFooterBigLogo = function (_a) {
  var clientX = _a.clientX,
    clientY = _a.clientY,
    opacity = _a.opacity;
  var logoRef = useRef(null);
  var _b = useState([-1000, -1000]),
    xy = _b[0],
    setXy = _b[1];
  useEffect(function () {
    if (!isClientSide() || !logoRef.current) return;
    var clientRect = logoRef.current.getBoundingClientRect();
    var xScale = GLOW_STROKE_WIDTH / clientRect.width;
    var yScale = GLOW_STROKE_HEIGHT / clientRect.height;
    var x = (clientX - clientRect.x) * xScale;
    var y = (clientY - clientRect.y) * yScale;
    setXy([x, y]);
  }, [clientX, clientY]);
  return jsx("div", {
    className: "SiteFooterBigLogo",
    ref: logoRef,
    children: jsxs("svg", {
      className: "glow-stroke",
      width: GLOW_STROKE_WIDTH,
      height: GLOW_STROKE_HEIGHT,
      viewBox: "0 0 ".concat(GLOW_STROKE_WIDTH, " ").concat(GLOW_STROKE_HEIGHT),
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: [jsxs("g", {
        clipPath: "url(#clip0_13920_5315)",
        children: [jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28.8981 -0.0566406C50.2281 21.2972 50.2281 55.9187 28.8981 77.2726L-69.8009 176.082C-91.1308 154.728 -91.1308 120.107 -69.8009 98.753L28.8981 -0.0566406ZM-69.5851 211.16C-90.9151 232.514 -90.9151 267.136 -69.5851 288.49L141.395 77.2726C162.725 55.9187 162.725 21.2972 141.395 -0.0566331L-69.5851 211.16ZM42.6868 211.934C21.3568 233.288 21.3568 267.91 42.6868 289.264L141.386 190.454C162.716 169.1 162.716 134.479 141.386 113.125L42.6868 211.934ZM542.089 45.1387H574.213V235.079H542.089V45.1387ZM251.273 49.4173H218.116V235.079H251.273V157.283H336.278V235.079H369.435V49.4173H336.278V126.189H251.273V49.4173ZM456.567 93.4374C415.569 93.4374 389.98 121.398 389.98 166.202H390.01C390.01 208.806 413.26 237.158 456.081 237.158C487.141 237.158 506.865 222.274 516.925 201.695L488.843 191.843C483.616 201.545 474.59 210.343 457.236 210.343C435.689 210.343 423.532 196.483 422.104 176.295H518.87V157.404C518.87 118.174 495.225 93.4374 456.567 93.4374ZM486.473 151.438V152.583H422.347C424.717 133.029 436.6 120.223 456.051 120.223C473.951 120.223 486.473 130.859 486.473 151.438ZM637.123 96.0286H605.273V285.698H637.397V211.759C645.359 226.884 658.792 235.049 679.307 235.049C718.998 235.049 739.512 205.401 739.512 164.243C739.512 123.086 718.998 93.4374 679.428 93.4374C658.397 93.4374 645.207 101.723 637.123 117.12V96.0286ZM707.419 164.243C707.419 191.421 694.472 207.872 672.408 207.872C650.313 207.872 637.397 191.421 637.397 164.243C637.397 137.066 650.313 120.615 672.408 120.615C694.502 120.615 707.419 137.066 707.419 164.243ZM792.241 179.79L825.277 174.096C828.286 197.145 845.913 210.463 870.59 210.463C891.621 210.463 905.054 200.61 905.054 184.43C905.054 163.972 883.385 159.844 859.224 155.295C829.045 149.721 794.186 143.001 794.186 102.356C794.186 65.5971 822.785 45.1387 863.661 45.1387C904.538 45.1387 930.644 67.0132 935.476 100.036L902.562 105.61C900.07 86.4471 887.427 74.0335 862.081 74.0335C841.445 74.0335 827.738 82.4398 827.738 99.0114C827.738 118.958 847.584 123.085 871.35 127.364C905.419 133.45 938.333 139.537 938.333 179.549C938.333 215.675 911.558 239.358 870.438 239.358C829.319 239.358 796.526 215.525 792.211 179.79H792.241ZM1019.69 93.4374C978.424 93.4374 953.747 120.609 953.741 165.404C953.747 209.536 977.664 237.249 1019.17 237.249C1054.31 237.249 1075.46 217.333 1080.69 189.613L1049.6 184.19C1046.34 200.641 1035.77 209.83 1019.17 209.83C997.475 209.83 985.865 195.097 985.865 165.69C985.865 136.283 998.143 120.886 1019.69 120.886C1036.01 120.886 1046.34 129.955 1049.6 146.256L1080.69 140.832C1075.46 113.112 1054.82 93.4374 1019.69 93.4374ZM1092.11 165.298C1092.11 121.278 1117.83 93.4374 1158.58 93.4374C1199.33 93.4374 1225.17 121.278 1225.17 165.298C1225.17 209.318 1199.46 237.158 1158.58 237.158C1117.7 237.158 1092.11 209.318 1092.11 165.298ZM1158.58 209.951C1180.4 209.951 1193.04 194.404 1193.04 165.298C1193.04 136.192 1180.37 120.645 1158.58 120.645C1136.79 120.645 1124.24 136.313 1124.24 165.298C1124.24 194.283 1136.91 209.951 1158.58 209.951ZM1244.44 96.0286V189.372L1244.47 189.342C1244.47 218.237 1261.06 237.128 1290.57 237.128C1312.63 237.128 1325.16 226.643 1332.48 213.054V235.049H1364.33V95.9984H1332.21V174.337C1332.21 193.771 1320.32 208.655 1300.99 208.655C1284.28 208.655 1276.56 197.145 1276.56 179.007V96.0286H1244.44ZM1407.43 198.562V124.381H1381.84V96.0286H1407.43V63.9098L1439.55 54.9913V96.0286H1473.1V124.381H1439.55V190.276C1439.55 197.145 1439.55 209.167 1459.15 209.167C1463.35 209.167 1468.54 208.655 1474.17 207.751L1475.59 233.904C1467.11 235.983 1457.84 237.128 1448.82 237.128C1424.14 237.128 1407.43 228.451 1407.43 198.562Z",
          fill: "white",
          fillOpacity: "0.02"
        }), jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28.8981 -0.0566406C50.2281 21.2972 50.2281 55.9187 28.8981 77.2726L-69.8009 176.082C-91.1308 154.728 -91.1308 120.107 -69.8009 98.753L28.8981 -0.0566406ZM-69.5851 211.16C-90.9151 232.514 -90.9151 267.136 -69.5851 288.49L141.395 77.2726C162.725 55.9187 162.725 21.2972 141.395 -0.0566331L-69.5851 211.16ZM42.6868 211.934C21.3568 233.288 21.3568 267.91 42.6868 289.264L141.386 190.454C162.716 169.1 162.716 134.479 141.386 113.125L42.6868 211.934ZM542.089 45.1387H574.213V235.079H542.089V45.1387ZM251.273 49.4173H218.116V235.079H251.273V157.283H336.278V235.079H369.435V49.4173H336.278V126.189H251.273V49.4173ZM456.567 93.4374C415.569 93.4374 389.98 121.398 389.98 166.202H390.01C390.01 208.806 413.26 237.158 456.081 237.158C487.141 237.158 506.865 222.274 516.925 201.695L488.843 191.843C483.616 201.545 474.59 210.343 457.236 210.343C435.689 210.343 423.532 196.483 422.104 176.295H518.87V157.404C518.87 118.174 495.225 93.4374 456.567 93.4374ZM486.473 151.438V152.583H422.347C424.717 133.029 436.6 120.223 456.051 120.223C473.951 120.223 486.473 130.859 486.473 151.438ZM637.123 96.0286H605.273V285.698H637.397V211.759C645.359 226.884 658.792 235.049 679.307 235.049C718.998 235.049 739.512 205.401 739.512 164.243C739.512 123.086 718.998 93.4374 679.428 93.4374C658.397 93.4374 645.207 101.723 637.123 117.12V96.0286ZM707.419 164.243C707.419 191.421 694.472 207.872 672.408 207.872C650.313 207.872 637.397 191.421 637.397 164.243C637.397 137.066 650.313 120.615 672.408 120.615C694.502 120.615 707.419 137.066 707.419 164.243ZM792.241 179.79L825.277 174.096C828.286 197.145 845.913 210.463 870.59 210.463C891.621 210.463 905.054 200.61 905.054 184.43C905.054 163.972 883.385 159.844 859.224 155.295C829.045 149.721 794.186 143.001 794.186 102.356C794.186 65.5971 822.785 45.1387 863.661 45.1387C904.538 45.1387 930.644 67.0132 935.476 100.036L902.562 105.61C900.07 86.4471 887.427 74.0335 862.081 74.0335C841.445 74.0335 827.738 82.4398 827.738 99.0114C827.738 118.958 847.584 123.085 871.35 127.364C905.419 133.45 938.333 139.537 938.333 179.549C938.333 215.675 911.558 239.358 870.438 239.358C829.319 239.358 796.526 215.525 792.211 179.79H792.241ZM1019.69 93.4374C978.424 93.4374 953.747 120.609 953.741 165.404C953.747 209.536 977.664 237.249 1019.17 237.249C1054.31 237.249 1075.46 217.333 1080.69 189.613L1049.6 184.19C1046.34 200.641 1035.77 209.83 1019.17 209.83C997.475 209.83 985.865 195.097 985.865 165.69C985.865 136.283 998.143 120.886 1019.69 120.886C1036.01 120.886 1046.34 129.955 1049.6 146.256L1080.69 140.832C1075.46 113.112 1054.82 93.4374 1019.69 93.4374ZM1092.11 165.298C1092.11 121.278 1117.83 93.4374 1158.58 93.4374C1199.33 93.4374 1225.17 121.278 1225.17 165.298C1225.17 209.318 1199.46 237.158 1158.58 237.158C1117.7 237.158 1092.11 209.318 1092.11 165.298ZM1158.58 209.951C1180.4 209.951 1193.04 194.404 1193.04 165.298C1193.04 136.192 1180.37 120.645 1158.58 120.645C1136.79 120.645 1124.24 136.313 1124.24 165.298C1124.24 194.283 1136.91 209.951 1158.58 209.951ZM1244.44 96.0286V189.372L1244.47 189.342C1244.47 218.237 1261.06 237.128 1290.57 237.128C1312.63 237.128 1325.16 226.643 1332.48 213.054V235.049H1364.33V95.9984H1332.21V174.337C1332.21 193.771 1320.32 208.655 1300.99 208.655C1284.28 208.655 1276.56 197.145 1276.56 179.007V96.0286H1244.44ZM1407.43 198.562V124.381H1381.84V96.0286H1407.43V63.9098L1439.55 54.9913V96.0286H1473.1V124.381H1439.55V190.276C1439.55 197.145 1439.55 209.167 1459.15 209.167C1463.35 209.167 1468.54 208.655 1474.17 207.751L1475.59 233.904C1467.11 235.983 1457.84 237.128 1448.82 237.128C1424.14 237.128 1407.43 228.451 1407.43 198.562Z",
          fill: "url(#pattern0)",
          fillOpacity: "0.08",
          style: {
            mixBlendMode: "soft-light"
          }
        }), jsx("mask", {
          id: "mask0_13920_5315",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: -86,
          y: -1,
          width: 1562,
          height: 291,
          children: jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.8981 -0.0566406C50.2281 21.2972 50.2281 55.9187 28.8981 77.2726L-69.8009 176.082C-91.1308 154.728 -91.1308 120.107 -69.8009 98.753L28.8981 -0.0566406ZM-69.5851 211.16C-90.9151 232.514 -90.9151 267.136 -69.5851 288.49L141.395 77.2726C162.725 55.9187 162.725 21.2972 141.395 -0.0566331L-69.5851 211.16ZM42.6868 211.934C21.3568 233.288 21.3568 267.91 42.6868 289.264L141.386 190.454C162.716 169.1 162.716 134.479 141.386 113.125L42.6868 211.934ZM542.089 45.1387H574.213V235.079H542.089V45.1387ZM251.273 49.4173H218.116V235.079H251.273V157.283H336.278V235.079H369.435V49.4173H336.278V126.189H251.273V49.4173ZM456.567 93.4374C415.569 93.4374 389.98 121.398 389.98 166.202H390.01C390.01 208.806 413.26 237.158 456.081 237.158C487.141 237.158 506.865 222.274 516.925 201.695L488.843 191.843C483.616 201.545 474.59 210.343 457.236 210.343C435.689 210.343 423.532 196.483 422.104 176.295H518.87V157.404C518.87 118.174 495.225 93.4374 456.567 93.4374ZM486.473 151.438V152.583H422.347C424.717 133.029 436.6 120.223 456.051 120.223C473.951 120.223 486.473 130.859 486.473 151.438ZM637.123 96.0286H605.273V285.698H637.397V211.759C645.359 226.884 658.792 235.049 679.307 235.049C718.998 235.049 739.512 205.401 739.512 164.243C739.512 123.086 718.998 93.4374 679.428 93.4374C658.397 93.4374 645.207 101.723 637.123 117.12V96.0286ZM707.419 164.243C707.419 191.421 694.472 207.872 672.408 207.872C650.313 207.872 637.397 191.421 637.397 164.243C637.397 137.066 650.313 120.615 672.408 120.615C694.502 120.615 707.419 137.066 707.419 164.243ZM792.241 179.79L825.277 174.096C828.286 197.145 845.913 210.463 870.59 210.463C891.621 210.463 905.054 200.61 905.054 184.43C905.054 163.972 883.385 159.844 859.224 155.295C829.045 149.721 794.186 143.001 794.186 102.356C794.186 65.5971 822.785 45.1387 863.661 45.1387C904.538 45.1387 930.644 67.0132 935.476 100.036L902.562 105.61C900.07 86.4471 887.427 74.0335 862.081 74.0335C841.445 74.0335 827.738 82.4398 827.738 99.0114C827.738 118.958 847.584 123.085 871.35 127.364C905.419 133.45 938.333 139.537 938.333 179.549C938.333 215.675 911.558 239.358 870.438 239.358C829.319 239.358 796.526 215.525 792.211 179.79H792.241ZM1019.69 93.4374C978.424 93.4374 953.747 120.609 953.741 165.404C953.747 209.536 977.664 237.249 1019.17 237.249C1054.31 237.249 1075.46 217.333 1080.69 189.613L1049.6 184.19C1046.34 200.641 1035.77 209.83 1019.17 209.83C997.475 209.83 985.865 195.097 985.865 165.69C985.865 136.283 998.143 120.886 1019.69 120.886C1036.01 120.886 1046.34 129.955 1049.6 146.256L1080.69 140.832C1075.46 113.112 1054.82 93.4374 1019.69 93.4374ZM1092.11 165.298C1092.11 121.278 1117.83 93.4374 1158.58 93.4374C1199.33 93.4374 1225.17 121.278 1225.17 165.298C1225.17 209.318 1199.46 237.158 1158.58 237.158C1117.7 237.158 1092.11 209.318 1092.11 165.298ZM1158.58 209.951C1180.4 209.951 1193.04 194.404 1193.04 165.298C1193.04 136.192 1180.37 120.645 1158.58 120.645C1136.79 120.645 1124.24 136.313 1124.24 165.298C1124.24 194.283 1136.91 209.951 1158.58 209.951ZM1244.44 96.0286V189.372L1244.47 189.342C1244.47 218.237 1261.06 237.128 1290.57 237.128C1312.63 237.128 1325.16 226.643 1332.48 213.054V235.049H1364.33V95.9984H1332.21V174.337C1332.21 193.771 1320.32 208.655 1300.99 208.655C1284.28 208.655 1276.56 197.145 1276.56 179.007V96.0286H1244.44ZM1407.43 198.562V124.381H1381.84V96.0286H1407.43V63.9098L1439.55 54.9913V96.0286H1473.1V124.381H1439.55V190.276C1439.55 197.145 1439.55 209.167 1459.15 209.167C1463.35 209.167 1468.54 208.655 1474.17 207.751L1475.59 233.904C1467.11 235.983 1457.84 237.128 1448.82 237.128C1424.14 237.128 1407.43 228.451 1407.43 198.562Z",
            fill: "#1D2B36"
          })
        }), jsxs("g", {
          mask: "url(#mask0_13920_5315)",
          children: [jsx("mask", {
            id: "path-3-inside-1_13920_5315",
            fill: "white",
            children: jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M28.8981 -0.0566366C50.2281 21.2972 50.2281 55.9187 28.8981 77.2726L-69.8009 176.082C-91.1308 154.728 -91.1308 120.107 -69.8009 98.753L28.8981 -0.0566366ZM-69.5851 211.16C-90.9151 232.514 -90.9151 267.136 -69.5851 288.49L141.395 77.2726C162.725 55.9187 162.725 21.2973 141.395 -0.0566291L-69.5851 211.16ZM42.6868 211.934C21.3568 233.288 21.3568 267.91 42.6868 289.264L141.386 190.454C162.716 169.1 162.716 134.479 141.386 113.125L42.6868 211.934ZM542.089 45.1387H574.213V235.079H542.089V45.1387ZM251.273 49.4173H218.116V235.079H251.273V157.283H336.278V235.079H369.435V49.4173H336.278V126.189H251.273V49.4173ZM456.567 93.4374C415.569 93.4374 389.98 121.398 389.98 166.202H390.01C390.01 208.806 413.26 237.158 456.081 237.158C487.141 237.158 506.865 222.274 516.925 201.695L488.843 191.843C483.616 201.545 474.59 210.343 457.236 210.343C435.689 210.343 423.532 196.483 422.104 176.295H518.87V157.404C518.87 118.174 495.225 93.4374 456.567 93.4374ZM486.473 151.438V152.583H422.347C424.717 133.029 436.6 120.223 456.051 120.223C473.951 120.223 486.473 130.859 486.473 151.438ZM637.123 96.0286H605.273V285.698H637.397V211.759C645.359 226.884 658.792 235.049 679.307 235.049C718.998 235.049 739.512 205.401 739.512 164.243C739.512 123.086 718.998 93.4374 679.428 93.4374C658.397 93.4374 645.207 101.723 637.123 117.12V96.0286ZM707.419 164.243C707.419 191.421 694.472 207.872 672.408 207.872C650.313 207.872 637.397 191.421 637.397 164.243C637.397 137.066 650.313 120.615 672.408 120.615C694.502 120.615 707.419 137.066 707.419 164.243ZM792.241 179.79L825.277 174.096C828.286 197.145 845.913 210.463 870.59 210.463C891.621 210.463 905.054 200.61 905.054 184.43C905.054 163.972 883.385 159.844 859.224 155.295C829.045 149.721 794.186 143.001 794.186 102.356C794.186 65.5971 822.785 45.1387 863.661 45.1387C904.538 45.1387 930.644 67.0132 935.476 100.036L902.562 105.61C900.07 86.4471 887.427 74.0335 862.081 74.0335C841.445 74.0335 827.738 82.4398 827.738 99.0114C827.738 118.958 847.584 123.085 871.35 127.364C905.419 133.45 938.333 139.537 938.333 179.549C938.333 215.675 911.558 239.358 870.438 239.358C829.319 239.358 796.526 215.525 792.211 179.79H792.241ZM1019.69 93.4374C978.424 93.4374 953.747 120.609 953.741 165.404C953.747 209.536 977.664 237.249 1019.17 237.249C1054.31 237.249 1075.46 217.333 1080.69 189.613L1049.6 184.19C1046.34 200.641 1035.77 209.83 1019.17 209.83C997.475 209.83 985.865 195.097 985.865 165.69C985.865 136.283 998.143 120.886 1019.69 120.886C1036.01 120.886 1046.34 129.955 1049.6 146.256L1080.69 140.832C1075.46 113.112 1054.82 93.4374 1019.69 93.4374ZM1092.11 165.298C1092.11 121.278 1117.83 93.4374 1158.58 93.4374C1199.33 93.4374 1225.17 121.278 1225.17 165.298C1225.17 209.318 1199.46 237.158 1158.58 237.158C1117.7 237.158 1092.11 209.318 1092.11 165.298ZM1158.58 209.951C1180.4 209.951 1193.04 194.404 1193.04 165.298C1193.04 136.192 1180.37 120.645 1158.58 120.645C1136.79 120.645 1124.24 136.313 1124.24 165.298C1124.24 194.283 1136.91 209.951 1158.58 209.951ZM1244.44 96.0286V189.372L1244.47 189.342C1244.47 218.237 1261.06 237.128 1290.57 237.128C1312.63 237.128 1325.16 226.643 1332.48 213.054V235.049H1364.33V95.9984H1332.21V174.337C1332.21 193.771 1320.32 208.655 1300.99 208.655C1284.28 208.655 1276.56 197.145 1276.56 179.007V96.0286H1244.44ZM1407.43 198.562V124.381H1381.84V96.0286H1407.43V63.9098L1439.55 54.9913V96.0286H1473.1V124.381H1439.55V190.276C1439.55 197.145 1439.55 209.167 1459.15 209.167C1463.35 209.167 1468.54 208.655 1474.17 207.751L1475.59 233.904C1467.11 235.983 1457.84 237.128 1448.82 237.128C1424.14 237.128 1407.43 228.451 1407.43 198.562Z"
            })
          }), jsx("path", {
            d: "M28.8981 77.2726L29.2518 77.626L29.2518 77.626L28.8981 77.2726ZM28.8981 -0.0566366L29.2518 -0.409992C29.1581 -0.503881 29.0308 -0.556637 28.8981 -0.556637C28.7654 -0.556637 28.6381 -0.503881 28.5443 -0.409992L28.8981 -0.0566366ZM-69.8009 176.082L-70.1546 176.436C-70.0608 176.529 -69.9336 176.582 -69.8009 176.582C-69.6682 176.582 -69.5409 176.529 -69.4471 176.436L-69.8009 176.082ZM-69.8009 98.753L-69.4471 99.1063L-69.4471 99.1063L-69.8009 98.753ZM-69.5851 288.49L-69.9389 288.843C-69.8451 288.937 -69.7178 288.99 -69.5851 288.99C-69.4524 288.99 -69.3252 288.937 -69.2314 288.843L-69.5851 288.49ZM-69.5851 211.16L-69.2314 211.514L-69.2314 211.514L-69.5851 211.16ZM141.395 77.2726L141.042 76.9193L141.042 76.9193L141.395 77.2726ZM141.395 -0.0566291L141.749 -0.409984C141.655 -0.503874 141.528 -0.556629 141.395 -0.556629C141.263 -0.556629 141.135 -0.503874 141.042 -0.409984L141.395 -0.0566291ZM42.6868 289.264L42.3331 289.617C42.4268 289.711 42.5541 289.764 42.6868 289.764C42.8195 289.764 42.9468 289.711 43.0406 289.617L42.6868 289.264ZM42.6868 211.934L43.0406 212.288L43.0406 212.288L42.6868 211.934ZM141.386 190.454L141.032 190.101L141.032 190.101L141.386 190.454ZM141.386 113.125L141.74 112.771C141.646 112.678 141.518 112.625 141.386 112.625C141.253 112.625 141.126 112.678 141.032 112.771L141.386 113.125ZM574.213 45.1387H574.713C574.713 44.8625 574.489 44.6387 574.213 44.6387V45.1387ZM542.089 45.1387V44.6387C541.813 44.6387 541.589 44.8625 541.589 45.1387H542.089ZM574.213 235.079V235.579C574.489 235.579 574.713 235.355 574.713 235.079H574.213ZM542.089 235.079H541.589C541.589 235.355 541.813 235.579 542.089 235.579V235.079ZM218.116 49.4173V48.9173C217.84 48.9173 217.616 49.1411 217.616 49.4173H218.116ZM251.273 49.4173H251.773C251.773 49.1411 251.549 48.9173 251.273 48.9173V49.4173ZM218.116 235.079H217.616C217.616 235.356 217.84 235.579 218.116 235.579V235.079ZM251.273 235.079V235.579C251.549 235.579 251.773 235.356 251.773 235.079H251.273ZM251.273 157.283V156.783C250.997 156.783 250.773 157.007 250.773 157.283H251.273ZM336.278 157.283H336.778C336.778 157.007 336.554 156.783 336.278 156.783V157.283ZM336.278 235.079H335.778C335.778 235.356 336.002 235.579 336.278 235.579V235.079ZM369.435 235.079V235.579C369.711 235.579 369.935 235.356 369.935 235.079H369.435ZM369.435 49.4173H369.935C369.935 49.1411 369.711 48.9173 369.435 48.9173V49.4173ZM336.278 49.4173V48.9173C336.002 48.9173 335.778 49.1411 335.778 49.4173H336.278ZM336.278 126.189V126.689C336.554 126.689 336.778 126.465 336.778 126.189H336.278ZM251.273 126.189H250.773C250.773 126.465 250.997 126.689 251.273 126.689V126.189ZM389.98 166.202H389.48C389.48 166.478 389.704 166.702 389.98 166.702V166.202ZM390.01 166.202H390.51C390.51 165.926 390.286 165.702 390.01 165.702V166.202ZM516.925 201.695L517.374 201.915C517.437 201.786 517.442 201.638 517.388 201.505C517.333 201.373 517.225 201.271 517.09 201.223L516.925 201.695ZM488.843 191.843L489.009 191.371C488.777 191.289 488.52 191.389 488.403 191.605L488.843 191.843ZM422.104 176.295V175.795C421.965 175.795 421.832 175.853 421.738 175.955C421.643 176.056 421.595 176.192 421.605 176.331L422.104 176.295ZM518.87 176.295V176.795C519.146 176.795 519.37 176.572 519.37 176.295H518.87ZM486.473 152.583V153.083C486.749 153.083 486.973 152.859 486.973 152.583H486.473ZM422.347 152.583L421.85 152.523C421.833 152.665 421.878 152.807 421.972 152.915C422.067 153.022 422.204 153.083 422.347 153.083V152.583ZM605.273 96.0286V95.5286C604.997 95.5286 604.773 95.7525 604.773 96.0286H605.273ZM637.123 96.0286H637.623C637.623 95.7525 637.399 95.5286 637.123 95.5286V96.0286ZM605.273 285.698H604.773C604.773 285.974 604.997 286.198 605.273 286.198V285.698ZM637.397 285.698V286.198C637.673 286.198 637.897 285.974 637.897 285.698H637.397ZM637.397 211.759L637.839 211.526C637.732 211.322 637.5 211.218 637.277 211.273C637.054 211.328 636.897 211.529 636.897 211.759H637.397ZM637.123 117.12H636.623C636.623 117.35 636.78 117.55 637.004 117.605C637.227 117.66 637.459 117.556 637.566 117.352L637.123 117.12ZM825.277 174.096L825.773 174.031C825.755 173.896 825.683 173.774 825.573 173.693C825.464 173.613 825.326 173.58 825.192 173.603L825.277 174.096ZM792.241 179.79V180.29C792.27 180.29 792.298 180.288 792.326 180.283L792.241 179.79ZM859.224 155.295L859.317 154.803L859.315 154.803L859.224 155.295ZM935.476 100.036L935.56 100.529C935.828 100.483 936.01 100.232 935.971 99.9635L935.476 100.036ZM902.562 105.61L902.066 105.674C902.084 105.809 902.156 105.931 902.265 106.012C902.374 106.093 902.512 106.126 902.646 106.103L902.562 105.61ZM871.35 127.364L871.262 127.856L871.262 127.856L871.35 127.364ZM792.211 179.79V179.29C792.068 179.29 791.932 179.352 791.837 179.459C791.742 179.566 791.697 179.708 791.714 179.85L792.211 179.79ZM953.741 165.404L953.241 165.404L953.241 165.404L953.741 165.404ZM1080.69 189.613L1081.18 189.706C1081.2 189.574 1081.17 189.438 1081.1 189.328C1081.02 189.218 1080.9 189.143 1080.77 189.12L1080.69 189.613ZM1049.6 184.19L1049.68 183.697C1049.41 183.65 1049.16 183.826 1049.11 184.093L1049.6 184.19ZM1049.6 146.256L1049.11 146.353C1049.16 146.62 1049.41 146.795 1049.68 146.748L1049.6 146.256ZM1080.69 140.832L1080.77 141.325C1080.9 141.302 1081.02 141.227 1081.1 141.117C1081.17 141.007 1081.2 140.871 1081.18 140.74L1080.69 140.832ZM1244.44 189.372H1243.94C1243.94 189.574 1244.06 189.756 1244.24 189.834C1244.43 189.911 1244.65 189.869 1244.79 189.726L1244.44 189.372ZM1244.44 96.0286V95.5286C1244.16 95.5286 1243.94 95.7524 1243.94 96.0286H1244.44ZM1244.47 189.342H1244.97C1244.97 189.14 1244.84 188.958 1244.66 188.88C1244.47 188.803 1244.26 188.845 1244.11 188.987L1244.47 189.342ZM1332.48 213.054H1332.98C1332.98 212.825 1332.82 212.625 1332.6 212.569C1332.38 212.513 1332.15 212.615 1332.04 212.817L1332.48 213.054ZM1332.48 235.049H1331.98C1331.98 235.325 1332.2 235.549 1332.48 235.549V235.049ZM1364.33 235.049V235.549C1364.61 235.549 1364.83 235.325 1364.83 235.049H1364.33ZM1364.33 95.9984H1364.83C1364.83 95.7223 1364.61 95.4984 1364.33 95.4984V95.9984ZM1332.21 95.9984V95.4984C1331.93 95.4984 1331.71 95.7223 1331.71 95.9984H1332.21ZM1276.56 96.0286H1277.06C1277.06 95.7524 1276.84 95.5286 1276.56 95.5286V96.0286ZM1407.43 124.381H1407.93C1407.93 124.105 1407.7 123.881 1407.43 123.881V124.381ZM1381.84 124.381H1381.34C1381.34 124.657 1381.56 124.881 1381.84 124.881V124.381ZM1381.84 96.0286V95.5286C1381.56 95.5286 1381.34 95.7525 1381.34 96.0286H1381.84ZM1407.43 96.0286V96.5286C1407.7 96.5286 1407.93 96.3047 1407.93 96.0286H1407.43ZM1407.43 63.9098L1407.29 63.428C1407.08 63.4881 1406.93 63.6852 1406.93 63.9098H1407.43ZM1439.55 54.9913H1440.05C1440.05 54.8351 1439.98 54.6878 1439.85 54.5932C1439.73 54.4987 1439.57 54.4677 1439.42 54.5095L1439.55 54.9913ZM1439.55 96.0286H1439.05C1439.05 96.3047 1439.27 96.5286 1439.55 96.5286V96.0286ZM1473.1 96.0286H1473.6C1473.6 95.7525 1473.38 95.5286 1473.1 95.5286V96.0286ZM1473.1 124.381V124.881C1473.38 124.881 1473.6 124.657 1473.6 124.381H1473.1ZM1439.55 124.381V123.881C1439.27 123.881 1439.05 124.105 1439.05 124.381H1439.55ZM1474.17 207.751L1474.66 207.724C1474.66 207.583 1474.59 207.451 1474.48 207.362C1474.37 207.273 1474.23 207.235 1474.09 207.258L1474.17 207.751ZM1475.59 233.904L1475.71 234.39C1475.95 234.333 1476.11 234.117 1476.09 233.877L1475.59 233.904ZM29.2518 77.626C50.7768 56.0769 50.7768 21.1391 29.2518 -0.409992L28.5443 0.296719C49.6793 21.4554 49.6793 55.7606 28.5443 76.9193L29.2518 77.626ZM-69.4471 176.436L29.2518 77.626L28.5443 76.9193L-70.1546 175.729L-69.4471 176.436ZM-70.1546 98.3996C-91.6796 119.949 -91.6796 154.886 -70.1546 176.436L-69.4471 175.729C-90.5821 154.57 -90.5821 120.265 -69.4471 99.1063L-70.1546 98.3996ZM28.5443 -0.409992L-70.1546 98.3996L-69.4471 99.1063L29.2518 0.296719L28.5443 -0.409992ZM-69.2314 288.136C-90.3664 266.978 -90.3664 232.672 -69.2314 211.514L-69.9389 210.807C-91.4639 232.356 -91.4638 267.294 -69.9389 288.843L-69.2314 288.136ZM141.042 76.9193L-69.9389 288.136L-69.2314 288.843L141.749 77.626L141.042 76.9193ZM141.042 0.296726C162.177 21.4554 162.177 55.7606 141.042 76.9193L141.749 77.626C163.274 56.0769 163.274 21.1391 141.749 -0.409984L141.042 0.296726ZM-69.2314 211.514L141.749 0.296726L141.042 -0.409984L-69.9389 210.807L-69.2314 211.514ZM43.0406 288.91C21.9056 267.752 21.9056 233.446 43.0406 212.288L42.3331 211.581C20.8081 233.13 20.8081 268.068 42.3331 289.617L43.0406 288.91ZM141.032 190.101L42.3331 288.91L43.0406 289.617L141.74 190.807L141.032 190.101ZM141.032 113.478C162.167 134.637 162.167 168.942 141.032 190.101L141.74 190.807C163.264 169.258 163.264 134.321 141.74 112.771L141.032 113.478ZM43.0406 212.288L141.74 113.478L141.032 112.771L42.3331 211.581L43.0406 212.288ZM574.213 44.6387H542.089V45.6387H574.213V44.6387ZM574.713 235.079V45.1387H573.713V235.079H574.713ZM542.089 235.579H574.213V234.579H542.089V235.579ZM541.589 45.1387V235.079H542.589V45.1387H541.589ZM218.116 49.9173H251.273V48.9173H218.116V49.9173ZM218.616 235.079V49.4173H217.616V235.079H218.616ZM251.273 234.579H218.116V235.579H251.273V234.579ZM250.773 157.283V235.079H251.773V157.283H250.773ZM336.278 156.783H251.273V157.783H336.278V156.783ZM336.778 235.079V157.283H335.778V235.079H336.778ZM369.435 234.579H336.278V235.579H369.435V234.579ZM368.935 49.4173V235.079H369.935V49.4173H368.935ZM336.278 49.9173H369.435V48.9173H336.278V49.9173ZM336.778 126.189V49.4173H335.778V126.189H336.778ZM251.273 126.689H336.278V125.689H251.273V126.689ZM250.773 49.4173V126.189H251.773V49.4173H250.773ZM390.48 166.202C390.48 143.893 396.85 125.833 408.268 113.356C419.682 100.884 436.187 93.9374 456.567 93.9374V92.9374C435.95 92.9374 419.161 99.9718 407.53 112.681C395.905 125.385 389.48 143.707 389.48 166.202H390.48ZM390.01 165.702H389.98V166.702H390.01V165.702ZM456.081 236.658C434.786 236.658 418.414 229.613 407.359 217.322C396.298 205.024 390.51 187.417 390.51 166.202H389.51C389.51 187.591 395.347 205.462 406.616 217.991C417.892 230.528 434.554 237.658 456.081 237.658V236.658ZM516.476 201.476C506.5 221.883 486.95 236.658 456.081 236.658V237.658C487.333 237.658 507.231 222.665 517.374 201.915L516.476 201.476ZM488.678 192.314L516.759 202.167L517.09 201.223L489.009 191.371L488.678 192.314ZM457.236 210.843C466.002 210.843 472.696 208.619 477.866 205.146C483.031 201.676 486.643 196.98 489.283 192.08L488.403 191.605C485.816 196.407 482.302 200.961 477.308 204.316C472.319 207.667 465.823 209.843 457.236 209.843V210.843ZM421.605 176.331C422.325 186.514 425.756 195.148 431.769 201.24C437.788 207.338 446.35 210.843 457.236 210.843V209.843C446.575 209.843 438.284 206.417 432.481 200.538C426.672 194.653 423.31 186.264 422.602 176.26L421.605 176.331ZM518.87 175.795H422.104V176.795H518.87V175.795ZM518.37 157.404V176.295H519.37V157.404H518.37ZM456.567 93.9374C475.787 93.9374 491.224 100.084 501.856 111.057C512.491 122.033 518.37 137.889 518.37 157.404H519.37C519.37 137.689 513.427 121.562 502.575 110.362C491.72 99.1592 476.006 92.9374 456.567 92.9374V93.9374ZM486.973 152.583V151.438H485.973V152.583H486.973ZM422.347 153.083H486.473V152.083H422.347V153.083ZM456.051 119.723C446.209 119.723 438.244 122.966 432.442 128.715C426.645 134.458 423.046 142.662 421.85 152.523L422.843 152.643C424.018 142.95 427.545 134.974 433.146 129.425C438.74 123.883 446.442 120.723 456.051 120.723V119.723ZM486.973 151.438C486.973 141.045 483.808 133.101 478.323 127.755C472.841 122.413 465.099 119.723 456.051 119.723V120.723C464.903 120.723 472.372 123.352 477.625 128.472C482.876 133.589 485.973 141.252 485.973 151.438H486.973ZM605.273 96.5286H637.123V95.5286H605.273V96.5286ZM605.773 285.698V96.0286H604.773V285.698H605.773ZM637.397 285.198H605.273V286.198H637.397V285.198ZM636.897 211.759V285.698H637.897V211.759H636.897ZM679.307 234.549C669.116 234.549 660.719 232.521 653.892 228.641C647.068 224.763 641.782 219.016 637.839 211.526L636.954 211.992C640.974 219.627 646.386 225.525 653.398 229.511C660.407 233.494 668.983 235.549 679.307 235.549V234.549ZM739.012 164.243C739.012 184.746 733.902 202.325 723.904 214.767C713.917 227.195 699.015 234.549 679.307 234.549V235.549C699.289 235.549 714.49 228.079 724.683 215.394C734.865 202.723 740.012 184.898 740.012 164.243H739.012ZM679.428 93.9374C699.075 93.9374 713.947 101.291 723.919 113.719C733.902 126.162 739.012 143.741 739.012 164.243H740.012C740.012 143.588 734.865 125.764 724.699 113.093C714.521 100.408 699.351 92.9374 679.428 92.9374V93.9374ZM637.566 117.352C641.572 109.723 646.829 103.879 653.67 99.9382C660.514 95.9956 668.978 93.9374 679.428 93.9374V92.9374C668.847 92.9374 660.201 95.0221 653.171 99.0716C646.139 103.123 640.759 109.12 636.681 116.887L637.566 117.352ZM636.623 96.0286V117.12H637.623V96.0286H636.623ZM672.408 208.372C683.576 208.372 692.479 204.202 698.578 196.561C704.666 188.935 707.919 177.904 707.919 164.243H706.919C706.919 177.76 703.699 188.543 697.797 195.937C691.906 203.316 683.304 207.372 672.408 207.372V208.372ZM636.897 164.243C636.897 177.904 640.142 188.935 646.226 196.561C652.321 204.202 661.224 208.372 672.408 208.372V207.372C661.497 207.372 652.894 203.316 647.008 195.937C641.11 188.544 637.897 177.76 637.897 164.243H636.897ZM672.408 120.115C661.224 120.115 652.321 124.285 646.226 131.926C640.142 139.552 636.897 150.583 636.897 164.243H637.897C637.897 150.727 641.11 139.943 647.008 132.549C652.894 125.17 661.497 121.115 672.408 121.115V120.115ZM707.919 164.243C707.919 150.583 704.673 139.552 698.59 131.926C692.494 124.285 683.591 120.115 672.408 120.115V121.115C683.319 121.115 691.921 125.17 697.808 132.549C703.706 139.943 706.919 150.727 706.919 164.243H707.919ZM825.192 173.603L792.156 179.298L792.326 180.283L825.362 174.589L825.192 173.603ZM870.59 209.963C858.34 209.963 847.88 206.658 840.117 200.531C832.36 194.407 827.261 185.437 825.773 174.031L824.781 174.161C826.301 185.804 831.52 195.018 839.498 201.315C847.471 207.609 858.163 210.963 870.59 210.963V209.963ZM904.554 184.43C904.554 192.365 901.268 198.724 895.409 203.114C889.534 207.516 881.035 209.963 870.59 209.963V210.963C881.177 210.963 889.909 208.484 896.009 203.914C902.124 199.333 905.554 192.676 905.554 184.43H904.554ZM859.131 155.786C871.235 158.065 882.616 160.224 890.979 164.345C895.15 166.401 898.539 168.931 900.886 172.18C903.227 175.422 904.554 179.411 904.554 184.43H905.554C905.554 179.221 904.173 175.022 901.696 171.594C899.225 168.173 895.686 165.55 891.421 163.448C882.909 159.254 871.375 157.074 859.317 154.803L859.131 155.786ZM793.686 102.356C793.686 112.591 795.882 120.722 799.672 127.242C803.463 133.763 808.831 138.644 815.132 142.406C827.71 149.918 844.064 153.003 859.133 155.786L859.315 154.803C844.205 152.012 828.04 148.95 815.644 141.548C809.458 137.853 804.226 133.085 800.537 126.74C796.848 120.395 794.686 112.444 794.686 102.356H793.686ZM863.661 44.6387C843.146 44.6387 825.657 49.772 813.285 59.5708C800.899 69.3807 793.686 83.833 793.686 102.356H794.686C794.686 84.1199 801.773 69.9636 813.905 60.3547C826.052 50.7346 843.3 45.6387 863.661 45.6387V44.6387ZM935.971 99.9635C933.538 83.3347 925.742 69.4916 913.394 59.8103C901.049 50.1317 884.188 44.6387 863.661 44.6387V45.6387C884.011 45.6387 900.641 51.0829 912.777 60.5972C924.909 70.1088 932.583 83.7143 934.981 100.108L935.971 99.9635ZM902.646 106.103L935.56 100.529L935.393 99.5429L902.479 105.117L902.646 106.103ZM862.081 74.5335C874.675 74.5335 884.047 77.617 890.573 83.0208C897.095 88.4215 900.833 96.1885 902.066 105.674L903.058 105.545C901.8 95.8686 897.97 87.8474 891.211 82.2506C884.456 76.6568 874.833 73.5335 862.081 73.5335V74.5335ZM828.238 99.0114C828.238 90.885 831.588 84.7958 837.456 80.7187C843.348 76.625 851.82 74.5335 862.081 74.5335V73.5335C851.706 73.5335 843.006 75.6451 836.886 79.8975C830.742 84.1665 827.238 90.5663 827.238 99.0114H828.238ZM871.439 126.872C859.536 124.729 848.713 122.638 840.86 118.618C836.944 116.614 833.795 114.143 831.623 110.972C829.455 107.807 828.238 103.91 828.238 99.0114H827.238C827.238 104.086 828.502 108.185 830.798 111.537C833.09 114.884 836.388 117.453 840.404 119.508C848.415 123.609 859.398 125.72 871.262 127.856L871.439 126.872ZM938.833 179.549C938.833 169.476 936.761 161.504 933.091 155.122C929.421 148.739 924.172 143.979 917.869 140.302C905.29 132.965 888.448 129.91 871.438 126.872L871.262 127.856C888.322 130.904 904.97 133.936 917.366 141.166C923.549 144.773 928.658 149.418 932.224 155.62C935.791 161.823 937.833 169.616 937.833 179.549H938.833ZM870.438 239.858C891.092 239.858 908.192 233.91 920.136 223.376C932.086 212.837 938.833 197.744 938.833 179.549H937.833C937.833 197.481 931.192 212.292 919.475 222.626C907.752 232.965 890.904 238.858 870.438 238.858V239.858ZM791.714 179.85C796.069 215.904 829.141 239.858 870.438 239.858V238.858C829.496 238.858 796.984 215.145 792.707 179.73L791.714 179.85ZM792.241 179.29H792.211V180.29H792.241V179.29ZM954.241 165.404C954.244 143.095 960.39 125.236 971.612 112.96C982.829 100.689 999.172 93.9374 1019.69 93.9374V92.9374C998.943 92.9374 982.313 99.7715 970.874 112.285C959.44 124.793 953.244 142.917 953.241 165.404L954.241 165.404ZM1019.17 236.749C998.536 236.749 982.324 229.863 971.266 217.542C960.201 205.213 954.244 187.383 954.241 165.404L953.241 165.404C953.244 187.556 959.249 205.649 970.521 218.21C981.801 230.778 998.302 237.749 1019.17 237.749V236.749ZM1080.2 189.52C1077.6 203.279 1071.06 215.078 1060.83 223.439C1050.6 231.799 1036.64 236.749 1019.17 236.749V237.749C1036.84 237.749 1051.03 232.741 1061.46 224.213C1071.9 215.686 1078.55 203.667 1081.18 189.706L1080.2 189.52ZM1049.51 184.682L1080.6 190.106L1080.77 189.12L1049.68 183.697L1049.51 184.682ZM1019.17 210.33C1027.57 210.33 1034.48 208.005 1039.71 203.56C1044.94 199.117 1048.44 192.596 1050.09 184.287L1049.11 184.093C1047.5 192.235 1044.08 198.534 1039.06 202.798C1034.05 207.061 1027.38 209.33 1019.17 209.33V210.33ZM985.365 165.69C985.365 180.446 988.276 191.608 993.985 199.091C999.712 206.597 1008.2 210.33 1019.17 210.33V209.33C1008.45 209.33 1000.28 205.696 994.78 198.484C989.259 191.248 986.365 180.34 986.365 165.69H985.365ZM1019.69 120.386C1008.79 120.386 1000.17 124.29 994.301 131.956C988.445 139.602 985.365 150.927 985.365 165.69H986.365C986.365 151.045 989.424 139.969 995.095 132.564C1000.75 125.181 1009.05 121.386 1019.69 121.386V120.386ZM1050.09 146.158C1048.44 137.926 1045 131.473 1039.87 127.078C1034.73 122.682 1027.95 120.386 1019.69 120.386V121.386C1027.76 121.386 1034.3 123.625 1039.22 127.838C1044.14 132.053 1047.5 138.285 1049.11 146.353L1050.09 146.158ZM1080.6 140.34L1049.51 145.763L1049.68 146.748L1080.77 141.325L1080.6 140.34ZM1019.69 93.9374C1037.16 93.9374 1050.99 98.8279 1061.09 107.126C1071.19 115.425 1077.6 127.163 1080.2 140.925L1081.18 140.74C1078.55 126.782 1072.03 114.822 1061.72 106.354C1051.41 97.8845 1037.35 92.9374 1019.69 92.9374V93.9374ZM1158.58 92.9374C1138.08 92.9374 1121.33 99.9415 1109.7 112.521C1098.07 125.096 1091.61 143.192 1091.61 165.298H1092.61C1092.61 143.384 1099.01 125.55 1110.43 113.2C1121.85 100.854 1138.32 93.9374 1158.58 93.9374V92.9374ZM1225.67 165.298C1225.67 143.191 1219.18 125.095 1207.52 112.52C1195.86 99.9414 1179.08 92.9374 1158.58 92.9374V93.9374C1178.84 93.9374 1195.35 100.854 1206.79 113.2C1218.24 125.551 1224.67 143.384 1224.67 165.298H1225.67ZM1158.58 237.658C1179.14 237.658 1195.92 230.655 1207.57 218.075C1219.21 205.501 1225.67 187.404 1225.67 165.298H1224.67C1224.67 187.212 1218.27 205.046 1206.84 217.396C1195.41 229.742 1178.9 236.658 1158.58 236.658V237.658ZM1091.61 165.298C1091.61 187.403 1098.04 205.5 1109.65 218.075C1121.27 230.655 1138.02 237.658 1158.58 237.658V236.658C1138.26 236.658 1121.78 229.742 1110.39 217.397C1098.98 205.046 1092.61 187.213 1092.61 165.298H1091.61ZM1192.54 165.298C1192.54 179.788 1189.4 190.826 1183.6 198.231C1177.82 205.617 1169.36 209.451 1158.58 209.451V210.451C1169.62 210.451 1178.39 206.511 1184.39 198.847C1190.37 191.202 1193.54 179.913 1193.54 165.298H1192.54ZM1158.58 121.145C1169.35 121.145 1177.81 124.978 1183.59 132.365C1189.39 139.77 1192.54 150.808 1192.54 165.298H1193.54C1193.54 150.682 1190.36 139.393 1184.38 131.749C1178.38 124.085 1169.61 120.145 1158.58 120.145V121.145ZM1124.74 165.298C1124.74 150.868 1127.86 139.829 1133.63 132.409C1139.39 125.007 1147.82 121.145 1158.58 121.145V120.145C1147.55 120.145 1138.81 124.116 1132.84 131.795C1126.89 139.455 1123.74 150.743 1123.74 165.298H1124.74ZM1158.58 209.451C1147.88 209.451 1139.45 205.589 1133.68 198.186C1127.89 190.766 1124.74 179.727 1124.74 165.298H1123.74C1123.74 179.854 1126.92 191.142 1132.89 198.801C1138.87 206.479 1147.61 210.451 1158.58 210.451V209.451ZM1244.94 189.372V96.0286H1243.94V189.372H1244.94ZM1244.11 188.987L1244.08 189.017L1244.79 189.726L1244.82 189.696L1244.11 188.987ZM1290.57 236.628C1275.93 236.628 1264.54 231.944 1256.82 223.728C1249.09 215.508 1244.97 203.696 1244.97 189.342H1243.97C1243.97 203.883 1248.14 215.964 1256.09 224.413C1264.04 232.867 1275.7 237.628 1290.57 237.628V236.628ZM1332.04 212.817C1328.41 219.554 1323.5 225.501 1316.78 229.765C1310.07 234.028 1301.52 236.628 1290.57 236.628V237.628C1301.68 237.628 1310.43 234.986 1317.32 230.609C1324.21 226.234 1329.23 220.143 1332.92 213.291L1332.04 212.817ZM1332.98 235.049V213.054H1331.98V235.049H1332.98ZM1364.33 234.549H1332.48V235.549H1364.33V234.549ZM1363.83 95.9984V235.049H1364.83V95.9984H1363.83ZM1332.21 96.4984H1364.33V95.4984H1332.21V96.4984ZM1332.71 174.337V95.9984H1331.71V174.337H1332.71ZM1300.99 209.155C1310.8 209.155 1318.74 205.377 1324.22 199.113C1329.7 192.857 1332.71 184.153 1332.71 174.337H1331.71C1331.71 183.954 1328.77 192.41 1323.47 198.454C1318.18 204.492 1310.52 208.155 1300.99 208.155V209.155ZM1276.06 179.007C1276.06 188.136 1278 195.675 1282.11 200.941C1286.24 206.227 1292.51 209.155 1300.99 209.155V208.155C1292.76 208.155 1286.81 205.328 1282.9 200.325C1278.98 195.302 1277.06 188.016 1277.06 179.007H1276.06ZM1276.06 96.0286V179.007H1277.06V96.0286H1276.06ZM1244.44 96.5286H1276.56V95.5286H1244.44V96.5286ZM1406.93 124.381V198.562H1407.93V124.381H1406.93ZM1381.84 124.881H1407.43V123.881H1381.84V124.881ZM1381.34 96.0286V124.381H1382.34V96.0286H1381.34ZM1407.43 95.5286H1381.84V96.5286H1407.43V95.5286ZM1406.93 63.9098V96.0286H1407.93V63.9098H1406.93ZM1439.42 54.5095L1407.29 63.428L1407.56 64.3916L1439.68 55.4731L1439.42 54.5095ZM1440.05 96.0286V54.9913H1439.05V96.0286H1440.05ZM1473.1 95.5286H1439.55V96.5286H1473.1V95.5286ZM1473.6 124.381V96.0286H1472.6V124.381H1473.6ZM1439.55 124.881H1473.1V123.881H1439.55V124.881ZM1440.05 190.276V124.381H1439.05V190.276H1440.05ZM1459.15 208.667C1449.45 208.667 1444.75 205.701 1442.42 202.03C1440.06 198.307 1440.05 193.733 1440.05 190.276H1439.05C1439.05 193.688 1439.04 198.56 1441.58 202.566C1444.15 206.623 1449.25 209.667 1459.15 209.667V208.667ZM1474.09 207.258C1468.48 208.159 1463.31 208.667 1459.15 208.667V209.667C1463.38 209.667 1468.61 209.151 1474.24 208.245L1474.09 207.258ZM1476.09 233.877L1474.66 207.724L1473.67 207.779L1475.09 233.932L1476.09 233.877ZM1448.82 237.628C1457.89 237.628 1467.19 236.478 1475.71 234.39L1475.47 233.419C1467.03 235.488 1457.8 236.628 1448.82 236.628V237.628ZM1406.93 198.562C1406.93 213.599 1411.13 223.41 1418.55 229.441C1425.95 235.455 1436.44 237.628 1448.82 237.628V236.628C1436.52 236.628 1426.31 234.463 1419.18 228.665C1412.07 222.886 1407.93 213.414 1407.93 198.562H1406.93Z",
            fill: "url(#paint0_linear_13920_5315)",
            fillOpacity: "0.08",
            mask: "url(#path-3-inside-1_13920_5315)"
          })]
        })]
      }), jsxs("defs", {
        children: [jsx("pattern", {
          id: "pattern0",
          patternContentUnits: "objectBoundingBox",
          width: "0.08454",
          height: "0.456242",
          children: jsx("use", {
            xlinkHref: "#image0_13920_5315",
            transform: "scale(0.000384273 0.00207383)"
          })
        }), jsxs("linearGradient", {
          id: "paint0_linear_13920_5315",
          x1: "1912.16",
          y1: "19.1645",
          x2: "1874.73",
          y2: "-192.262",
          gradientUnits: "userSpaceOnUse",
          children: [jsx("stop", {
            stopColor: "white",
            stopOpacity: 0
          }), jsx("stop", {
            offset: "0.496902",
            stopColor: "white"
          }), jsx("stop", {
            offset: 1,
            stopColor: "white",
            stopOpacity: "0.2"
          })]
        }), jsx("clipPath", {
          id: "clip0_13920_5315",
          children: jsx("rect", {
            width: 1476,
            height: 200,
            fill: "white",
            transform: "translate(0 0.783691)"
          })
        }), jsx("image", {
          id: "image0_13920_5315",
          width: 220,
          height: 220,
          xlinkHref: "data:image/png;base64,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"
        })]
      }), jsxs("mask", {
        id: "glow-mask",
        children: [jsx("circle", {
          cx: xy[0],
          cy: xy[1],
          r: GLOW_XY,
          fill: "url(#glow-gradient)",
          fillOpacity: "1"
        }), jsx("defs", {
          children: jsxs("radialGradient", {
            id: "glow-gradient",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(".concat(xy[0], " ").concat(xy[1], ") rotate(90) scale(").concat(GLOW_XY, ")"),
            children: [jsx("stop", {
              stopColor: "white"
            }), jsx("stop", {
              offset: "0.0666667",
              stopColor: "white",
              stopOpacity: "0.991353"
            }), jsx("stop", {
              offset: "0.133333",
              stopColor: "white",
              stopOpacity: "0.96449"
            }), jsx("stop", {
              offset: "0.2",
              stopColor: "white",
              stopOpacity: "0.91834"
            }), jsx("stop", {
              offset: "0.266667",
              stopColor: "white",
              stopOpacity: "0.852589"
            }), jsx("stop", {
              offset: "0.333333",
              stopColor: "white",
              stopOpacity: "0.768225"
            }), jsx("stop", {
              offset: "0.4",
              stopColor: "white",
              stopOpacity: "0.668116"
            }), jsx("stop", {
              offset: "0.466667",
              stopColor: "white",
              stopOpacity: "0.557309"
            }), jsx("stop", {
              offset: "0.533333",
              stopColor: "white",
              stopOpacity: "0.442691"
            }), jsx("stop", {
              offset: "0.6",
              stopColor: "white",
              stopOpacity: "0.331884"
            }), jsx("stop", {
              offset: "0.666667",
              stopColor: "white",
              stopOpacity: "0.231775"
            }), jsx("stop", {
              offset: "0.733333",
              stopColor: "white",
              stopOpacity: "0.147411"
            }), jsx("stop", {
              offset: "0.8",
              stopColor: "white",
              stopOpacity: "0.0816599"
            }), jsx("stop", {
              offset: "0.866667",
              stopColor: "white",
              stopOpacity: "0.03551"
            }), jsx("stop", {
              offset: "0.933333",
              stopColor: "white",
              stopOpacity: "0.01"
            }), jsx("stop", {
              offset: "1",
              stopColor: "white",
              stopOpacity: "0"
            })]
          })
        })]
      }), jsxs("g", {
        clipPath: "url(#clip0_13920_5315)",
        mask: "url(#glow-mask)",
        style: {
          opacity: opacity
        },
        children: [jsx("mask", {
          id: "mask0_13920_5315-3",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "-86",
          y: "-1",
          width: "1562",
          height: "291",
          children: jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.8981 -0.0566406C50.2281 21.2972 50.2281 55.9187 28.8981 77.2726L-69.8009 176.082C-91.1308 154.728 -91.1308 120.107 -69.8009 98.753L28.8981 -0.0566406ZM-69.5851 211.16C-90.9151 232.514 -90.9151 267.136 -69.5851 288.49L141.395 77.2726C162.725 55.9187 162.725 21.2972 141.395 -0.0566331L-69.5851 211.16ZM42.6868 211.934C21.3568 233.288 21.3568 267.91 42.6868 289.264L141.386 190.454C162.716 169.1 162.716 134.479 141.386 113.125L42.6868 211.934ZM542.089 45.1387H574.213V235.079H542.089V45.1387ZM251.273 49.4173H218.116V235.079H251.273V157.283H336.278V235.079H369.435V49.4173H336.278V126.189H251.273V49.4173ZM456.567 93.4374C415.569 93.4374 389.98 121.398 389.98 166.202H390.01C390.01 208.806 413.26 237.158 456.081 237.158C487.141 237.158 506.865 222.274 516.925 201.695L488.843 191.843C483.616 201.545 474.59 210.343 457.236 210.343C435.689 210.343 423.532 196.483 422.104 176.295H518.87V157.404C518.87 118.174 495.225 93.4374 456.567 93.4374ZM486.473 151.438V152.583H422.347C424.717 133.029 436.6 120.223 456.051 120.223C473.951 120.223 486.473 130.859 486.473 151.438ZM637.123 96.0286H605.273V285.698H637.397V211.759C645.359 226.884 658.792 235.049 679.307 235.049C718.998 235.049 739.512 205.401 739.512 164.243C739.512 123.086 718.998 93.4374 679.428 93.4374C658.397 93.4374 645.207 101.723 637.123 117.12V96.0286ZM707.419 164.243C707.419 191.421 694.472 207.872 672.408 207.872C650.313 207.872 637.397 191.421 637.397 164.243C637.397 137.066 650.313 120.615 672.408 120.615C694.502 120.615 707.419 137.066 707.419 164.243ZM792.241 179.79L825.277 174.096C828.286 197.145 845.913 210.463 870.59 210.463C891.621 210.463 905.054 200.61 905.054 184.43C905.054 163.972 883.385 159.844 859.224 155.295C829.045 149.721 794.186 143.001 794.186 102.356C794.186 65.5971 822.785 45.1387 863.661 45.1387C904.538 45.1387 930.644 67.0132 935.476 100.036L902.562 105.61C900.07 86.4471 887.427 74.0335 862.081 74.0335C841.445 74.0335 827.738 82.4398 827.738 99.0114C827.738 118.958 847.584 123.085 871.35 127.364C905.419 133.45 938.333 139.537 938.333 179.549C938.333 215.675 911.558 239.358 870.438 239.358C829.319 239.358 796.526 215.525 792.211 179.79H792.241ZM1019.69 93.4374C978.424 93.4374 953.747 120.609 953.741 165.404C953.747 209.536 977.664 237.249 1019.17 237.249C1054.31 237.249 1075.46 217.333 1080.69 189.613L1049.6 184.19C1046.34 200.641 1035.77 209.83 1019.17 209.83C997.475 209.83 985.865 195.097 985.865 165.69C985.865 136.283 998.143 120.886 1019.69 120.886C1036.01 120.886 1046.34 129.955 1049.6 146.256L1080.69 140.832C1075.46 113.112 1054.82 93.4374 1019.69 93.4374ZM1092.11 165.298C1092.11 121.278 1117.83 93.4374 1158.58 93.4374C1199.33 93.4374 1225.17 121.278 1225.17 165.298C1225.17 209.318 1199.46 237.158 1158.58 237.158C1117.7 237.158 1092.11 209.318 1092.11 165.298ZM1158.58 209.951C1180.4 209.951 1193.04 194.404 1193.04 165.298C1193.04 136.192 1180.37 120.645 1158.58 120.645C1136.79 120.645 1124.24 136.313 1124.24 165.298C1124.24 194.283 1136.91 209.951 1158.58 209.951ZM1244.44 96.0286V189.372L1244.47 189.342C1244.47 218.237 1261.06 237.128 1290.57 237.128C1312.63 237.128 1325.16 226.643 1332.48 213.054V235.049H1364.33V95.9984H1332.21V174.337C1332.21 193.771 1320.32 208.655 1300.99 208.655C1284.28 208.655 1276.56 197.145 1276.56 179.007V96.0286H1244.44ZM1407.43 198.562V124.381H1381.84V96.0286H1407.43V63.9098L1439.55 54.9913V96.0286H1473.1V124.381H1439.55V190.276C1439.55 197.145 1439.55 209.167 1459.15 209.167C1463.35 209.167 1468.54 208.655 1474.17 207.751L1475.59 233.904C1467.11 235.983 1457.84 237.128 1448.82 237.128C1424.14 237.128 1407.43 228.451 1407.43 198.562Z",
            fill: "#1D2B36"
          })
        }), jsxs("g", {
          mask: "url(#mask0_13920_5315-3)",
          children: [jsx("mask", {
            id: "path-2-inside-1_13920_5315-4",
            fill: "white",
            children: jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M28.8981 -0.0566366C50.2281 21.2972 50.2281 55.9187 28.8981 77.2726L-69.8009 176.082C-91.1308 154.728 -91.1308 120.107 -69.8009 98.753L28.8981 -0.0566366ZM-69.5851 211.16C-90.9151 232.514 -90.9151 267.136 -69.5851 288.49L141.395 77.2726C162.725 55.9187 162.725 21.2973 141.395 -0.0566291L-69.5851 211.16ZM42.6868 211.934C21.3568 233.288 21.3568 267.91 42.6868 289.264L141.386 190.454C162.716 169.1 162.716 134.479 141.386 113.125L42.6868 211.934ZM542.089 45.1387H574.213V235.079H542.089V45.1387ZM251.273 49.4173H218.116V235.079H251.273V157.283H336.278V235.079H369.435V49.4173H336.278V126.189H251.273V49.4173ZM456.567 93.4374C415.569 93.4374 389.98 121.398 389.98 166.202H390.01C390.01 208.806 413.26 237.158 456.081 237.158C487.141 237.158 506.865 222.274 516.925 201.695L488.843 191.843C483.616 201.545 474.59 210.343 457.236 210.343C435.689 210.343 423.532 196.483 422.104 176.295H518.87V157.404C518.87 118.174 495.225 93.4374 456.567 93.4374ZM486.473 151.438V152.583H422.347C424.717 133.029 436.6 120.223 456.051 120.223C473.951 120.223 486.473 130.859 486.473 151.438ZM637.123 96.0286H605.273V285.698H637.397V211.759C645.359 226.884 658.792 235.049 679.307 235.049C718.998 235.049 739.512 205.401 739.512 164.243C739.512 123.086 718.998 93.4374 679.428 93.4374C658.397 93.4374 645.207 101.723 637.123 117.12V96.0286ZM707.419 164.243C707.419 191.421 694.472 207.872 672.408 207.872C650.313 207.872 637.397 191.421 637.397 164.243C637.397 137.066 650.313 120.615 672.408 120.615C694.502 120.615 707.419 137.066 707.419 164.243ZM792.241 179.79L825.277 174.096C828.286 197.145 845.913 210.463 870.59 210.463C891.621 210.463 905.054 200.61 905.054 184.43C905.054 163.972 883.385 159.844 859.224 155.295C829.045 149.721 794.186 143.001 794.186 102.356C794.186 65.5971 822.785 45.1387 863.661 45.1387C904.538 45.1387 930.644 67.0132 935.476 100.036L902.562 105.61C900.07 86.4471 887.427 74.0335 862.081 74.0335C841.445 74.0335 827.738 82.4398 827.738 99.0114C827.738 118.958 847.584 123.085 871.35 127.364C905.419 133.45 938.333 139.537 938.333 179.549C938.333 215.675 911.558 239.358 870.438 239.358C829.319 239.358 796.526 215.525 792.211 179.79H792.241ZM1019.69 93.4374C978.424 93.4374 953.747 120.609 953.741 165.404C953.747 209.536 977.664 237.249 1019.17 237.249C1054.31 237.249 1075.46 217.333 1080.69 189.613L1049.6 184.19C1046.34 200.641 1035.77 209.83 1019.17 209.83C997.475 209.83 985.865 195.097 985.865 165.69C985.865 136.283 998.143 120.886 1019.69 120.886C1036.01 120.886 1046.34 129.955 1049.6 146.256L1080.69 140.832C1075.46 113.112 1054.82 93.4374 1019.69 93.4374ZM1092.11 165.298C1092.11 121.278 1117.83 93.4374 1158.58 93.4374C1199.33 93.4374 1225.17 121.278 1225.17 165.298C1225.17 209.318 1199.46 237.158 1158.58 237.158C1117.7 237.158 1092.11 209.318 1092.11 165.298ZM1158.58 209.951C1180.4 209.951 1193.04 194.404 1193.04 165.298C1193.04 136.192 1180.37 120.645 1158.58 120.645C1136.79 120.645 1124.24 136.313 1124.24 165.298C1124.24 194.283 1136.91 209.951 1158.58 209.951ZM1244.44 96.0286V189.372L1244.47 189.342C1244.47 218.237 1261.06 237.128 1290.57 237.128C1312.63 237.128 1325.16 226.643 1332.48 213.054V235.049H1364.33V95.9984H1332.21V174.337C1332.21 193.771 1320.32 208.655 1300.99 208.655C1284.28 208.655 1276.56 197.145 1276.56 179.007V96.0286H1244.44ZM1407.43 198.562V124.381H1381.84V96.0286H1407.43V63.9098L1439.55 54.9913V96.0286H1473.1V124.381H1439.55V190.276C1439.55 197.145 1439.55 209.167 1459.15 209.167C1463.35 209.167 1468.54 208.655 1474.17 207.751L1475.59 233.904C1467.11 235.983 1457.84 237.128 1448.82 237.128C1424.14 237.128 1407.43 228.451 1407.43 198.562Z"
            })
          }), jsx("path", {
            d: "M28.8981 77.2726L29.2518 77.626L29.2518 77.626L28.8981 77.2726ZM28.8981 -0.0566366L29.2518 -0.409992C29.1581 -0.503881 29.0308 -0.556637 28.8981 -0.556637C28.7654 -0.556637 28.6381 -0.503881 28.5443 -0.409992L28.8981 -0.0566366ZM-69.8009 176.082L-70.1546 176.436C-70.0608 176.529 -69.9336 176.582 -69.8009 176.582C-69.6682 176.582 -69.5409 176.529 -69.4471 176.436L-69.8009 176.082ZM-69.8009 98.753L-69.4471 99.1063L-69.4471 99.1063L-69.8009 98.753ZM-69.5851 288.49L-69.9389 288.843C-69.8451 288.937 -69.7178 288.99 -69.5851 288.99C-69.4524 288.99 -69.3252 288.937 -69.2314 288.843L-69.5851 288.49ZM-69.5851 211.16L-69.2314 211.514L-69.2314 211.514L-69.5851 211.16ZM141.395 77.2726L141.042 76.9193L141.042 76.9193L141.395 77.2726ZM141.395 -0.0566291L141.749 -0.409984C141.655 -0.503874 141.528 -0.556629 141.395 -0.556629C141.263 -0.556629 141.135 -0.503874 141.042 -0.409984L141.395 -0.0566291ZM42.6868 289.264L42.3331 289.617C42.4268 289.711 42.5541 289.764 42.6868 289.764C42.8195 289.764 42.9468 289.711 43.0406 289.617L42.6868 289.264ZM42.6868 211.934L43.0406 212.288L43.0406 212.288L42.6868 211.934ZM141.386 190.454L141.032 190.101L141.032 190.101L141.386 190.454ZM141.386 113.125L141.74 112.771C141.646 112.678 141.518 112.625 141.386 112.625C141.253 112.625 141.126 112.678 141.032 112.771L141.386 113.125ZM574.213 45.1387H574.713C574.713 44.8625 574.489 44.6387 574.213 44.6387V45.1387ZM542.089 45.1387V44.6387C541.813 44.6387 541.589 44.8625 541.589 45.1387H542.089ZM574.213 235.079V235.579C574.489 235.579 574.713 235.355 574.713 235.079H574.213ZM542.089 235.079H541.589C541.589 235.355 541.813 235.579 542.089 235.579V235.079ZM218.116 49.4173V48.9173C217.84 48.9173 217.616 49.1411 217.616 49.4173H218.116ZM251.273 49.4173H251.773C251.773 49.1411 251.549 48.9173 251.273 48.9173V49.4173ZM218.116 235.079H217.616C217.616 235.356 217.84 235.579 218.116 235.579V235.079ZM251.273 235.079V235.579C251.549 235.579 251.773 235.356 251.773 235.079H251.273ZM251.273 157.283V156.783C250.997 156.783 250.773 157.007 250.773 157.283H251.273ZM336.278 157.283H336.778C336.778 157.007 336.554 156.783 336.278 156.783V157.283ZM336.278 235.079H335.778C335.778 235.356 336.002 235.579 336.278 235.579V235.079ZM369.435 235.079V235.579C369.711 235.579 369.935 235.356 369.935 235.079H369.435ZM369.435 49.4173H369.935C369.935 49.1411 369.711 48.9173 369.435 48.9173V49.4173ZM336.278 49.4173V48.9173C336.002 48.9173 335.778 49.1411 335.778 49.4173H336.278ZM336.278 126.189V126.689C336.554 126.689 336.778 126.465 336.778 126.189H336.278ZM251.273 126.189H250.773C250.773 126.465 250.997 126.689 251.273 126.689V126.189ZM389.98 166.202H389.48C389.48 166.478 389.704 166.702 389.98 166.702V166.202ZM390.01 166.202H390.51C390.51 165.926 390.286 165.702 390.01 165.702V166.202ZM516.925 201.695L517.374 201.915C517.437 201.786 517.442 201.638 517.388 201.505C517.333 201.373 517.225 201.271 517.09 201.223L516.925 201.695ZM488.843 191.843L489.009 191.371C488.777 191.289 488.52 191.389 488.403 191.605L488.843 191.843ZM422.104 176.295V175.795C421.965 175.795 421.832 175.853 421.738 175.955C421.643 176.056 421.595 176.192 421.605 176.331L422.104 176.295ZM518.87 176.295V176.795C519.146 176.795 519.37 176.572 519.37 176.295H518.87ZM486.473 152.583V153.083C486.749 153.083 486.973 152.859 486.973 152.583H486.473ZM422.347 152.583L421.85 152.523C421.833 152.665 421.878 152.807 421.972 152.915C422.067 153.022 422.204 153.083 422.347 153.083V152.583ZM605.273 96.0286V95.5286C604.997 95.5286 604.773 95.7525 604.773 96.0286H605.273ZM637.123 96.0286H637.623C637.623 95.7525 637.399 95.5286 637.123 95.5286V96.0286ZM605.273 285.698H604.773C604.773 285.974 604.997 286.198 605.273 286.198V285.698ZM637.397 285.698V286.198C637.673 286.198 637.897 285.974 637.897 285.698H637.397ZM637.397 211.759L637.839 211.526C637.732 211.322 637.5 211.218 637.277 211.273C637.054 211.328 636.897 211.529 636.897 211.759H637.397ZM637.123 117.12H636.623C636.623 117.35 636.78 117.55 637.004 117.605C637.227 117.66 637.459 117.556 637.566 117.352L637.123 117.12ZM825.277 174.096L825.773 174.031C825.755 173.896 825.683 173.774 825.573 173.693C825.464 173.613 825.326 173.58 825.192 173.603L825.277 174.096ZM792.241 179.79V180.29C792.27 180.29 792.298 180.288 792.326 180.283L792.241 179.79ZM859.224 155.295L859.317 154.803L859.315 154.803L859.224 155.295ZM935.476 100.036L935.56 100.529C935.828 100.483 936.01 100.232 935.971 99.9635L935.476 100.036ZM902.562 105.61L902.066 105.674C902.084 105.809 902.156 105.931 902.265 106.012C902.374 106.093 902.512 106.126 902.646 106.103L902.562 105.61ZM871.35 127.364L871.262 127.856L871.262 127.856L871.35 127.364ZM792.211 179.79V179.29C792.068 179.29 791.932 179.352 791.837 179.459C791.742 179.566 791.697 179.708 791.714 179.85L792.211 179.79ZM953.741 165.404L953.241 165.404L953.241 165.404L953.741 165.404ZM1080.69 189.613L1081.18 189.706C1081.2 189.574 1081.17 189.438 1081.1 189.328C1081.02 189.218 1080.9 189.143 1080.77 189.12L1080.69 189.613ZM1049.6 184.19L1049.68 183.697C1049.41 183.65 1049.16 183.826 1049.11 184.093L1049.6 184.19ZM1049.6 146.256L1049.11 146.353C1049.16 146.62 1049.41 146.795 1049.68 146.748L1049.6 146.256ZM1080.69 140.832L1080.77 141.325C1080.9 141.302 1081.02 141.227 1081.1 141.117C1081.17 141.007 1081.2 140.871 1081.18 140.74L1080.69 140.832ZM1244.44 189.372H1243.94C1243.94 189.574 1244.06 189.756 1244.24 189.834C1244.43 189.911 1244.65 189.869 1244.79 189.726L1244.44 189.372ZM1244.44 96.0286V95.5286C1244.16 95.5286 1243.94 95.7524 1243.94 96.0286H1244.44ZM1244.47 189.342H1244.97C1244.97 189.14 1244.84 188.958 1244.66 188.88C1244.47 188.803 1244.26 188.845 1244.11 188.987L1244.47 189.342ZM1332.48 213.054H1332.98C1332.98 212.825 1332.82 212.625 1332.6 212.569C1332.38 212.513 1332.15 212.615 1332.04 212.817L1332.48 213.054ZM1332.48 235.049H1331.98C1331.98 235.325 1332.2 235.549 1332.48 235.549V235.049ZM1364.33 235.049V235.549C1364.61 235.549 1364.83 235.325 1364.83 235.049H1364.33ZM1364.33 95.9984H1364.83C1364.83 95.7223 1364.61 95.4984 1364.33 95.4984V95.9984ZM1332.21 95.9984V95.4984C1331.93 95.4984 1331.71 95.7223 1331.71 95.9984H1332.21ZM1276.56 96.0286H1277.06C1277.06 95.7524 1276.84 95.5286 1276.56 95.5286V96.0286ZM1407.43 124.381H1407.93C1407.93 124.105 1407.7 123.881 1407.43 123.881V124.381ZM1381.84 124.381H1381.34C1381.34 124.657 1381.56 124.881 1381.84 124.881V124.381ZM1381.84 96.0286V95.5286C1381.56 95.5286 1381.34 95.7525 1381.34 96.0286H1381.84ZM1407.43 96.0286V96.5286C1407.7 96.5286 1407.93 96.3047 1407.93 96.0286H1407.43ZM1407.43 63.9098L1407.29 63.428C1407.08 63.4881 1406.93 63.6852 1406.93 63.9098H1407.43ZM1439.55 54.9913H1440.05C1440.05 54.8351 1439.98 54.6878 1439.85 54.5932C1439.73 54.4987 1439.57 54.4677 1439.42 54.5095L1439.55 54.9913ZM1439.55 96.0286H1439.05C1439.05 96.3047 1439.27 96.5286 1439.55 96.5286V96.0286ZM1473.1 96.0286H1473.6C1473.6 95.7525 1473.38 95.5286 1473.1 95.5286V96.0286ZM1473.1 124.381V124.881C1473.38 124.881 1473.6 124.657 1473.6 124.381H1473.1ZM1439.55 124.381V123.881C1439.27 123.881 1439.05 124.105 1439.05 124.381H1439.55ZM1474.17 207.751L1474.66 207.724C1474.66 207.583 1474.59 207.451 1474.48 207.362C1474.37 207.273 1474.23 207.235 1474.09 207.258L1474.17 207.751ZM1475.59 233.904L1475.71 234.39C1475.95 234.333 1476.11 234.117 1476.09 233.877L1475.59 233.904ZM29.2518 77.626C50.7768 56.0769 50.7768 21.1391 29.2518 -0.409992L28.5443 0.296719C49.6793 21.4554 49.6793 55.7606 28.5443 76.9193L29.2518 77.626ZM-69.4471 176.436L29.2518 77.626L28.5443 76.9193L-70.1546 175.729L-69.4471 176.436ZM-70.1546 98.3996C-91.6796 119.949 -91.6796 154.886 -70.1546 176.436L-69.4471 175.729C-90.5821 154.57 -90.5821 120.265 -69.4471 99.1063L-70.1546 98.3996ZM28.5443 -0.409992L-70.1546 98.3996L-69.4471 99.1063L29.2518 0.296719L28.5443 -0.409992ZM-69.2314 288.136C-90.3664 266.978 -90.3664 232.672 -69.2314 211.514L-69.9389 210.807C-91.4639 232.356 -91.4638 267.294 -69.9389 288.843L-69.2314 288.136ZM141.042 76.9193L-69.9389 288.136L-69.2314 288.843L141.749 77.626L141.042 76.9193ZM141.042 0.296726C162.177 21.4554 162.177 55.7606 141.042 76.9193L141.749 77.626C163.274 56.0769 163.274 21.1391 141.749 -0.409984L141.042 0.296726ZM-69.2314 211.514L141.749 0.296726L141.042 -0.409984L-69.9389 210.807L-69.2314 211.514ZM43.0406 288.91C21.9056 267.752 21.9056 233.446 43.0406 212.288L42.3331 211.581C20.8081 233.13 20.8081 268.068 42.3331 289.617L43.0406 288.91ZM141.032 190.101L42.3331 288.91L43.0406 289.617L141.74 190.807L141.032 190.101ZM141.032 113.478C162.167 134.637 162.167 168.942 141.032 190.101L141.74 190.807C163.264 169.258 163.264 134.321 141.74 112.771L141.032 113.478ZM43.0406 212.288L141.74 113.478L141.032 112.771L42.3331 211.581L43.0406 212.288ZM574.213 44.6387H542.089V45.6387H574.213V44.6387ZM574.713 235.079V45.1387H573.713V235.079H574.713ZM542.089 235.579H574.213V234.579H542.089V235.579ZM541.589 45.1387V235.079H542.589V45.1387H541.589ZM218.116 49.9173H251.273V48.9173H218.116V49.9173ZM218.616 235.079V49.4173H217.616V235.079H218.616ZM251.273 234.579H218.116V235.579H251.273V234.579ZM250.773 157.283V235.079H251.773V157.283H250.773ZM336.278 156.783H251.273V157.783H336.278V156.783ZM336.778 235.079V157.283H335.778V235.079H336.778ZM369.435 234.579H336.278V235.579H369.435V234.579ZM368.935 49.4173V235.079H369.935V49.4173H368.935ZM336.278 49.9173H369.435V48.9173H336.278V49.9173ZM336.778 126.189V49.4173H335.778V126.189H336.778ZM251.273 126.689H336.278V125.689H251.273V126.689ZM250.773 49.4173V126.189H251.773V49.4173H250.773ZM390.48 166.202C390.48 143.893 396.85 125.833 408.268 113.356C419.682 100.884 436.187 93.9374 456.567 93.9374V92.9374C435.95 92.9374 419.161 99.9718 407.53 112.681C395.905 125.385 389.48 143.707 389.48 166.202H390.48ZM390.01 165.702H389.98V166.702H390.01V165.702ZM456.081 236.658C434.786 236.658 418.414 229.613 407.359 217.322C396.298 205.024 390.51 187.417 390.51 166.202H389.51C389.51 187.591 395.347 205.462 406.616 217.991C417.892 230.528 434.554 237.658 456.081 237.658V236.658ZM516.476 201.476C506.5 221.883 486.95 236.658 456.081 236.658V237.658C487.333 237.658 507.231 222.665 517.374 201.915L516.476 201.476ZM488.678 192.314L516.759 202.167L517.09 201.223L489.009 191.371L488.678 192.314ZM457.236 210.843C466.002 210.843 472.696 208.619 477.866 205.146C483.031 201.676 486.643 196.98 489.283 192.08L488.403 191.605C485.816 196.407 482.302 200.961 477.308 204.316C472.319 207.667 465.823 209.843 457.236 209.843V210.843ZM421.605 176.331C422.325 186.514 425.756 195.148 431.769 201.24C437.788 207.338 446.35 210.843 457.236 210.843V209.843C446.575 209.843 438.284 206.417 432.481 200.538C426.672 194.653 423.31 186.264 422.602 176.26L421.605 176.331ZM518.87 175.795H422.104V176.795H518.87V175.795ZM518.37 157.404V176.295H519.37V157.404H518.37ZM456.567 93.9374C475.787 93.9374 491.224 100.084 501.856 111.057C512.491 122.033 518.37 137.889 518.37 157.404H519.37C519.37 137.689 513.427 121.562 502.575 110.362C491.72 99.1592 476.006 92.9374 456.567 92.9374V93.9374ZM486.973 152.583V151.438H485.973V152.583H486.973ZM422.347 153.083H486.473V152.083H422.347V153.083ZM456.051 119.723C446.209 119.723 438.244 122.966 432.442 128.715C426.645 134.458 423.046 142.662 421.85 152.523L422.843 152.643C424.018 142.95 427.545 134.974 433.146 129.425C438.74 123.883 446.442 120.723 456.051 120.723V119.723ZM486.973 151.438C486.973 141.045 483.808 133.101 478.323 127.755C472.841 122.413 465.099 119.723 456.051 119.723V120.723C464.903 120.723 472.372 123.352 477.625 128.472C482.876 133.589 485.973 141.252 485.973 151.438H486.973ZM605.273 96.5286H637.123V95.5286H605.273V96.5286ZM605.773 285.698V96.0286H604.773V285.698H605.773ZM637.397 285.198H605.273V286.198H637.397V285.198ZM636.897 211.759V285.698H637.897V211.759H636.897ZM679.307 234.549C669.116 234.549 660.719 232.521 653.892 228.641C647.068 224.763 641.782 219.016 637.839 211.526L636.954 211.992C640.974 219.627 646.386 225.525 653.398 229.511C660.407 233.494 668.983 235.549 679.307 235.549V234.549ZM739.012 164.243C739.012 184.746 733.902 202.325 723.904 214.767C713.917 227.195 699.015 234.549 679.307 234.549V235.549C699.289 235.549 714.49 228.079 724.683 215.394C734.865 202.723 740.012 184.898 740.012 164.243H739.012ZM679.428 93.9374C699.075 93.9374 713.947 101.291 723.919 113.719C733.902 126.162 739.012 143.741 739.012 164.243H740.012C740.012 143.588 734.865 125.764 724.699 113.093C714.521 100.408 699.351 92.9374 679.428 92.9374V93.9374ZM637.566 117.352C641.572 109.723 646.829 103.879 653.67 99.9382C660.514 95.9956 668.978 93.9374 679.428 93.9374V92.9374C668.847 92.9374 660.201 95.0221 653.171 99.0716C646.139 103.123 640.759 109.12 636.681 116.887L637.566 117.352ZM636.623 96.0286V117.12H637.623V96.0286H636.623ZM672.408 208.372C683.576 208.372 692.479 204.202 698.578 196.561C704.666 188.935 707.919 177.904 707.919 164.243H706.919C706.919 177.76 703.699 188.543 697.797 195.937C691.906 203.316 683.304 207.372 672.408 207.372V208.372ZM636.897 164.243C636.897 177.904 640.142 188.935 646.226 196.561C652.321 204.202 661.224 208.372 672.408 208.372V207.372C661.497 207.372 652.894 203.316 647.008 195.937C641.11 188.544 637.897 177.76 637.897 164.243H636.897ZM672.408 120.115C661.224 120.115 652.321 124.285 646.226 131.926C640.142 139.552 636.897 150.583 636.897 164.243H637.897C637.897 150.727 641.11 139.943 647.008 132.549C652.894 125.17 661.497 121.115 672.408 121.115V120.115ZM707.919 164.243C707.919 150.583 704.673 139.552 698.59 131.926C692.494 124.285 683.591 120.115 672.408 120.115V121.115C683.319 121.115 691.921 125.17 697.808 132.549C703.706 139.943 706.919 150.727 706.919 164.243H707.919ZM825.192 173.603L792.156 179.298L792.326 180.283L825.362 174.589L825.192 173.603ZM870.59 209.963C858.34 209.963 847.88 206.658 840.117 200.531C832.36 194.407 827.261 185.437 825.773 174.031L824.781 174.161C826.301 185.804 831.52 195.018 839.498 201.315C847.471 207.609 858.163 210.963 870.59 210.963V209.963ZM904.554 184.43C904.554 192.365 901.268 198.724 895.409 203.114C889.534 207.516 881.035 209.963 870.59 209.963V210.963C881.177 210.963 889.909 208.484 896.009 203.914C902.124 199.333 905.554 192.676 905.554 184.43H904.554ZM859.131 155.786C871.235 158.065 882.616 160.224 890.979 164.345C895.15 166.401 898.539 168.931 900.886 172.18C903.227 175.422 904.554 179.411 904.554 184.43H905.554C905.554 179.221 904.173 175.022 901.696 171.594C899.225 168.173 895.686 165.55 891.421 163.448C882.909 159.254 871.375 157.074 859.317 154.803L859.131 155.786ZM793.686 102.356C793.686 112.591 795.882 120.722 799.672 127.242C803.463 133.763 808.831 138.644 815.132 142.406C827.71 149.918 844.064 153.003 859.133 155.786L859.315 154.803C844.205 152.012 828.04 148.95 815.644 141.548C809.458 137.853 804.226 133.085 800.537 126.74C796.848 120.395 794.686 112.444 794.686 102.356H793.686ZM863.661 44.6387C843.146 44.6387 825.657 49.772 813.285 59.5708C800.899 69.3807 793.686 83.833 793.686 102.356H794.686C794.686 84.1199 801.773 69.9636 813.905 60.3547C826.052 50.7346 843.3 45.6387 863.661 45.6387V44.6387ZM935.971 99.9635C933.538 83.3347 925.742 69.4916 913.394 59.8103C901.049 50.1317 884.188 44.6387 863.661 44.6387V45.6387C884.011 45.6387 900.641 51.0829 912.777 60.5972C924.909 70.1088 932.583 83.7143 934.981 100.108L935.971 99.9635ZM902.646 106.103L935.56 100.529L935.393 99.5429L902.479 105.117L902.646 106.103ZM862.081 74.5335C874.675 74.5335 884.047 77.617 890.573 83.0208C897.095 88.4215 900.833 96.1885 902.066 105.674L903.058 105.545C901.8 95.8686 897.97 87.8474 891.211 82.2506C884.456 76.6568 874.833 73.5335 862.081 73.5335V74.5335ZM828.238 99.0114C828.238 90.885 831.588 84.7958 837.456 80.7187C843.348 76.625 851.82 74.5335 862.081 74.5335V73.5335C851.706 73.5335 843.006 75.6451 836.886 79.8975C830.742 84.1665 827.238 90.5663 827.238 99.0114H828.238ZM871.439 126.872C859.536 124.729 848.713 122.638 840.86 118.618C836.944 116.614 833.795 114.143 831.623 110.972C829.455 107.807 828.238 103.91 828.238 99.0114H827.238C827.238 104.086 828.502 108.185 830.798 111.537C833.09 114.884 836.388 117.453 840.404 119.508C848.415 123.609 859.398 125.72 871.262 127.856L871.439 126.872ZM938.833 179.549C938.833 169.476 936.761 161.504 933.091 155.122C929.421 148.739 924.172 143.979 917.869 140.302C905.29 132.965 888.448 129.91 871.438 126.872L871.262 127.856C888.322 130.904 904.97 133.936 917.366 141.166C923.549 144.773 928.658 149.418 932.224 155.62C935.791 161.823 937.833 169.616 937.833 179.549H938.833ZM870.438 239.858C891.092 239.858 908.192 233.91 920.136 223.376C932.086 212.837 938.833 197.744 938.833 179.549H937.833C937.833 197.481 931.192 212.292 919.475 222.626C907.752 232.965 890.904 238.858 870.438 238.858V239.858ZM791.714 179.85C796.069 215.904 829.141 239.858 870.438 239.858V238.858C829.496 238.858 796.984 215.145 792.707 179.73L791.714 179.85ZM792.241 179.29H792.211V180.29H792.241V179.29ZM954.241 165.404C954.244 143.095 960.39 125.236 971.612 112.96C982.829 100.689 999.172 93.9374 1019.69 93.9374V92.9374C998.943 92.9374 982.313 99.7715 970.874 112.285C959.44 124.793 953.244 142.917 953.241 165.404L954.241 165.404ZM1019.17 236.749C998.536 236.749 982.324 229.863 971.266 217.542C960.201 205.213 954.244 187.383 954.241 165.404L953.241 165.404C953.244 187.556 959.249 205.649 970.521 218.21C981.801 230.778 998.302 237.749 1019.17 237.749V236.749ZM1080.2 189.52C1077.6 203.279 1071.06 215.078 1060.83 223.439C1050.6 231.799 1036.64 236.749 1019.17 236.749V237.749C1036.84 237.749 1051.03 232.741 1061.46 224.213C1071.9 215.686 1078.55 203.667 1081.18 189.706L1080.2 189.52ZM1049.51 184.682L1080.6 190.106L1080.77 189.12L1049.68 183.697L1049.51 184.682ZM1019.17 210.33C1027.57 210.33 1034.48 208.005 1039.71 203.56C1044.94 199.117 1048.44 192.596 1050.09 184.287L1049.11 184.093C1047.5 192.235 1044.08 198.534 1039.06 202.798C1034.05 207.061 1027.38 209.33 1019.17 209.33V210.33ZM985.365 165.69C985.365 180.446 988.276 191.608 993.985 199.091C999.712 206.597 1008.2 210.33 1019.17 210.33V209.33C1008.45 209.33 1000.28 205.696 994.78 198.484C989.259 191.248 986.365 180.34 986.365 165.69H985.365ZM1019.69 120.386C1008.79 120.386 1000.17 124.29 994.301 131.956C988.445 139.602 985.365 150.927 985.365 165.69H986.365C986.365 151.045 989.424 139.969 995.095 132.564C1000.75 125.181 1009.05 121.386 1019.69 121.386V120.386ZM1050.09 146.158C1048.44 137.926 1045 131.473 1039.87 127.078C1034.73 122.682 1027.95 120.386 1019.69 120.386V121.386C1027.76 121.386 1034.3 123.625 1039.22 127.838C1044.14 132.053 1047.5 138.285 1049.11 146.353L1050.09 146.158ZM1080.6 140.34L1049.51 145.763L1049.68 146.748L1080.77 141.325L1080.6 140.34ZM1019.69 93.9374C1037.16 93.9374 1050.99 98.8279 1061.09 107.126C1071.19 115.425 1077.6 127.163 1080.2 140.925L1081.18 140.74C1078.55 126.782 1072.03 114.822 1061.72 106.354C1051.41 97.8845 1037.35 92.9374 1019.69 92.9374V93.9374ZM1158.58 92.9374C1138.08 92.9374 1121.33 99.9415 1109.7 112.521C1098.07 125.096 1091.61 143.192 1091.61 165.298H1092.61C1092.61 143.384 1099.01 125.55 1110.43 113.2C1121.85 100.854 1138.32 93.9374 1158.58 93.9374V92.9374ZM1225.67 165.298C1225.67 143.191 1219.18 125.095 1207.52 112.52C1195.86 99.9414 1179.08 92.9374 1158.58 92.9374V93.9374C1178.84 93.9374 1195.35 100.854 1206.79 113.2C1218.24 125.551 1224.67 143.384 1224.67 165.298H1225.67ZM1158.58 237.658C1179.14 237.658 1195.92 230.655 1207.57 218.075C1219.21 205.501 1225.67 187.404 1225.67 165.298H1224.67C1224.67 187.212 1218.27 205.046 1206.84 217.396C1195.41 229.742 1178.9 236.658 1158.58 236.658V237.658ZM1091.61 165.298C1091.61 187.403 1098.04 205.5 1109.65 218.075C1121.27 230.655 1138.02 237.658 1158.58 237.658V236.658C1138.26 236.658 1121.78 229.742 1110.39 217.397C1098.98 205.046 1092.61 187.213 1092.61 165.298H1091.61ZM1192.54 165.298C1192.54 179.788 1189.4 190.826 1183.6 198.231C1177.82 205.617 1169.36 209.451 1158.58 209.451V210.451C1169.62 210.451 1178.39 206.511 1184.39 198.847C1190.37 191.202 1193.54 179.913 1193.54 165.298H1192.54ZM1158.58 121.145C1169.35 121.145 1177.81 124.978 1183.59 132.365C1189.39 139.77 1192.54 150.808 1192.54 165.298H1193.54C1193.54 150.682 1190.36 139.393 1184.38 131.749C1178.38 124.085 1169.61 120.145 1158.58 120.145V121.145ZM1124.74 165.298C1124.74 150.868 1127.86 139.829 1133.63 132.409C1139.39 125.007 1147.82 121.145 1158.58 121.145V120.145C1147.55 120.145 1138.81 124.116 1132.84 131.795C1126.89 139.455 1123.74 150.743 1123.74 165.298H1124.74ZM1158.58 209.451C1147.88 209.451 1139.45 205.589 1133.68 198.186C1127.89 190.766 1124.74 179.727 1124.74 165.298H1123.74C1123.74 179.854 1126.92 191.142 1132.89 198.801C1138.87 206.479 1147.61 210.451 1158.58 210.451V209.451ZM1244.94 189.372V96.0286H1243.94V189.372H1244.94ZM1244.11 188.987L1244.08 189.017L1244.79 189.726L1244.82 189.696L1244.11 188.987ZM1290.57 236.628C1275.93 236.628 1264.54 231.944 1256.82 223.728C1249.09 215.508 1244.97 203.696 1244.97 189.342H1243.97C1243.97 203.883 1248.14 215.964 1256.09 224.413C1264.04 232.867 1275.7 237.628 1290.57 237.628V236.628ZM1332.04 212.817C1328.41 219.554 1323.5 225.501 1316.78 229.765C1310.07 234.028 1301.52 236.628 1290.57 236.628V237.628C1301.68 237.628 1310.43 234.986 1317.32 230.609C1324.21 226.234 1329.23 220.143 1332.92 213.291L1332.04 212.817ZM1332.98 235.049V213.054H1331.98V235.049H1332.98ZM1364.33 234.549H1332.48V235.549H1364.33V234.549ZM1363.83 95.9984V235.049H1364.83V95.9984H1363.83ZM1332.21 96.4984H1364.33V95.4984H1332.21V96.4984ZM1332.71 174.337V95.9984H1331.71V174.337H1332.71ZM1300.99 209.155C1310.8 209.155 1318.74 205.377 1324.22 199.113C1329.7 192.857 1332.71 184.153 1332.71 174.337H1331.71C1331.71 183.954 1328.77 192.41 1323.47 198.454C1318.18 204.492 1310.52 208.155 1300.99 208.155V209.155ZM1276.06 179.007C1276.06 188.136 1278 195.675 1282.11 200.941C1286.24 206.227 1292.51 209.155 1300.99 209.155V208.155C1292.76 208.155 1286.81 205.328 1282.9 200.325C1278.98 195.302 1277.06 188.016 1277.06 179.007H1276.06ZM1276.06 96.0286V179.007H1277.06V96.0286H1276.06ZM1244.44 96.5286H1276.56V95.5286H1244.44V96.5286ZM1406.93 124.381V198.562H1407.93V124.381H1406.93ZM1381.84 124.881H1407.43V123.881H1381.84V124.881ZM1381.34 96.0286V124.381H1382.34V96.0286H1381.34ZM1407.43 95.5286H1381.84V96.5286H1407.43V95.5286ZM1406.93 63.9098V96.0286H1407.93V63.9098H1406.93ZM1439.42 54.5095L1407.29 63.428L1407.56 64.3916L1439.68 55.4731L1439.42 54.5095ZM1440.05 96.0286V54.9913H1439.05V96.0286H1440.05ZM1473.1 95.5286H1439.55V96.5286H1473.1V95.5286ZM1473.6 124.381V96.0286H1472.6V124.381H1473.6ZM1439.55 124.881H1473.1V123.881H1439.55V124.881ZM1440.05 190.276V124.381H1439.05V190.276H1440.05ZM1459.15 208.667C1449.45 208.667 1444.75 205.701 1442.42 202.03C1440.06 198.307 1440.05 193.733 1440.05 190.276H1439.05C1439.05 193.688 1439.04 198.56 1441.58 202.566C1444.15 206.623 1449.25 209.667 1459.15 209.667V208.667ZM1474.09 207.258C1468.48 208.159 1463.31 208.667 1459.15 208.667V209.667C1463.38 209.667 1468.61 209.151 1474.24 208.245L1474.09 207.258ZM1476.09 233.877L1474.66 207.724L1473.67 207.779L1475.09 233.932L1476.09 233.877ZM1448.82 237.628C1457.89 237.628 1467.19 236.478 1475.71 234.39L1475.47 233.419C1467.03 235.488 1457.8 236.628 1448.82 236.628V237.628ZM1406.93 198.562C1406.93 213.599 1411.13 223.41 1418.55 229.441C1425.95 235.455 1436.44 237.628 1448.82 237.628V236.628C1436.52 236.628 1426.31 234.463 1419.18 228.665C1412.07 222.886 1407.93 213.414 1407.93 198.562H1406.93Z",
            fill: "white",
            mask: "url(#path-2-inside-1_13920_5315-4)"
          })]
        })]
      })]
    })
  });
};

var SiteFooterResponsibility = function () {
  return jsxs("div", {
    className: "responsibility",
    children: [jsxs("svg", {
      width: "44",
      height: "75",
      viewBox: "0 0 44 75",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.7654 44.0964H24.9474C27.7644 44.0964 29.5529 42.3621 29.5529 39.6555C29.5529 36.428 26.9751 35.5258 24.224 35.5258H16.7654V44.0964ZM16.7654 32.75H23.2984C27.0085 32.75 28.5226 31.3971 28.5226 28.7939C28.5226 25.3582 26.1176 24.8734 23.2984 24.8734H16.7654V32.75ZM13.5021 22.0971H22.4026C24.5692 22.0971 27.4214 22.0971 28.899 22.9993C30.5146 23.9707 31.785 25.7405 31.785 28.1701C31.785 30.807 30.4122 32.785 28.143 33.721V33.7907C31.169 34.4149 32.8171 36.7055 32.8171 39.7598C32.8171 43.4019 30.2389 46.8727 25.3594 46.8727H13.5021V22.0971Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.4979 12.7776C10.6259 12.7776 0.999725 22.4964 0.999725 34.485C0.999725 46.4723 10.6259 56.192 22.4979 56.192C34.374 56.192 44.0001 46.4723 44.0001 34.485C44.0001 22.4964 34.374 12.7776 22.4979 12.7776ZM41.1649 34.4954C41.1649 44.9036 32.8092 53.3414 22.4979 53.3414C12.1903 53.3414 3.83456 44.9036 3.83456 34.4954C3.83456 24.088 12.1903 15.652 22.4979 15.652C32.8092 15.652 41.1649 24.088 41.1649 34.4954Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.04436 63.6185H43.9557V60.7707H1.04436V63.6185Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.4486 57.2038C41.5177 57.0478 41.6108 56.9155 41.727 56.7973C41.8442 56.6808 41.9823 56.5944 42.1391 56.5265C42.2941 56.4599 42.4625 56.4294 42.6344 56.4294C42.813 56.4294 42.9787 56.4599 43.1369 56.5265C43.2901 56.5944 43.4251 56.6808 43.5396 56.7973C43.6558 56.9155 43.752 57.0478 43.818 57.2038C43.8892 57.3617 43.9213 57.5326 43.9213 57.717C43.9213 57.9032 43.8892 58.0737 43.818 58.2293C43.752 58.3898 43.6558 58.5248 43.5396 58.6412C43.4251 58.7609 43.2901 58.8481 43.1369 58.9151C42.9787 58.979 42.813 59.011 42.6344 59.011C42.4625 59.011 42.2941 58.979 42.1391 58.9151C41.9823 58.8481 41.8442 58.7609 41.727 58.6412C41.6108 58.5248 41.5177 58.3898 41.4486 58.2293C41.3773 58.0737 41.3484 57.9032 41.3484 57.717C41.3484 57.5326 41.3773 57.3617 41.4486 57.2038ZM41.6615 58.1528C41.7114 58.29 41.7854 58.4078 41.882 58.5068C41.9751 58.6053 42.0878 58.6835 42.2184 58.7406C42.3449 58.7964 42.487 58.8221 42.6344 58.8221C42.7854 58.8221 42.9248 58.7964 43.0509 58.7406C43.1787 58.6835 43.2901 58.6053 43.3872 58.5068C43.479 58.4078 43.5547 58.29 43.6068 58.1528C43.662 58.0197 43.6892 57.8722 43.6892 57.717C43.6892 57.5582 43.662 57.417 43.6068 57.2825C43.5547 57.1472 43.479 57.032 43.3872 56.9331C43.2901 56.8364 43.1787 56.7595 43.0509 56.7024C42.9248 56.6479 42.7854 56.6174 42.6344 56.6174C42.487 56.6174 42.3449 56.6479 42.2184 56.7024C42.0878 56.7595 41.9751 56.8364 41.882 56.9331C41.7854 57.032 41.7114 57.1472 41.6615 57.2825C41.6063 57.417 41.58 57.5582 41.58 57.717C41.58 57.8722 41.6063 58.0197 41.6615 58.1528ZM42.7164 56.9637C42.895 56.9637 43.0251 56.9996 43.111 57.0694C43.1974 57.1431 43.2415 57.2502 43.2415 57.3954C43.2415 57.5326 43.2019 57.6298 43.1284 57.6963C43.0509 57.7584 42.9587 57.7962 42.8442 57.8092L43.2732 58.4739H43.0251L42.6157 57.8231H42.3698V58.4739H42.1342V56.9637H42.7164ZM42.613 57.6351C42.666 57.6351 42.7164 57.6324 42.7631 57.6297C42.8068 57.6275 42.8513 57.6176 42.887 57.6014C42.9248 57.5825 42.9542 57.5582 42.9752 57.5263C42.9974 57.4912 43.0059 57.4471 43.0059 57.3851C43.0059 57.3352 42.9974 57.2929 42.9774 57.2659C42.9587 57.2335 42.9324 57.2124 42.9017 57.1971C42.87 57.1786 42.8375 57.1683 42.7961 57.1607C42.7565 57.1584 42.7186 57.1544 42.6781 57.1544H42.3698V57.6351H42.613Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.24474 3.23283C6.14273 3.06822 6.01623 2.92385 5.86433 2.79972C5.71154 2.67514 5.54004 2.57844 5.34761 2.50873C5.15562 2.43947 4.95472 2.40439 4.74447 2.40439C4.36094 2.40439 4.03443 2.4795 3.76671 2.62926C3.49855 2.77948 3.28118 2.98052 3.11458 3.23283C2.94798 3.48515 2.82637 3.77254 2.7502 4.09456C2.67358 4.41614 2.63617 4.74941 2.63617 5.09302C2.63617 5.42179 2.67358 5.74202 2.7502 6.0528C2.82637 6.36403 2.94798 6.64377 3.11458 6.89249C3.28118 7.1412 3.49855 7.34044 3.76671 7.49066C4.03443 7.64043 4.36094 7.71509 4.74447 7.71509C5.26654 7.71509 5.67412 7.55452 5.96723 7.23295C6.26033 6.91093 6.43985 6.48681 6.50488 5.96015H8.15705C8.11339 6.44993 8.00114 6.89249 7.82029 7.28737C7.63899 7.68271 7.39979 8.01957 7.10312 8.29662C6.80601 8.57502 6.45811 8.7873 6.05943 8.93347C5.66076 9.07964 5.22288 9.15295 4.74447 9.15295C4.15024 9.15295 3.61615 9.04861 3.1413 8.83992C2.66735 8.63169 2.266 8.34474 1.94082 7.97864C1.61475 7.61299 1.36441 7.18348 1.19069 6.68965C1.01652 6.19582 0.929656 5.66376 0.929656 5.09302C0.929656 4.50744 1.01652 3.96414 1.19069 3.46311C1.36441 2.96208 1.61475 2.52492 1.94082 2.15207C2.266 1.77878 2.66735 1.48644 3.1413 1.27415C3.61615 1.06232 4.15024 0.956177 4.74447 0.956177C5.1721 0.956177 5.57612 1.01869 5.95654 1.14238C6.3365 1.26696 6.67727 1.44821 6.97795 1.68613C7.27818 1.9236 7.52674 2.21819 7.72185 2.569C7.91829 2.92025 8.04123 3.32279 8.09157 3.77614H6.43985C6.41089 3.5787 6.34586 3.39744 6.24474 3.23283Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.1265 4.63193C11.9416 4.42729 11.6601 4.32475 11.2837 4.32475C11.0378 4.32475 10.8329 4.36703 10.6699 4.45113C10.5068 4.53523 10.3763 4.63913 10.2788 4.76326C10.1808 4.88829 10.1122 5.01962 10.0721 5.15904C10.0324 5.29802 10.0084 5.4217 10.0012 5.53189H12.5122C12.4396 5.13655 12.3109 4.83657 12.1265 4.63193ZM10.3821 7.61695C10.6137 7.84318 10.9474 7.95652 11.3817 7.95652C11.6935 7.95652 11.9617 7.87781 12.1862 7.72085C12.4107 7.56388 12.5479 7.39702 12.5995 7.22117H13.9577C13.7399 7.9021 13.4067 8.38873 12.9577 8.68107C12.5082 8.97341 11.9652 9.12003 11.3273 9.12003C10.8855 9.12003 10.4868 9.04852 10.1318 8.90595C9.77719 8.76338 9.47651 8.56054 9.22973 8.29653C8.9834 8.03342 8.79319 7.71905 8.65911 7.3534C8.52503 6.98774 8.45822 6.58521 8.45822 6.14625C8.45822 5.72214 8.52726 5.3268 8.6649 4.96115C8.8021 4.59505 8.99854 4.27887 9.25156 4.01217C9.50546 3.74502 9.80792 3.53498 10.1594 3.38116C10.5104 3.22735 10.8997 3.15089 11.3273 3.15089C11.8053 3.15089 12.2223 3.24399 12.5773 3.43064C12.9323 3.61728 13.2241 3.86735 13.4521 4.18218C13.6802 4.497 13.845 4.85546 13.9466 5.25754C14.0473 5.66007 14.0842 6.08059 14.0548 6.51955H10.0012C10.0231 7.02417 10.15 7.38983 10.3821 7.61695Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.2177 3.30444V4.35776H16.2396C16.3122 4.18236 16.4102 4.01954 16.5331 3.86933C16.6561 3.71956 16.7977 3.59138 16.9567 3.48524C17.1162 3.37954 17.2864 3.29679 17.4681 3.23832C17.649 3.17985 17.8374 3.15107 18.0329 3.15107C18.1345 3.15107 18.2463 3.16906 18.3701 3.20549V4.6537C18.2971 4.63931 18.2107 4.62671 18.1087 4.61547C18.0076 4.60468 17.9096 4.59883 17.8156 4.59883C17.5327 4.59883 17.2939 4.64695 17.0984 4.74185C16.9024 4.83675 16.7451 4.96673 16.6253 5.13134C16.5059 5.29595 16.4204 5.48754 16.3701 5.70747C16.3197 5.92695 16.2944 6.16442 16.2944 6.42034V8.97719H14.7504V3.30444H16.2177Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.5001 3.30443V4.34652H21.3691V7.15568C21.3691 7.41924 21.4132 7.59464 21.5001 7.68234C21.5869 7.7705 21.7611 7.81412 22.0213 7.81412C22.1081 7.81412 22.1919 7.81053 22.2712 7.80333C22.3509 7.79613 22.4271 7.78489 22.5001 7.7705V8.97719C22.3696 8.99968 22.2239 9.01362 22.0645 9.02081C21.9059 9.02846 21.75 9.03251 21.5976 9.03251C21.3584 9.03251 21.1317 9.01587 20.9179 8.98259C20.7045 8.9502 20.5165 8.88634 20.3535 8.79099C20.19 8.69564 20.0613 8.56072 19.9669 8.38486C19.8729 8.20901 19.8265 7.97873 19.8265 7.69404V4.34652H18.8915V3.30443H19.8265V1.60346H21.3691V3.30443H22.5001Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.3987 8.97741H24.9422V3.30466H23.3987V8.97741ZM23.3987 2.42629H24.9422V1.14224H23.3987V2.42629Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5539 4.34647V3.30439H26.4773V2.86543C26.4773 2.3608 26.6332 1.94748 26.945 1.62591C27.2559 1.30343 27.7277 1.14242 28.358 1.14242C28.4952 1.14242 28.6333 1.14827 28.7714 1.15906C28.9077 1.1703 29.0422 1.1793 29.1723 1.1865V2.35001C28.9914 2.32752 28.803 2.31673 28.6074 2.31673C28.3976 2.31673 28.2471 2.3662 28.1571 2.4647C28.0667 2.56364 28.0212 2.73005 28.0212 2.96438V3.30439H29.0858V4.34647H28.0212V8.97714H26.4773V4.34647H25.5539Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.1317 8.97741H31.6751V3.30466H30.1317V8.97741ZM30.1321 2.42629H31.6756V1.14224H30.1321V2.42629Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35.8535 4.63193C35.6691 4.42729 35.3876 4.32475 35.0112 4.32475C34.7649 4.32475 34.5608 4.36703 34.3974 4.45113C34.2339 4.53523 34.1038 4.63913 34.0063 4.76326C33.9083 4.88829 33.8397 5.01962 33.7996 5.15904C33.7599 5.29802 33.7363 5.4217 33.7292 5.53189H36.2388C36.1676 5.13655 36.0388 4.83657 35.8535 4.63193ZM34.1092 7.61695C34.3412 7.84318 34.6749 7.95652 35.1087 7.95652C35.4206 7.95652 35.6887 7.87781 35.9137 7.72085C36.1382 7.56388 36.2758 7.39702 36.3266 7.22117H37.6843C37.4678 7.9021 37.1342 8.38873 36.6856 8.68107C36.2348 8.97341 35.6927 9.12003 35.0548 9.12003C34.6125 9.12003 34.2138 9.04852 33.8593 8.90595C33.5047 8.76338 33.2036 8.56054 32.9572 8.29653C32.7109 8.03342 32.5211 7.71905 32.3866 7.3534C32.253 6.98774 32.1857 6.58521 32.1857 6.14625C32.1857 5.72214 32.2552 5.3268 32.392 4.96115C32.53 4.59505 32.7251 4.27887 32.9795 4.01217C33.2325 3.74502 33.535 3.53498 33.8864 3.38116C34.2379 3.22735 34.6272 3.15089 35.0548 3.15089C35.5328 3.15089 35.9502 3.24399 36.3052 3.43064C36.6602 3.61728 36.9516 3.86735 37.1801 4.18218C37.4077 4.497 37.5725 4.85546 37.6736 5.25754C37.7752 5.66007 37.8117 6.08059 37.7828 6.51955H33.7292C33.7506 7.02417 33.8775 7.38983 34.1092 7.61695Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.4013 5.44931C42.3581 5.23388 42.2837 5.04364 42.179 4.87858C42.0743 4.71441 41.938 4.58084 41.7714 4.47829C41.6048 4.37575 41.3946 4.32493 41.1411 4.32493C40.8881 4.32493 40.6734 4.37575 40.4997 4.47829C40.326 4.58084 40.1861 4.71576 40.081 4.88442C39.9763 5.05308 39.9006 5.24468 39.8533 5.46011C39.8057 5.67644 39.783 5.90132 39.783 6.13519C39.783 6.35467 39.8079 6.57415 39.8582 6.79363C39.909 7.01356 39.991 7.20875 40.1032 7.38056C40.2159 7.55327 40.3563 7.69179 40.5273 7.79748C40.6975 7.90407 40.9024 7.9567 41.1411 7.9567C41.3946 7.9567 41.6066 7.90587 41.7772 7.80333C41.9469 7.70079 42.0833 7.56361 42.1848 7.3918C42.2855 7.22 42.3581 7.0239 42.4013 6.80487C42.4454 6.58494 42.4668 6.35827 42.4668 6.1244C42.4668 5.89052 42.4454 5.6652 42.4013 5.44931ZM42.4668 8.25308C42.2855 8.56027 42.0485 8.782 41.755 8.91692C41.4619 9.0523 41.1304 9.11976 40.7607 9.11976C40.3398 9.11976 39.9709 9.03791 39.6524 8.87285C39.3335 8.70868 39.0702 8.48561 38.8644 8.20406C38.6573 7.92251 38.5014 7.59869 38.3967 7.23259C38.2916 6.86694 38.2395 6.4869 38.2395 6.09156C38.2395 5.71152 38.2916 5.34362 38.3967 4.98877C38.5014 4.63391 38.6573 4.32133 38.8644 4.05013C39.0702 3.78028 39.3295 3.56214 39.6413 3.39753C39.9527 3.23292 40.3148 3.15107 40.7282 3.15107C41.0614 3.15107 41.3786 3.22168 41.6783 3.3647C41.9799 3.50727 42.2169 3.71731 42.3911 3.99571H42.4124V1.14246H43.9555V8.97719H42.4886V8.25308H42.4668Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.80879 69.2102C4.73084 68.6615 4.21056 68.2445 3.61366 68.2445C2.53523 68.2445 2.12898 69.1719 2.12898 70.138C2.12898 71.0564 2.53523 71.9843 3.61366 71.9843C4.3482 71.9843 4.76336 71.4742 4.85334 70.7474H6.01863C5.89524 72.1237 4.95356 73.0043 3.61366 73.0043C1.92274 73.0043 0.928497 71.7292 0.928497 70.138C0.928497 68.4996 1.92274 67.224 3.61366 67.224C4.81592 67.224 5.82531 67.9356 5.97141 69.2102H4.80879Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.52681 72.1542C9.26893 72.1542 9.49032 71.5124 9.49032 70.8796C9.49032 70.2383 9.26893 69.5969 8.52681 69.5969C7.79272 69.5969 7.5691 70.2383 7.5691 70.8796C7.5691 71.5124 7.79272 72.1542 8.52681 72.1542ZM8.52681 68.7707C9.77451 68.7707 10.5777 69.6037 10.5777 70.8796C10.5777 72.1466 9.77451 72.9813 8.52681 72.9813C7.28669 72.9813 6.48354 72.1466 6.48354 70.8796C6.48354 69.6037 7.28669 68.7707 8.52681 68.7707Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.2482 68.8711H12.2798V69.6123H12.2963C12.4941 69.1108 13.0304 68.7636 13.5596 68.7636C13.6358 68.7636 13.7267 68.778 13.7975 68.8014V69.821C13.6959 69.7985 13.5365 69.7832 13.4068 69.7832C12.6099 69.7832 12.3337 70.3629 12.3337 71.0654V72.8663H11.2482V68.8711Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.1595 70.8875C17.1595 70.2525 16.9069 69.5972 16.2107 69.5972C15.4989 69.5972 15.2699 70.2385 15.2699 70.8875C15.2699 71.5356 15.5149 72.154 16.2187 72.154C16.931 72.154 17.1595 71.5356 17.1595 70.8875ZM14.2213 68.878H15.2552V69.3876H15.2699C15.5296 68.9635 15.9581 68.7705 16.4472 68.7705C17.6883 68.7705 18.2455 69.782 18.2455 70.9172C18.2455 71.984 17.6655 72.9811 16.5092 72.9811C16.0352 72.9811 15.584 72.772 15.3238 72.378H15.3078V74.2791H14.2213V68.878Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.6309 72.1542C21.3734 72.1542 21.5957 71.5124 21.5957 70.8796C21.5957 70.2383 21.3734 69.5969 20.6309 69.5969C19.8977 69.5969 19.675 70.2383 19.675 70.8796C19.675 71.5124 19.8977 72.1542 20.6309 72.1542ZM20.6309 68.7707C21.879 68.7707 22.6835 69.6037 22.6835 70.8796C22.6835 72.1466 21.879 72.9813 20.6309 72.9813C19.3921 72.9813 18.5885 72.1466 18.5885 70.8796C18.5885 69.6037 19.3921 68.7707 20.6309 68.7707Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.354 68.8711H24.387V69.6123H24.4035C24.6013 69.1108 25.1372 68.7636 25.665 68.7636C25.7412 68.7636 25.8338 68.778 25.9029 68.8014V69.821C25.8031 69.7985 25.6423 69.7832 25.5127 69.7832C24.7167 69.7832 24.4405 70.3629 24.4405 71.0654V72.8663H23.354V68.8711Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.7334 70.9174C28.5485 71.0806 28.1667 71.0869 27.8295 71.1499C27.4928 71.2178 27.1863 71.3357 27.1863 71.7368C27.1863 72.1466 27.5004 72.246 27.8532 72.246C28.7017 72.246 28.7334 71.5673 28.7334 71.3271V70.9174ZM26.2215 70.1065C26.2838 69.0783 27.1939 68.7707 28.0817 68.7707C28.8697 68.7707 29.8194 68.9475 29.8194 69.905V71.9842C29.8194 72.3481 29.8568 72.7101 29.9583 72.8734H28.8545C28.8175 72.7483 28.7855 72.6179 28.7775 72.4857C28.434 72.85 27.9293 72.9813 27.4469 72.9813C26.6968 72.9813 26.1003 72.6026 26.1003 71.7827C26.1003 70.8796 26.7752 70.6637 27.4469 70.5706C28.1128 70.4694 28.7334 70.4933 28.7334 70.0444C28.7334 69.574 28.41 69.5038 28.0287 69.5038C27.6148 69.5038 27.348 69.6734 27.3088 70.1065H26.2215Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32.0142 68.8781H32.8106V69.6121H32.0142V71.5888C32.0142 71.9607 32.1068 72.0538 32.473 72.0538C32.5884 72.0538 32.6957 72.0457 32.8106 72.0232V72.8809C32.6258 72.912 32.3883 72.9192 32.1741 72.9192C31.5104 72.9192 30.9282 72.764 30.9282 71.9684V69.6121H30.2693V68.8781H30.9282V67.68H32.0142V68.8781Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.6302 72.8732H34.7171V68.878H33.6302V72.8732ZM33.6302 68.2596H34.7171V67.3551H33.6302V68.2596Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M37.4892 72.1542C38.2331 72.1542 38.454 71.5124 38.454 70.8796C38.454 70.2383 38.2331 69.5969 37.4892 69.5969C36.7551 69.5969 36.5328 70.2383 36.5328 70.8796C36.5328 71.5124 36.7551 72.1542 37.4892 72.1542ZM37.4892 68.7707C38.7373 68.7707 39.5422 69.6037 39.5422 70.8796C39.5422 72.1466 38.7373 72.9813 37.4892 72.9813C36.2504 72.9813 35.4477 72.1466 35.4477 70.8796C35.4477 69.6037 36.2504 68.7707 37.4892 68.7707Z",
        fill: "var(--color--charcoal-600)"
      }), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M40.2441 68.8781H41.2775V69.4345H41.3002C41.576 68.9861 42.0504 68.7706 42.5101 68.7706C43.6656 68.7706 43.9556 69.4268 43.9556 70.4158V72.8733H42.8696V70.6164C42.8696 69.9598 42.6776 69.6346 42.1733 69.6346C41.5831 69.6346 41.3305 69.9674 41.3305 70.7797V72.8733H40.2441V68.8781Z",
        fill: "var(--color--charcoal-600)"
      })]
    }), jsxs("svg", {
      width: "43",
      height: "39",
      viewBox: "0 0 43 39",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsxs("g", {
        clipPath: "url(#clip0)",
        children: [jsx("path", {
          d: "M0.105596 32.9913H3.35553V16.2127H0.023468V10.7046H10.7353V32.9913H13.9853V37.8643H0.105596V32.9913Z",
          fill: "var(--color--charcoal-600)"
        }), jsx("path", {
          d: "M14.1495 16.7323C14.1495 13.0949 17.2352 10.3466 21.0014 10.3466C24.7793 10.3466 27.818 13.1064 27.818 16.7323C27.818 20.3236 24.7793 23.1643 21.0014 23.1643C17.2352 23.1643 14.1495 20.3236 14.1495 16.7323ZM34.5995 10.7045H39.9613L22.6205 37.8642H17.2587L34.5995 10.7045ZM22.9138 16.7323C22.9138 15.0117 22.1042 14.1341 21.0014 14.1341C19.8633 14.1341 19.089 15.0117 19.089 16.7323C19.089 18.5337 19.8633 19.3652 21.0014 19.3652C22.1042 19.3652 22.9138 18.5337 22.9138 16.7323ZM29.3198 31.7903C29.3198 28.1528 32.4055 25.4045 36.1716 25.4045C39.9495 25.4045 42.9883 28.1643 42.9883 31.7903C42.9883 35.4277 39.9495 38.2222 36.1716 38.2222C32.4055 38.2222 29.3198 35.4277 29.3198 31.7903ZM38.0841 31.7903C38.0841 30.0697 37.2745 29.1921 36.1716 29.1921C35.0336 29.1921 34.2592 30.0697 34.2592 31.7903C34.2592 33.5917 35.0336 34.4231 36.1716 34.4231C37.2745 34.4231 38.0841 33.5917 38.0841 31.7903Z",
          fill: "var(--color--charcoal-600)"
        }), jsx("path", {
          d: "M1.97108 7.25183H0L0.0234652 0L3.00355 0.0115475C4.88076 0.023095 5.91323 1.1432 5.9015 2.62128C5.9015 4.09936 4.8573 5.18483 2.98008 5.18483H1.97108V7.25183ZM2.89795 3.55663C3.56671 3.55663 3.93042 3.2102 3.93042 2.60973C3.93042 2.00926 3.57844 1.65129 2.90969 1.65129H1.99454L1.98281 3.55663H2.89795Z",
          fill: "var(--color--charcoal-600)"
        }), jsx("path", {
          d: "M7.3446 0.0230713L9.31568 0.0346188L9.30395 5.6467L12.4248 5.65825V7.298L7.32114 7.2749L7.3446 0.0230713Z",
          fill: "var(--color--charcoal-600)"
        }), jsx("path", {
          d: "M14.1143 0.0461426L19.2884 0.0692376L19.2767 1.69744L16.0854 1.68589L16.0737 2.88683H18.737V4.43419L16.0737 4.42264L16.0619 5.66977L19.4175 5.68132L19.4057 7.32107L14.0909 7.29797L14.1143 0.0461426Z",
          fill: "var(--color--charcoal-600)"
        }), jsx("path", {
          d: "M21.1421 0.0808105L23.9932 0.092358C26.1168 0.103906 27.7124 1.47806 27.7007 3.72982C27.6889 5.98158 26.0816 7.34419 23.958 7.34419L21.1187 7.32109L21.1421 0.0808105ZM23.7585 5.6929C24.9552 5.6929 25.6944 4.91921 25.6944 3.71827C25.6944 2.51733 24.967 1.7321 23.7703 1.7321H23.1132L23.1015 5.6929H23.7585Z",
          fill: "var(--color--charcoal-600)"
        }), jsx("path", {
          d: "M34.1888 4.82682H32.7222V3.3372L35.937 3.34874L35.9487 6.46657C35.2682 7.02085 34.3765 7.45965 32.734 7.45965C30.5634 7.4481 28.7801 5.91229 28.7801 3.72981C28.7918 1.54733 30.5869 0.0230636 32.7105 0.0346111C34.0128 0.0346111 35.0218 0.519606 35.6671 1.33948L34.2827 2.50578C33.919 2.03233 33.4027 1.72055 32.6636 1.72055C31.4669 1.72055 30.7981 2.59816 30.7981 3.74136C30.7981 4.88456 31.4669 5.83146 32.7574 5.843C33.4731 5.843 33.872 5.70443 34.1888 5.56586V4.82682Z",
          fill: "var(--color--charcoal-600)"
        }), jsx("path", {
          d: "M37.7086 0.13855L42.8709 0.150097V1.77829L39.6679 1.76675V2.96769L42.3312 2.97923V4.51505H39.6679L39.6562 5.76218L43 5.77373V7.40193L37.6851 7.37883L37.7086 0.13855Z",
          fill: "var(--color--charcoal-600)"
        })]
      }), jsx("defs", {
        children: jsx("clipPath", {
          id: "clip0",
          children: jsx("rect", {
            width: "43",
            height: "38.2222",
            fill: "white"
          })
        })
      })]
    })]
  });
};

var SiteFooterSocialLinks = function () {
  return jsxs("div", {
    className: "social-links",
    children: [jsx("a", {
      "aria-label": "Follow us on X / Twitter",
      href: "https://twitter.com/helpscout",
      children: jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [jsx("title", {
          children: "Follow us on X / Twitter"
        }), jsx("path", {
          d: "M11.3723 8.72382L17.4434 1.66663H16.0047L10.7332 7.79429L6.5228 1.66663H1.66663L8.03355 10.9327L1.66663 18.3333H3.10537L8.67228 11.8623L13.1187 18.3333H17.9749L11.3719 8.72382H11.3723ZM9.40172 11.0144L8.75662 10.0917L3.62377 2.74969H5.8336L9.97587 8.67491L10.621 9.59761L16.0054 17.2995H13.7956L9.40172 11.0147V11.0144Z",
          fill: "var(--color--charcoal-600)"
        })]
      })
    }), jsx("a", {
      "aria-label": "Follow us on Facebook",
      href: "https://www.facebook.com/helpscout",
      children: jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [jsx("title", {
          children: "Follow us on Facebook"
        }), jsx("g", {
          clipPath: "url(#clip0_14704_1516)",
          children: jsx("path", {
            d: "M19.1667 10C19.1667 4.93747 15.0626 0.833374 10 0.833374C4.93747 0.833374 0.833374 4.93747 0.833374 10C0.833374 14.2988 3.79311 17.9061 7.78574 18.8968V12.8014H5.89557V10H7.78574V8.79297C7.78574 5.67301 9.19777 4.22687 12.2609 4.22687C12.8417 4.22687 13.8438 4.34091 14.2537 4.45457V6.99374C14.0374 6.97101 13.6616 6.95964 13.1948 6.95964C11.6918 6.95964 11.111 7.52907 11.111 9.00931V10H14.1052L13.5908 12.8014H11.111V19.0996C15.6493 18.5514 19.1667 14.6868 19.1667 10Z",
            fill: "var(--color--charcoal-600)"
          })
        }), jsx("defs", {
          children: jsx("clipPath", {
            id: "clip0_14704_1516",
            children: jsx("rect", {
              width: "18.3333",
              height: "18.3333",
              fill: "white",
              transform: "translate(0.833374 0.833374)"
            })
          })
        })]
      })
    }), jsx("a", {
      "aria-label": "Follow us on LinkedIn",
      href: "https://www.linkedin.com/company/help-scout",
      children: jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [jsx("title", {
          children: "Follow us on LinkedIn"
        }), jsx("path", {
          d: "M16.8413 1.66663H2.63879C1.95846 1.66663 1.40833 2.20374 1.40833 2.8678V17.1289C1.40833 17.7929 1.95846 18.3333 2.63879 18.3333H16.8413C17.5216 18.3333 18.075 17.7929 18.075 17.1321V2.8678C18.075 2.20374 17.5216 1.66663 16.8413 1.66663ZM6.35299 15.8691H3.87903V7.91337H6.35299V15.8691ZM5.11601 6.82939C4.32174 6.82939 3.68046 6.18811 3.68046 5.39709C3.68046 4.60608 4.32174 3.9648 5.11601 3.9648C5.90702 3.9648 6.5483 4.60608 6.5483 5.39709C6.5483 6.18486 5.90702 6.82939 5.11601 6.82939ZM15.6108 15.8691H13.1401V12.0019C13.1401 11.0807 13.1238 9.89254 11.8543 9.89254C10.5685 9.89254 10.3732 10.8984 10.3732 11.9368V15.8691H7.90572V7.91337H10.2755V9.00061H10.3081C10.6368 8.37561 11.4441 7.7148 12.6453 7.7148C15.1486 7.7148 15.6108 9.36194 15.6108 11.5039V15.8691Z",
          fill: "var(--color--charcoal-600)"
        })]
      })
    }), jsx("a", {
      "aria-label": "Follow us on Instagram",
      href: "https://www.instagram.com/hellohelpscout/",
      children: jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        children: [jsx("title", {
          children: "Follow us on Instagram"
        }), jsx("g", {
          clipPath: "url(#clip0_14704_1341)",
          children: jsx("path", {
            d: "M5.29039 0.724786C4.40371 0.76662 3.79821 0.908121 3.26887 1.11612C2.72103 1.32963 2.25669 1.61613 1.79469 2.0798C1.33268 2.54347 1.04818 3.00814 0.836176 3.55681C0.631008 4.08732 0.492006 4.69333 0.452839 5.5805C0.413672 6.46768 0.405005 6.75285 0.409339 9.01587C0.413672 11.2789 0.423672 11.5626 0.466673 12.4516C0.509006 13.3381 0.650008 13.9434 0.85801 14.4729C1.07185 15.0208 1.35802 15.4849 1.82185 15.9471C2.28569 16.4093 2.75003 16.6931 3.30003 16.9055C3.83004 17.1103 4.43621 17.25 5.32322 17.2888C6.21023 17.3276 6.49573 17.3366 8.75809 17.3323C11.0204 17.328 11.3053 17.318 12.1941 17.2758C13.083 17.2336 13.6851 17.0916 14.2148 16.8846C14.7627 16.6703 15.2272 16.3846 15.689 15.9206C16.1508 15.4566 16.4352 14.9916 16.647 14.4426C16.8523 13.9126 16.9918 13.3064 17.0303 12.4201C17.0692 11.5306 17.0783 11.2466 17.074 8.98387C17.0697 6.72118 17.0595 6.43751 17.0173 5.54884C16.9752 4.66016 16.834 4.05665 16.6262 3.52681C16.412 2.97898 16.1262 2.51514 15.6625 2.05263C15.1988 1.59013 14.7335 1.30596 14.1846 1.09462C13.6543 0.889454 13.0485 0.749619 12.1615 0.711286C11.2744 0.672952 10.9889 0.663119 8.72576 0.667452C6.46257 0.671785 6.17923 0.681452 5.29039 0.724786ZM5.38772 15.7896C4.57521 15.7543 4.13404 15.6193 3.84004 15.5063C3.4507 15.3563 3.17337 15.1749 2.88036 14.8848C2.58736 14.5946 2.40736 14.3163 2.25536 13.9278C2.14119 13.6338 2.00369 13.1931 1.96569 12.3806C1.92435 11.5024 1.91569 11.2387 1.91085 9.01387C1.90602 6.78901 1.91452 6.52568 1.95302 5.64717C1.98769 4.83533 2.12352 4.39366 2.23636 4.09982C2.38636 3.70998 2.56703 3.43315 2.85786 3.14031C3.1487 2.84747 3.4262 2.66714 3.81504 2.51514C4.10871 2.40047 4.54938 2.26413 5.36156 2.22547C6.2404 2.1838 6.50373 2.17547 8.72826 2.17063C10.9528 2.1658 11.2168 2.17413 12.096 2.2128C12.9078 2.24813 13.3496 2.38264 13.6431 2.49614C14.0326 2.64614 14.3098 2.82631 14.6027 3.11764C14.8955 3.40898 15.076 3.68548 15.228 4.07515C15.3428 4.36799 15.4792 4.80849 15.5175 5.62117C15.5593 6.50001 15.5688 6.76351 15.5728 8.98787C15.5768 11.2122 15.569 11.4764 15.5305 12.3546C15.495 13.1671 15.3603 13.6084 15.2472 13.9028C15.0972 14.2919 14.9163 14.5694 14.6253 14.8621C14.3343 15.1548 14.0571 15.3351 13.6681 15.4871C13.3748 15.6016 12.9336 15.7383 12.1221 15.7769C11.2433 15.8183 10.9799 15.8269 8.75459 15.8318C6.52923 15.8366 6.26673 15.8276 5.38789 15.7896M12.1813 4.54599C12.1816 4.74379 12.2406 4.93705 12.3508 5.10132C12.4609 5.26559 12.6174 5.39351 12.8002 5.46888C12.9831 5.54425 13.1842 5.5637 13.3782 5.52477C13.5721 5.48583 13.7501 5.39026 13.8897 5.25014C14.0293 5.11002 14.1242 4.93164 14.1625 4.73758C14.2007 4.54351 14.1805 4.34246 14.1045 4.15987C14.0284 3.97727 13.8999 3.82133 13.7352 3.71176C13.5706 3.60219 13.3771 3.54392 13.1793 3.54431C12.9141 3.54484 12.66 3.65067 12.4729 3.83851C12.2857 4.02635 12.1808 4.28083 12.1813 4.54599ZM4.46288 9.0082C4.46755 11.3716 6.3869 13.2831 8.74976 13.2786C11.1126 13.2741 13.0255 11.3549 13.021 8.99154C13.0165 6.62818 11.0966 4.71616 8.73342 4.72083C6.37023 4.72549 4.45838 6.64518 4.46288 9.0082ZM5.9639 9.0052C5.96281 8.4558 6.12467 7.9184 6.429 7.46098C6.73333 7.00356 7.16646 6.64666 7.67363 6.43541C8.1808 6.22415 8.73923 6.16804 9.27829 6.27416C9.81735 6.38027 10.3128 6.64386 10.7021 7.03158C11.0914 7.4193 11.3569 7.91374 11.4652 8.45238C11.5734 8.99102 11.5195 9.54966 11.3103 10.0577C11.101 10.5657 10.7458 11.0002 10.2896 11.3064C9.83341 11.6125 9.29667 11.7765 8.74726 11.7776C8.38245 11.7783 8.02107 11.7072 7.68374 11.5683C7.34642 11.4294 7.03977 11.2254 6.7813 10.9679C6.52283 10.7105 6.31761 10.4046 6.17736 10.0679C6.03711 9.73111 5.96457 9.37001 5.9639 9.0052Z",
            fill: "var(--color--charcoal-600)"
          })
        }), jsx("defs", {
          children: jsx("clipPath", {
            id: "clip0_14704_1341",
            children: jsx("rect", {
              width: "16.6667",
              height: "16.6667",
              fill: "white",
              transform: "translate(0.408325 0.666626)"
            })
          })
        })]
      })
    })]
  });
};

var SiteFooter = function (_a) {
  var columns = _a.columns,
    prefixUrls = _a.prefixUrls,
    LinkComponent = _a.LinkComponent;
  var _b = useState(0),
    logoHighlightOpacity = _b[0],
    setLogoHighlightOpacity = _b[1];
  var _c = useState([0, 0]),
    clientXY = _c[0],
    setClientXY = _c[1];
  var Link = LinkComponent || function (props) {
    return jsx("a", __assign({}, props));
  };
  var currentYear = new Date().getFullYear();
  // Add Do Not Sell consent manager pop-up using transcend API
  useEffect(function () {
    if (!isClientSide()) return;
    var doNotSell = document.querySelector("#footerDoNotSell");
    var checkAPI = function (timeout) {
      var startTime = Date.now();
      var pollAPI = function () {
        if (window.transcend) {
          // API is loaded
          if (doNotSell) {
            doNotSell.addEventListener("click", function (event) {
              event.preventDefault();
              window.transcend.doNotSell(event);
            });
          }
        } else {
          // API has not yet loaded
          var currentTime = Date.now();
          var elapsedTime = currentTime - startTime;
          if (elapsedTime >= timeout) {
            console.error('Timeout occurred while waiting for Transcend.');
            return;
          }
          // Schedule another check
          setTimeout(pollAPI, 100);
        }
      };
      pollAPI();
    };
    // Specify polling timeout duration (in milliseconds)
    var timeoutDuration = 5000;
    if (doNotSell) checkAPI(timeoutDuration);
  }, [isClientSide]);
  var handleMouseMove = function (e) {
    setClientXY([e.clientX, e.clientY]);
  };
  var handleMouseEnter = function () {
    setLogoHighlightOpacity(0.2);
  };
  var handleMouseLeave = function () {
    setLogoHighlightOpacity(0);
  };
  var renderNewBadge = function () {
    return jsx(Badge, {
      color: BADGE_COLORS.COBALT,
      size: BADGE_SIZES.XS,
      children: "NEW"
    });
  };
  return jsxs("footer", {
    className: "SiteFooter",
    onMouseMove: handleMouseMove,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: [jsx("div", {
      className: "container",
      children: jsxs("div", {
        className: "flex",
        children: [columns && columns.map(function (column) {
          return !column ? null : jsxs("div", {
            className: "SiteFooter--column ".concat(convertStringToKebabCase(column.title)),
            children: [jsx("h4", {
              className: "type--headline-medium-S",
              children: column.title
            }), column.items && column.items.map(function (item, index) {
              if (!item) return null;
              if (!item.url && item.html) {
                return jsx("span", {
                  dangerouslySetInnerHTML: {
                    __html: item.html
                  }
                }, item.html || index);
              }
              if (!item.url) return null;
              return jsxs(Link, {
                href: prefixUrls && !isExternalLink(item.url) ? "".concat(HS_MARKETING_SITE_URL).concat(item.url) : item.url,
                children: [item.title, item.isNew && renderNewBadge(), item.title === "Status" && jsxs(Badge, {
                  className: "status-badge",
                  color: BADGE_COLORS.CHARCOAL,
                  size: BADGE_SIZES.XS,
                  children: [jsx("svg", {
                    style: {
                      verticalAlign: "baseline",
                      width: "calc(var(--font-size--XS) * .8)",
                      height: "calc(var(--font-size--XS) * .8)"
                    },
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: jsx("path", {
                      d: "M4.96873 16.3535L10.2052 5.85653C10.9418 4.38476 13.0388 4.38515 13.7748 5.85718L19.0391 16.3542C19.704 17.6841 18.7388 19.25 17.2541 19.25H6.75335C5.26832 19.25 4.30314 17.6835 4.96873 16.3535Z",
                      stroke: "var(--color--charcoal-400)",
                      fill: "var(--color--charcoal-400)",
                      strokeWidth: "1.5",
                      strokeLinecap: "square",
                      strokeLinejoin: "round"
                    })
                  }), "99.99%"]
                }), item.url.includes("//") && jsx(Icon, {
                  size: "calc(var(--font-size--XS) * .8)",
                  type: ICON_TYPES["arrow-up-right"]
                })]
              }, item.title || index);
            })]
          }, column.title);
        }), jsxs("div", {
          className: "SiteFooter--column desktop-meta",
          children: [jsx(SiteFooterSocialLinks, {}), jsx(SiteFooterResponsibility, {}), jsxs("div", {
            className: "type--text-XS color--charcoal-600 text-align--right",
            children: ["\u00A9 ", currentYear, " Help\u00A0Scout"]
          })]
        }), jsx("div", {
          className: "SiteFooter--column mobile-meta",
          children: jsx(SiteFooterResponsibility, {})
        }), jsxs("div", {
          className: "SiteFooter--column mobile-meta social-links-copyright",
          children: [jsx(SiteFooterSocialLinks, {}), jsxs("div", {
            className: "type--text-XS color--charcoal-600",
            children: ["\u00A9 ", currentYear, " Help\u00A0Scout"]
          })]
        })]
      })
    }), jsx(SiteFooterBigLogo, {
      clientX: clientXY[0],
      clientY: clientXY[1],
      opacity: logoHighlightOpacity
    })]
  });
};

var SCROLL_UP_THRESHOLD = 100;
var SCROLL_DOWN_THRESHOLD = 200;
var SCROLLED_AND_VISIBLE_STATES;
(function (SCROLLED_AND_VISIBLE_STATES) {
  SCROLLED_AND_VISIBLE_STATES["HIDING"] = "HIDING";
  SCROLLED_AND_VISIBLE_STATES["SHOWING"] = "SHOWING";
  SCROLLED_AND_VISIBLE_STATES["UNINITIALIZED"] = "UNINITIALIZED";
})(SCROLLED_AND_VISIBLE_STATES || (SCROLLED_AND_VISIBLE_STATES = {}));
function useScrolledAndVisible(isOpen) {
  var _a = useState(SCROLLED_AND_VISIBLE_STATES.UNINITIALIZED),
    scrolledAndVisibleState = _a[0],
    setScrolledAndVisibleState = _a[1];
  var _b = useState(0),
    scrollY = _b[0],
    setScrollY = _b[1];
  var _c = useState(0),
    scrollYStartedScrollingUp = _c[0],
    setScrollYStartedScrollingUp = _c[1];
  var _d = useState(0),
    scrollYStartedScrollingDown = _d[0],
    setScrollYStartedScrollingDown = _d[1];
  useEffect(function () {
    if (!isClientSide()) return;
    var SCROLL_START_POSITION = window.innerHeight * 0.5;
    if (isOpen) {
      window.requestAnimationFrame(function () {
        setScrollYStartedScrollingUp(0);
        setScrollYStartedScrollingDown(0);
        setScrolledAndVisibleState(window.scrollY <= SCROLL_START_POSITION ? SCROLLED_AND_VISIBLE_STATES.UNINITIALIZED : SCROLLED_AND_VISIBLE_STATES.HIDING);
      });
      return;
    }
    var updateScrollY = function () {
      setScrollY(window.scrollY);
      // If we return to the top of the page, reset
      if (window.scrollY <= 0) {
        window.requestAnimationFrame(function () {
          setScrollYStartedScrollingUp(0);
          setScrollYStartedScrollingDown(0);
          setScrolledAndVisibleState(SCROLLED_AND_VISIBLE_STATES.UNINITIALIZED);
        });
        return;
      }
      // If we start scrolling up, mark the spot
      if (scrolledAndVisibleState !== SCROLLED_AND_VISIBLE_STATES.SHOWING && window.scrollY > SCROLL_START_POSITION && window.scrollY < scrollY && !scrollYStartedScrollingUp) {
        window.requestAnimationFrame(function () {
          setScrollYStartedScrollingUp(window.scrollY);
        });
        return;
      }
      // If we've scrolled up the SCROLL_UP_THRESHOLD amount past the marked spot, go visible
      if (scrollYStartedScrollingUp - window.scrollY >= SCROLL_UP_THRESHOLD) {
        window.requestAnimationFrame(function () {
          setScrolledAndVisibleState(SCROLLED_AND_VISIBLE_STATES.SHOWING);
          setScrollYStartedScrollingUp(0);
        });
        return;
      }
      // If we start scrolling down, and we're visible, mark the spot
      if (scrolledAndVisibleState === SCROLLED_AND_VISIBLE_STATES.SHOWING && window.scrollY > scrollY && !scrollYStartedScrollingDown) {
        window.requestAnimationFrame(function () {
          setScrollYStartedScrollingDown(window.scrollY);
        });
        return;
      }
      // If we're scrolling down and we're visible and the spot is marked, hide it again
      if (scrolledAndVisibleState === SCROLLED_AND_VISIBLE_STATES.SHOWING && scrollYStartedScrollingDown > 0 && window.scrollY - scrollYStartedScrollingDown >= SCROLL_DOWN_THRESHOLD) {
        window.requestAnimationFrame(function () {
          setScrolledAndVisibleState(SCROLLED_AND_VISIBLE_STATES.HIDING);
          setScrollYStartedScrollingDown(0);
        });
        return;
      }
      // If we hit the bottom of the page, hide!
      if (scrolledAndVisibleState === SCROLLED_AND_VISIBLE_STATES.SHOWING && window.scrollY + window.innerHeight >= document.body.scrollHeight) {
        window.requestAnimationFrame(function () {
          setScrolledAndVisibleState(SCROLLED_AND_VISIBLE_STATES.HIDING);
          setScrollYStartedScrollingDown(0);
        });
        return;
      }
    };
    window.addEventListener("scroll", updateScrollY);
    return function () {
      window.removeEventListener("scroll", updateScrollY);
    };
  }, [isOpen, scrollY, scrollYStartedScrollingUp, scrollYStartedScrollingDown]);
  return scrolledAndVisibleState;
}

var SiteNav = function (_a) {
  var _b;
  var LinkComponent = _a.LinkComponent,
    _c = _a.className,
    className = _c === void 0 ? "" : _c,
    demoUrl = _a.demoUrl,
    includeLoginButton = _a.includeLoginButton,
    isStatic = _a.isStatic,
    loginUrl = _a.loginUrl,
    navItems = _a.navItems,
    onLinkClick = _a.onLinkClick,
    onLoginClick = _a.onLoginClick,
    prefixUrls = _a.prefixUrls,
    signupPlusUrl = _a.signupPlusUrl;
  var elRef = useRef(null);
  var _d = useState(true),
    isReady = _d[0],
    setIsReady = _d[1];
  var _e = useState(false),
    isOpen = _e[0],
    setIsOpen = _e[1];
  var _f = useState(""),
    expandedNavLink = _f[0],
    setExpandedNavLink = _f[1];
  var scrolledAndVisibleState = useScrolledAndVisible(isOpen);
  var Link = LinkComponent || function (props) {
    return jsx("a", __assign({}, props));
  };
  var handleClickLink = function () {
    setIsOpen(false);
    setExpandedNavLink("");
    onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick();
    // Trick any open nav items into closing while navigating to a new page
    setIsReady(false);
    setTimeout(function () {
      return setIsReady(true);
    }, 300);
  };
  var handleClickLogin = function () {
    if (isClientSide() && window.localStorage) {
      window.localStorage.setItem(LOCAL_STORAGE_NAME_LOGGED_IN, "true");
    }
    onLoginClick === null || onLoginClick === void 0 ? void 0 : onLoginClick();
  };
  useEffect(function () {
    if (!isClientSide() || window.innerWidth >= BREAKPOINTS.M || !elRef.current) return;
    var navDrawers = Array.from(elRef.current.querySelectorAll(".nav-drawer"));
    navDrawers.forEach(function (navDrawer) {
      var _transition = navDrawer.style.transition;
      navDrawer.style.transition = "";
      navDrawer.style.maxHeight = "none";
      var height = navDrawer.getBoundingClientRect().height;
      navDrawer.style.setProperty("--SiteNav--nav-drawer-max-height", "".concat(height, "px"));
      navDrawer.style.maxHeight = "";
      navDrawer.style.transition = _transition;
    });
  }, [BREAKPOINTS.M, isClientSide]);
  useEffect(function () {
    if (!isClientSide() || window.innerWidth >= BREAKPOINTS.M || !isOpen) return;
    var handleClickOutside = function (e) {
      var target = e.target;
      var closestNav = target === null || target === void 0 ? void 0 : target.closest(".main-nav, .touch-menu-toggle");
      if (closestNav) return;
      setIsOpen(false);
    };
    window.addEventListener("click", handleClickOutside);
    return function () {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen, BREAKPOINTS.M, isClientSide]);
  if (!navItems || navItems.length === 0) return null;
  return jsx("nav", {
    className: "".concat(generateConditionalClassName((_b = {
      "SiteNav": true,
      "is-open": isOpen,
      "is-ready": isReady,
      "is-static": !!isStatic
    }, _b["scrolled--".concat(scrolledAndVisibleState)] = !isStatic && !!scrolledAndVisibleState, _b)), " ").concat(className),
    ref: elRef,
    children: jsx("div", {
      className: "container",
      children: jsxs("div", {
        className: "nav-pill flex",
        children: [jsx("a", {
          className: "skip-to-content",
          href: "#main-content",
          children: "Skip to content"
        }), jsx(Link, {
          "aria-label": "Return to home page",
          className: "nav-logo",
          href: "".concat(prefixUrls ? HS_MARKETING_SITE_URL : "", "/"),
          children: jsxs("svg", {
            width: "168",
            height: "33",
            viewBox: "0 0 168 33",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M70.9816 5.5H67.5268V26.5133H70.9816V5.5ZM32.6848 5.97335H36.2507V14.4667H45.3927V5.97335H48.9586V26.5133H45.3927V17.9067H36.2507V26.5133H32.6848V5.97335ZM51.1681 18.8933C51.1681 13.9367 53.9201 10.8433 58.3293 10.8433C62.4868 10.8433 65.0297 13.58 65.0297 17.92V20.01H54.6229C54.7765 22.2433 56.0839 23.7767 58.4012 23.7767C60.2675 23.7767 61.2383 22.8033 61.8005 21.73L64.8205 22.82C63.7387 25.0967 61.6174 26.7433 58.277 26.7433C53.6717 26.7433 51.1714 23.6067 51.1714 18.8933H51.1681ZM61.5455 17.3867V17.26C61.5455 14.9833 60.1989 13.8067 58.2738 13.8067C56.1819 13.8067 54.904 15.2233 54.649 17.3867H61.5455ZM74.322 11.13H77.7474V13.4633C78.6168 11.76 80.0353 10.8433 82.2971 10.8433C86.5527 10.8433 88.7589 14.1233 88.7589 18.6767C88.7589 23.23 86.5527 26.51 82.284 26.51C80.0778 26.51 78.6331 25.6067 77.7768 23.9333V32.1133H74.322V11.13ZM81.5421 23.5033C83.915 23.5033 85.3074 21.6833 85.3074 18.6767C85.3074 15.67 83.9183 13.85 81.5421 13.85C79.1659 13.85 77.7768 15.67 77.7768 18.6767C77.7768 21.6833 79.1659 23.5033 81.5421 23.5033ZM97.9826 19.7667L94.4297 20.3967H94.4264C94.8906 24.35 98.4173 26.9867 102.84 26.9867C107.262 26.9867 110.141 24.3667 110.141 20.37C110.141 15.9433 106.602 15.27 102.938 14.5967C100.382 14.1233 98.2473 13.6667 98.2473 11.46C98.2473 9.62667 99.7214 8.69667 101.941 8.69667C104.667 8.69667 106.026 10.07 106.294 12.19L109.834 11.5733C109.314 7.92 106.507 5.5 102.111 5.5C97.7145 5.5 94.6389 7.76333 94.6389 11.83C94.6389 16.3267 98.3878 17.07 101.633 17.6867C104.232 18.19 106.562 18.6467 106.562 20.91C106.562 22.7 105.118 23.79 102.856 23.79C100.202 23.79 98.3061 22.3167 97.9826 19.7667ZM111.798 18.805C111.799 13.8493 114.453 10.8433 118.891 10.8433C122.669 10.8433 124.889 13.02 125.451 16.0867L122.107 16.6867C121.757 14.8833 120.646 13.88 118.891 13.88C116.574 13.88 115.253 15.5833 115.253 18.8367C115.253 22.09 116.502 23.72 118.835 23.72C120.62 23.72 121.757 22.7033 122.107 20.8833L125.451 21.4833C124.889 24.55 122.614 26.7533 118.835 26.7533C114.371 26.7533 111.799 23.6874 111.798 18.805ZM133.828 10.8433C129.445 10.8433 126.68 13.9233 126.68 18.7933C126.68 23.6633 129.432 26.7433 133.828 26.7433C138.224 26.7433 140.989 23.6633 140.989 18.7933C140.989 13.9233 138.211 10.8433 133.828 10.8433ZM137.534 18.7933C137.534 22.0133 136.175 23.7333 133.828 23.7333C131.498 23.7333 130.135 22 130.135 18.7933C130.135 15.5867 131.485 13.8533 133.828 13.8533C136.172 13.8533 137.534 15.5733 137.534 18.7933ZM143.061 21.4567V11.13H146.516V20.31C146.516 22.3167 147.346 23.59 149.144 23.59C151.223 23.59 152.501 21.9433 152.501 19.7933V11.1267H155.956V26.51H152.53V24.0767C151.743 25.58 150.396 26.74 148.023 26.74C144.849 26.74 143.065 24.65 143.065 21.4533L143.061 21.4567ZM160.59 14.2667V22.4733C160.59 25.78 162.388 26.74 165.042 26.74C166.013 26.74 167.01 26.6133 167.922 26.3833L167.768 23.49C167.163 23.59 166.604 23.6467 166.153 23.6467C164.045 23.6467 164.045 22.3167 164.045 21.5567V14.2667H167.654V11.13H164.045V6.59001L160.59 7.57667V11.13H157.838V14.2667H160.59Z",
              fill: "#131B24"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.4956 9.05293C14.789 6.6911 14.789 2.86183 12.4956 0.5L1.8835 11.4287C-0.409896 13.7906 -0.409896 17.6198 1.8835 19.9817L12.4956 9.05293ZM1.90669 32.4144C-0.386702 30.0526 -0.386702 26.2233 1.90669 23.8615L24.5913 0.500005C26.8847 2.86183 26.8847 6.69111 24.5913 9.05293L1.90669 32.4144ZM13.9782 32.5C11.6848 30.1382 11.6848 26.3089 13.9782 23.9471L24.5902 13.0183C26.8836 15.3802 26.8836 19.2094 24.5902 21.5713L13.9782 32.5Z",
              fill: "#304DDB"
            })]
          })
        }), jsxs("ul", {
          className: "main-nav",
          children: [navItems.map(function (navItem) {
            return !navItem ? null : jsxs("li", {
              children: [navItem.url ? jsx(Link, {
                className: "nav-link",
                onClick: handleClickLink,
                href: "".concat(prefixUrls && !isExternalLink(navItem.url) ? HS_MARKETING_SITE_URL : "").concat(navItem.url),
                children: navItem.title
              }) : jsxs("button", {
                className: generateConditionalClassName({
                  "nav-link has-drawer": true,
                  "is-expanded": expandedNavLink === navItem.title
                }),
                onClick: function () {
                  if (window.innerWidth > BREAKPOINTS.M) return;
                  setExpandedNavLink(function (_expandedNavLink) {
                    if (window.innerWidth >= BREAKPOINTS.M) return "";
                    return _expandedNavLink && _expandedNavLink === navItem.title ? "" : navItem.title || "";
                  });
                },
                children: [navItem.title, " ", jsx(Icon, {
                  color: "var(--color--text-dark)",
                  size: "16px",
                  type: ICON_TYPES["chevron-down"]
                })]
              }), isReady && navItem.navItems && jsxs("ul", {
                className: generateConditionalClassName({
                  "nav-drawer": true,
                  "has-feature": !!navItem.feature
                }),
                children: [navItem.navItems.map(function (subNavItem) {
                  return !subNavItem ? null : jsx("li", {
                    children: jsxs(Link, {
                      className: "subnav-link",
                      onClick: handleClickLink,
                      href: "".concat(prefixUrls && !isExternalLink(subNavItem.url) ? HS_MARKETING_SITE_URL : "").concat(subNavItem.url),
                      children: [jsxs("span", {
                        className: "title font-family--sans-brand",
                        children: [subNavItem.icon && jsx(Icon, {
                          color: "var(--color--text-dark)",
                          size: "1.5em",
                          type: subNavItem.icon
                        }), subNavItem.title]
                      }), subNavItem.description && jsx("span", {
                        className: "description",
                        children: subNavItem.description
                      })]
                    })
                  }, subNavItem.title);
                }), navItem.feature && jsx("li", {
                  className: "feature",
                  children: jsxs(Link, {
                    onClick: handleClickLink,
                    href: "".concat(prefixUrls && !isExternalLink(navItem.feature.url) ? HS_MARKETING_SITE_URL : "").concat(navItem.feature.url || "/"),
                    children: [jsx("span", {
                      className: "type--mono-XS color--clay-800 margin-bottom--base-0-75",
                      children: navItem.feature.overline
                    }), navItem.feature.image && jsx("div", {
                      className: "image-wrapper border-radius--M margin-bottom--base-1",
                      children: jsx("img", {
                        alt: navItem.feature.title || "Resource image",
                        src: navItem.feature.image.images.fallback.src,
                        srcSet: navItem.feature.image.images.fallback.srcSet
                      })
                    }), jsx("span", {
                      className: "type--headline-medium-XS color--text-headline margin-bottom--0",
                      dangerouslySetInnerHTML: {
                        __html: navItem.feature.title || ""
                      }
                    })]
                  })
                })]
              })]
            }, navItem.title);
          }), jsxs("li", {
            className: "get-a-demo-or-login",
            children: [includeLoginButton && jsx("a", {
              className: "nav-link font-family--sans-brand",
              href: loginUrl,
              onClick: handleClickLogin,
              children: "Login"
            }), !includeLoginButton && jsx(Link, {
              className: "nav-link get-a-demo font-family--sans-brand",
              onClick: handleClickLink,
              href: "".concat(prefixUrls && !isExternalLink(demoUrl) ? HS_MARKETING_SITE_URL : "").concat(demoUrl || "/"),
              children: "Get a Demo"
            })]
          }), jsx("li", {
            className: "free-trial",
            children: jsx("a", {
              className: "button",
              href: signupPlusUrl,
              children: jsxs(Fragment, {
                children: ["Start", jsx("span", {
                  className: "hide-tablet",
                  children: " for"
                }), " Free"]
              })
            })
          })]
        }), jsx("a", {
          className: "mobile-signup button button--S",
          href: signupPlusUrl,
          children: jsxs(Fragment, {
            children: ["Start", jsx("span", {
              className: "hide-tiny-mobile",
              children: " for"
            }), " Free"]
          })
        }), jsx("div", {
          className: "touch-menu-toggle",
          children: jsxs("button", {
            "aria-label": isOpen ? "Close Menu" : "Open Menu",
            onClick: function () {
              setIsOpen(function (_isOpen) {
                return !_isOpen;
              });
            },
            children: [jsx(Icon, {
              color: "var(--color--text-dark)",
              size: "24px",
              type: ICON_TYPES["close"]
            }), jsx(Icon, {
              color: "var(--color--text-dark)",
              size: "24px",
              type: ICON_TYPES["menu"]
            })]
          })
        })]
      })
    })
  });
};

var SubNav = function (_a) {
  var _b;
  var children = _a.children,
    className = _a.className,
    currentItemSlug = _a.currentItemSlug,
    isSticky = _a.isSticky,
    items = _a.items,
    LinkComponent = _a.LinkComponent;
  var elRef = useRef(null);
  var Link = LinkComponent || function (props) {
    return jsx("a", __assign({}, props));
  };
  var _c = useState(false),
    isStuck = _c[0],
    setIsStuck = _c[1];
  useEffect(function () {
    if (!isClientSide() || !elRef.current) return;
    var activeItem = elRef.current.querySelector(".SubNav--item-link.is-active");
    if (activeItem) {
      activeItem.scrollIntoView({
        behavior: "instant",
        block: "nearest",
        inline: "center"
      });
    }
    if (!isSticky) return;
    var observer = new IntersectionObserver(function (e) {
      setIsStuck(!e[0].isIntersecting);
    }, {
      rootMargin: "-1px 0px 0px 0px",
      threshold: [1]
    });
    observer.observe(elRef.current);
    return function () {
      if (elRef.current) observer.unobserve(elRef.current);
    };
  }, [elRef.current]);
  return jsx("nav", {
    className: generateConditionalClassName((_b = {
      SubNav: true,
      "is-sticky": !!isSticky,
      "is-stuck": isStuck
    }, _b["".concat(className)] = !!className, _b)),
    ref: elRef,
    children: jsx("div", {
      className: "container",
      children: jsxs("div", {
        className: "flex",
        children: [jsx("div", {
          className: "SubNav--items-scroller",
          children: jsx("ul", {
            children: items.map(function (item) {
              return jsx("li", {
                children: jsx(Link, {
                  className: "SubNav--item-link".concat(currentItemSlug === item.slug ? " is-active" : ""),
                  "data-text": item.title,
                  href: item.link,
                  children: jsx("span", {
                    children: item.title
                  })
                })
              });
            })
          })
        }), children && jsx("div", {
          className: "actions",
          children: children
        })]
      })
    })
  });
};

var TEXT_LINK_SIZES;
(function (TEXT_LINK_SIZES) {
  TEXT_LINK_SIZES["XS"] = "XS";
  TEXT_LINK_SIZES["S"] = "S";
  TEXT_LINK_SIZES["M"] = "M";
  TEXT_LINK_SIZES["L"] = "L";
})(TEXT_LINK_SIZES || (TEXT_LINK_SIZES = {}));
var TextLinkCaretSVG = function () {
  return jsx("svg", {
    width: "9",
    height: "13",
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.23684 6.36842L2.67193 0.578948L1 2.31835L4.91233 6.34829L1 10.4185L2.67193 12.1579L8.23684 6.36842Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "0.405263"
    })
  });
};
var TextLink = function (_a) {
  var _b;
  var LinkComponent = _a.LinkComponent,
    children = _a.children,
    className = _a.className,
    href = _a.href,
    onClick = _a.onClick,
    rotateIcon = _a.rotateIcon,
    _c = _a.size,
    size = _c === void 0 ? TEXT_LINK_SIZES.M : _c,
    useDarkMode = _a.useDarkMode;
  var Link = LinkComponent || function (props) {
    return jsx("a", __assign({}, props));
  };
  var _className = generateConditionalClassName((_b = {
    TextLink: true
  }, _b["".concat(className)] = !!className, _b["font-size--".concat(size)] = true, _b["font-family--sans-brand"] = true, _b["use-dark-mode"] = !!useDarkMode, _b["use-rotate-svg"] = !!rotateIcon, _b));
  var content = jsxs(Fragment, {
    children: [children, jsx(TextLinkCaretSVG, {})]
  });
  return !href ? jsx("span", {
    className: _className,
    onClick: onClick,
    children: content
  }) : jsx(Link, {
    className: _className,
    href: href,
    onClick: onClick,
    children: content
  });
};

/*
  `useWistiaScript`
  This hook can be used to include Wistia's E-v1.js script, which is necessary for
  any Wistia embeds. In addition, the hook will return the status of whether or not
  the `window.Wistia` object is available and that the Wistia embed API is ready
  for use.
*/
var useWistiaScript = function (isNeeded) {
  var scriptTimerRef = useRef();
  var _a = useState(false),
    isWistiaReady = _a[0],
    setIsWistiaReady = _a[1];
  useEffect(function () {
    if (!isClientSide() || !isNeeded) return;
    /*
      Add Wistia Embed script
    */
    var WISTIA_EV1_SRC = "https://fast.wistia.com/assets/external/E-v1.js";
    var existingWistiaScriptEl = Array.from(document.querySelectorAll("script")).find(function (el) {
      return el.src.includes(WISTIA_EV1_SRC);
    });
    if (!existingWistiaScriptEl) {
      var wistiaScriptEl = document.createElement("script");
      wistiaScriptEl.src = WISTIA_EV1_SRC;
      wistiaScriptEl.defer = true;
      wistiaScriptEl.type = "text/javascript";
      document.getElementsByTagName("head")[0].appendChild(wistiaScriptEl);
    }
    var waitForWistia = function () {
      // Wait for Wistia to be available`
      if (!window.Wistia) {
        scriptTimerRef.current = setTimeout(waitForWistia, 100);
        return;
      }
      setIsWistiaReady(true);
    };
    waitForWistia();
    return function () {
      if (scriptTimerRef.current) clearTimeout(scriptTimerRef.current);
    };
  }, [isNeeded]);
  return isWistiaReady;
};

var Wistia = function (_a) {
  var _b;
  var autoPlay = _a.autoPlay,
    className = _a.className,
    id = _a.id,
    muted = _a.muted,
    onVideoEnd = _a.onVideoEnd,
    onVideoPlay = _a.onVideoPlay;
  var isWistiaReady = useWistiaScript(true);
  var _c = useState(16 / 9),
    aspectRatio = _c[0],
    setAspectRatio = _c[1];
  useEffect(function () {
    if (!isClientSide() || !isWistiaReady || !window.Wistia) return;
    var scriptEl = document.createElement("script");
    scriptEl.async = true;
    scriptEl.src = "https://fast.wistia.com/embed/medias/".concat(id, ".jsonp");
    document.body.appendChild(scriptEl);
    var timeout = Date.now() + 3000;
    var waitForVideo = function () {
      var _a, _b;
      var videoObj = window.Wistia.api(id);
      if (Date.now() >= timeout) return;
      if (!videoObj) {
        setTimeout(waitForVideo, 100);
        return;
      }
      var _aspect = videoObj.aspect();
      if (((_b = (_a = videoObj.data) === null || _a === void 0 ? void 0 : _a.media) === null || _b === void 0 ? void 0 : _b.mediaType) === "Audio") {
        setAspectRatio(16 / 9);
        return;
      }
      if (_aspect === 0) {
        setTimeout(waitForVideo, 100);
        return;
      }
      if (onVideoEnd) videoObj.bind("end", onVideoEnd);
      if (onVideoPlay) videoObj.bind("play", onVideoPlay);
      setAspectRatio(_aspect);
    };
    waitForVideo();
  }, [isWistiaReady]);
  return jsx("div", {
    className: generateConditionalClassName((_b = {
      Wistia: true
    }, _b["".concat(className)] = !!className, _b["is-wistia-ready"] = isWistiaReady, _b)),
    style: {
      "--Wistia--aspect-ratio": aspectRatio
    },
    children: jsx("div", {
      className: "Wistia--Responsive",
      children: jsx("div", {
        className: "Wistia--Embed wistia_embed wistia_async_".concat(id, " videoFoam=false").concat(autoPlay ? " autoPlay=true" : "autoPlay=false").concat(muted ? " muted=true" : "")
      })
    })
  });
};

export { BADGE_COLORS, BADGE_SIZES, Badge, DefaultPrefooter, ICON_BUTTON_SIZES, ICON_BUTTON_VARIANTS, ICON_TYPES, Icon, IconButton, PLAY_BUTTON_SIZES, PLAY_BUTTON_VARIANTS, PlayButton, RevealArea, SCRUBBER_THRESHOLDS, Scrubber, Search, SearchInput, SiteFooter, SiteNav, SubNav, TextLink, Wistia };
//# sourceMappingURL=index.esm.js.map
